import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  ArrayList3it5z8td81qkl as ArrayList,
  toList383f556t1dixk as toList,
  toMutableList20rdgwi7d3cwi as toMutableList,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  lazy2hsh8ze7j6ikd as lazy,
  toList3jhuyej2anx2q as toList_0,
  retainAll1hufpctl19y6u as retainAll,
  toSet2orjxp16sotqu as toSet,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  addAll1k27qatfgp3k5 as addAll,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toSet1glep2u1u9tcb as toSet_0,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  Duration5ynfiptaqcrg as Duration,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberToDouble210hrknaofnhf as numberToDouble,
  abs1kdzbjes1idip as abs,
  until1jbpn0z3f8lbg as until,
  listOfvhqybd2zx248 as listOf,
  get_sign1dnxi33u9vk0c as get_sign,
  isLetterOrDigit2kuxd9e198haf as isLetterOrDigit,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspendednggonvg9333x as returnIfSuspended,
  isNaNymqb93xtq8w8 as isNaN_0,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  indexOfa2zokh3tu4p6 as indexOf,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  Enum3alwj03lh1n41 as Enum,
  contains1tccixv8iwdcq as contains,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Duration__times_impl_sfuzvp1gzave8ckyu1a as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  replace3le3ie7l9k8aq as replace,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Companion_getInstancet6d3dkp9rzuf as Companion_getInstance_1,
  invoke2sf88d1xeuyqh as invoke,
  Signal3nnez3346azzf as Signal,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope1245ljoj2flcu as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance2expa55gr45sc as Key_instance,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout2wixyx2dhn9kz as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readBitmapdk80pcjw6p8f as readBitmap,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_2,
  _RGBA___get_premultipliedFast__impl__qiau4g35hwdu9bo5950 as _RGBA___get_premultipliedFast__impl__qiau4g,
  get_lazyBitmap3pyj425xl7cp4 as get_lazyBitmap,
  RGBA__times_impl_wehs9n2bi9iz06j1oam as RGBA__times_impl_wehs9n,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_3,
  Font2bg7nte760csr as Font,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  MaterialColors_getInstance39ky4hjexuaug as MaterialColors_getInstance,
  RichTextData1m4oei1jdcuz5 as RichTextData,
  RGBA__withAf_impl_dpdu32g4ua5xko755s as RGBA__withAf_impl_dpdu32,
  _RGBA___get_ad__impl__pt5rdj2rhup0gteq97n as _RGBA___get_ad__impl__pt5rdj,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance1905h5dvjxi3r as EmptyShape_instance,
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  readFont34z4s2654u5hd as readFont,
  HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j as VerticalAlign__getOffsetY_impl_iso0y6,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  BitmapFont35unsvaxq1brd as BitmapFont,
  getTextBoundsWithGlyphsa2ggkffutq4d as getTextBoundsWithGlyphs,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke_0,
  LineInfo27uw564y6w2d2 as LineInfo,
  _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk as _HorizontalAlign___get_ratio__impl__x9wlea,
  _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance2w9pdpq8h2ue0 as Companion_getInstance_4,
  NativeImage33w1i7ec8zfym as NativeImage,
  drawRichTextyqpa5ren8u0j as drawRichText,
  placem8wpiy4fm4tw as place,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqtysv8goadjy9q as _RGBA___get_rgb__impl__tijaqt,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5 as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3gshkh79a96f7 as Companion_instance_0,
  Companion_instance293l0r179rei7 as Companion_instance_1,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_5,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  FastDuration3d3pupg2e5ora as FastDuration,
  FastDuration__times_impl_h6amcp3u6kv4tju4mnx as FastDuration__times_impl_h6amcp,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7_0,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  _FastDuration___get_fastSeconds__impl__amo4s31n2ucdhlz8ys6 as _FastDuration___get_fastSeconds__impl__amo4s3,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  get_slowaqovrrnrezzv as get_slow,
  get_fast37cu8s8qwnuyi as get_fast,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  FastDuration__div_impl_rlslck3eqcfgtjve915 as FastDuration__div_impl_rlslck,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2moqkr2wlhp55 as FastDuration__div_impl_rlslck_0,
  toDuration15w5sljvx2ut2 as toDuration_0,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injectorznx5rgygah7n as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance1dp345vz250gb as Companion_getInstance_6,
  DefaultViewport_getInstance3ta8638tkh0q1 as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2edcjnp9auwx5 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1jsrcs9uzp4z9 as KorgeReload_getInstance,
  configureLoggerFromProperties2zy8apzr93pqp as configureLoggerFromProperties,
  CoroutineKey_getInstance2jikmq30sknr8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance104tc4m897tyy as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstance27oonvh9zpi1o as Type_START_getInstance,
  Status_ADD_getInstance22apyg5ct4px7 as Status_ADD_getInstance,
  Type_END_getInstance3ekhp9k4xqwsb as Type_END_getInstance,
  Status_REMOVE_getInstance19drpw6lfvon8 as Status_REMOVE_getInstance,
  Type_MOVE_getInstanceavavmobr5nzz as Type_MOVE_getInstance,
  Status_KEEP_getInstance3tj4183qdgyi5 as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2pxjdxrpl68c5 as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance1oyczma3u1sfi as Type_DRAG_getInstance,
  Type_UP_getInstance1azeslmnft6l5 as Type_UP_getInstance,
  Type_DOWN_getInstance1zas01g4tazis as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstancekjblelnta22u as Companion_getInstance_7,
  Companion_getInstance1wltq3fgn1avz as Companion_getInstance_8,
  Companion_getInstance2ckr5i14ndxro as Companion_getInstance_9,
  Companion_getInstance18y91gyxi2z7 as Companion_getInstance_10,
  Companion_instance3i2v9jzzqvdkl as Companion_instance_2,
  Companion_instance2ovjg7lp6gfg7 as Companion_instance_3,
  Companion_instancef7estul0zruo as Companion_instance_4,
  Companion_instance99w5lpdgjzr4 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance6ryfwvwg9trm as Companion_getInstance_11,
  Companion_getInstanceok0yphc67vv6 as Companion_getInstance_12,
  Companion_instancekcgdgz2aik3h as Companion_instance_6,
  Companion_instance12t49ingjwxzt as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance7uo85wjiqj61 as Companion_instance_8,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Type_TYPE_getInstance3kl3gtiytkq1p as Type_TYPE_getInstance,
  Type_DOWN_getInstance3w3upujzs6x5 as Type_DOWN_getInstance_0,
  Type_UP_getInstance2onpl7vaj0n6f as Type_UP_getInstance_0,
  Cursor_DEFAULT_getInstancemdqrzfwu4c9e as Cursor_DEFAULT_getInstance,
  Companion_getInstance1ifu77pbb1si2 as Companion_getInstance_13,
  drawText2ld6eqw3mc9xd as drawText,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  SDFShaders_getInstance2aqc6fv2u457r as SDFShaders_getInstance,
  If1av5krmfyt44s as If,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  TextClipboardDatafimoftc14pmm as TextClipboardData,
  Key_X_getInstance2ymba0j0rmblp as Key_X_getInstance,
  Key_BACKSPACE_getInstance1qsaehdyc2n7u as Key_BACKSPACE_getInstance,
  SoftKeyboardConfig3ue4h4egpkqhq as SoftKeyboardConfig,
  Companion_getInstanceae40js4gnuwg as Companion_getInstance_14,
  Cursor_TEXT_getInstancebh4jd1821ndb as Cursor_TEXT_getInstance,
  ISoftKeyboardConfige7b4czi6ukd7 as ISoftKeyboardConfig,
  Companion_instanceyamrbth4pjfq as Companion_instance_9,
  _interpolateColor3ps0kri0tazz4 as _interpolateColor,
  Cursor_HAND_getInstance18p4ksi2yuad6 as Cursor_HAND_getInstance,
  Key_SPACE_getInstance3ccpin6uc1wp0 as Key_SPACE_getInstance,
  Companion_getInstance2y4l90zc9q53m as Companion_getInstance_15,
  Key_TAB_getInstancerm3v8lzruhq1 as Key_TAB_getInstance,
  _interpolated0idy8l9id9j as _interpolate,
  V2Callback2d6dtckx13wqz as V2Callback,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance23l94gq35u9ye as Companion_getInstance_16,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance2c14wyrj73xek as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_17,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont2i7i2ml66o1iy as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance20smmrbslhgku as Key_F12_getInstance,
  Key_F7_getInstance1fxfgbmldwoq6 as Key_F7_getInstance,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  DefaultShaders_getInstance2nkm3g7twu3qg as DefaultShaders_getInstance,
  VertexShader26kcg39ndf3s1 as VertexShader,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  drawfyi5eaogony1 as draw,
  Texture2obedkmljq67n as Texture_0,
  Companion_getInstance2cx7brx0y6bm1 as Companion_getInstance_18,
  Companion_getInstance3dym1csqm206y as Companion_getInstance_19,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus,
  _AGColorMask___init__impl__j38ai819ejt5rq8iy6o as _AGColorMask___init__impl__j38ai8,
  Companion_getInstancei2plsq4vst79 as Companion_getInstance_20,
  AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4 as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3 as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance203qp9xyfv543 as Companion_getInstance_21,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42 as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance14dcva8uz4sb6 as Companion_getInstance_22,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0 as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai828hvpfxybxjk7 as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstance29a9zmyrrw3c9 as Companion_getInstance_23,
  AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891w3d9dwll45l9u7 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2 as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082fge542b8j3bn5 as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufx32vlakxm4newn as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5urey2md6modztx as AGCullFace__hashCode_impl_t4e5ur,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw_0,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance321ftm11bbyai as VarType_Float2_getInstance,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance1fp6gxp2vmo7y as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstancewn61okav7bh4 as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  Program1hnygp9hph4ry as Program,
  Companion_instance31en7fj48z7ti as Companion_instance_10,
  Companion_getInstance31h96uhdj5cc as Companion_getInstance_24,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance23o88a0u6ly94 as Companion_getInstance_25,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_26,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_27,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_28,
  Companion_getInstance3lu3946d91kk8 as Companion_getInstance_29,
  Vector2F2yb91r49vy4m7 as Vector2F,
  timesatqrmkwmiu2z as times,
  Marginzmgz0t8x8vn as Margin,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Companion_getInstance3la8ioxhl91va as Companion_getInstance_30,
  RectCorners2yrtl8r42p5bs as RectCorners,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_31,
  Scale2cm697xlulcp5 as Scale,
  Companion_getInstance2yu48324co92b as Companion_getInstance_32,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_33,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_34,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x_0,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_35,
  BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl as BoundsBuilder__plus_impl_cz7f7x_1,
  _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa as _BoundsBuilder___get_xmax__impl__gsz0km,
  _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r as _BoundsBuilder___get_ymax__impl__oia4uz,
  _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5 as _BoundsBuilder___get_ymin__impl__5n2e8j,
  MarginInt3jiec8xsxkfd as MarginInt,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_36,
  convertRange1a6ancvyn151r as convertRange,
  clamp011ml7wx1d2b7sp as clamp01,
  toRatio1hooqit5gulhr as toRatio,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_37,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clamp31lhm66c28ic8 as clamp,
  clampdicp8njiht45 as clamp_0,
  clamp1qclpmpfxm7xb as clamp_1,
  toLongRound7crzegvo2qbo as toLongRound,
  _Ratio___get_value__impl__57cli6w1n0arietzij as _Ratio___get_value__impl__57cli6,
  toIntCeil3h286vm49zgwd as toIntCeil,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange_0,
  umod164hvijxhfi8p as umod,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_EASElq2v0gsk9fz7 as get_EASE,
  get_immutablepxpdoj6e54ll as get_immutable,
  Bezier1nrnsph9esuxa as Bezier,
  get_EASE_IN3dgilxucimnao as get_EASE_IN,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  HitTestDirection_ANY_getInstance1hlnrhgqmsigf as HitTestDirection_ANY_getInstance,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838 as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance2mlqkio15xcm4 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_38,
  cancel1n0qjc93h2v6w as cancel_0,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  Closeable2m9yv0b0gma2l as Closeable,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1 as _Frequency___get_hertz__impl__9m7k6x,
  _Frequency___get_fastDuration__impl__87web01nqjqeilxp91g as _Frequency___get_fastDuration__impl__87web0,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance20wy3vp7551rj as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ibbocika451b as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  get_length100spxmnpj7nb as get_length,
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance2nobhthyyb9yj as Companion_instance_13,
  Dyn__set_impl_2ozvx82bmztjcahblz8 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Property1m5vulkepgwzd as Property,
  Mixin3lmkm5hum2vdj as Mixin,
  getExtra307y0o9pd6mp3 as getExtra,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  TGenDeque2zx9g0ftfbw19 as TGenDeque,
  Pool1zbsw0zhvh8ca as Pool,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  HistoryStack2mrikkhc0etuj as HistoryStack,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  IntArrayList3liuagbdnwmna as IntArrayList,
  getCyclicOrNull12fem85bj0m7u as getCyclicOrNull,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-memory-root-korlibs-memory.mjs';
import { atomic$int$11d5swdyn6j0pu as atomic$int$1 } from './kotlinx-atomicfu.mjs';
import {
  withoutRangetvtevgxw4fe7 as withoutRange,
  withoutIndex1982826lx7knb as withoutIndex,
  withInsertion32qy0wb7w2f46 as withInsertion,
} from './korlibs-string-root-korlibs-string.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.j9g_1 = Companion_getInstance_0().mw('Korge');
    this.k9g_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  l9g(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  qd(p1, $completion) {
    return this.l9g(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.x9e_1 = this$0;
    this.y9e_1 = $entry;
  }
  w1n($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  qd(p1, $completion) {
    return this.w1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_39();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_39().k9g_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().g87_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().s84_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_40().h3p() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().t3y_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().s3y_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.z9e_1 = args;
    this.a9f_1 = imageFormats;
    this.b9f_1 = gameWindow;
    this.c9f_1 = mainSceneClass;
    this.d9f_1 = timeProvider;
    this.e9f_1 = injector;
    this.f9f_1 = configInjector;
    this.g9f_1 = debug;
    this.h9f_1 = trace;
    this.i9f_1 = context;
    this.j9f_1 = fullscreen;
    this.k9f_1 = blocking;
    this.l9f_1 = gameId;
    this.m9f_1 = settingsFolder;
    this.n9f_1 = batchMaxQuads;
    this.o9f_1 = windowSize;
    this.p9f_1 = virtualSize;
    this.q9f_1 = displayMode;
    this.r9f_1 = title;
    this.s9f_1 = backgroundColor;
    this.t9f_1 = quality;
    this.u9f_1 = icon;
    this.v9f_1 = multithreaded;
    this.w9f_1 = forceRenderEveryFrame;
    this.x9f_1 = windowCreationConfig;
    this.y9f_1 = main;
    this.z9f_1 = debugAg;
    this.a9g_1 = debugFontExtraScale;
    this.b9g_1 = debugFontColor;
    this.c9g_1 = stageBuilder;
    this.d9g_1 = targetFps;
    this.e9g_1 = preferSyncIo;
    this.f9g_1 = debugCoroutines;
    this.g9g_1 = unit;
  }
  g9j(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this, entry), $completion);
  }
  h9j(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  h9g(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.z9e_1 : args;
    imageFormats = imageFormats === VOID ? this.a9f_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.b9f_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.c9f_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.d9f_1 : timeProvider;
    injector = injector === VOID ? this.e9f_1 : injector;
    configInjector = configInjector === VOID ? this.f9f_1 : configInjector;
    debug = debug === VOID ? this.g9f_1 : debug;
    trace = trace === VOID ? this.h9f_1 : trace;
    context = context === VOID ? this.i9f_1 : context;
    fullscreen = fullscreen === VOID ? this.j9f_1 : fullscreen;
    blocking = blocking === VOID ? this.k9f_1 : blocking;
    gameId = gameId === VOID ? this.l9f_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.m9f_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.n9f_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.o9f_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.p9f_1 : virtualSize;
    displayMode = displayMode === VOID ? this.q9f_1 : displayMode;
    title = title === VOID ? this.r9f_1 : title;
    backgroundColor = backgroundColor === VOID ? this.s9f_1 : backgroundColor;
    quality = quality === VOID ? this.t9f_1 : quality;
    icon = icon === VOID ? this.u9f_1 : icon;
    multithreaded = multithreaded === VOID ? this.v9f_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.w9f_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.x9f_1 : windowCreationConfig;
    main = main === VOID ? this.y9f_1 : main;
    debugAg = debugAg === VOID ? this.z9f_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.a9g_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.b9g_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.c9g_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.d9g_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.e9g_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.f9g_1 : debugCoroutines;
    unit = unit === VOID ? this.g9g_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.h9j(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.h9j;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.z9e_1);
    var tmp_0 = this.a9f_1.toString();
    var tmp_1 = toString_0(this.b9f_1);
    var tmp_2 = toString_0(this.c9f_1);
    var tmp_3 = toString(this.d9f_1);
    var tmp_4 = this.e9f_1.toString();
    var tmp_5 = toString(this.f9f_1);
    var tmp_6 = toString_0(this.i9f_1);
    var tmp_7 = this.o9f_1.toString();
    var tmp_8 = this.p9f_1.toString();
    var tmp_9 = this.q9f_1.toString();
    var tmp_10 = this.s9f_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.g9f_1 + ', trace=' + this.h9f_1 + ', context=' + tmp_6 + ', fullscreen=' + this.j9f_1 + ', blocking=' + this.k9f_1 + ', gameId=' + this.l9f_1 + ', settingsFolder=' + this.m9f_1 + ', batchMaxQuads=' + this.n9f_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.r9f_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.t9f_1) + ', icon=' + this.u9f_1 + ', multithreaded=' + this.v9f_1 + ', forceRenderEveryFrame=' + this.w9f_1 + ', windowCreationConfig=' + this.x9f_1.toString() + ', main=' + toString(this.y9f_1) + ', debugAg=' + this.z9f_1 + ', debugFontExtraScale=' + this.a9g_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.b9g_1) + ', stageBuilder=' + toString(this.c9g_1) + ', targetFps=' + this.d9g_1 + ', preferSyncIo=' + this.e9g_1 + ', debugCoroutines=' + this.f9g_1 + ', unit=' + this.g9g_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.z9e_1);
    result = imul(result, 31) + hashCode(this.a9f_1) | 0;
    result = imul(result, 31) + (this.b9f_1 == null ? 0 : hashCode(this.b9f_1)) | 0;
    result = imul(result, 31) + (this.c9f_1 == null ? 0 : this.c9f_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.d9f_1) | 0;
    result = imul(result, 31) + hashCode(this.e9f_1) | 0;
    result = imul(result, 31) + hashCode(this.f9f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g9f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h9f_1) | 0;
    result = imul(result, 31) + (this.i9f_1 == null ? 0 : hashCode(this.i9f_1)) | 0;
    result = imul(result, 31) + (this.j9f_1 == null ? 0 : getBooleanHashCode(this.j9f_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k9f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l9f_1) | 0;
    result = imul(result, 31) + (this.m9f_1 == null ? 0 : getStringHashCode(this.m9f_1)) | 0;
    result = imul(result, 31) + this.n9f_1 | 0;
    result = imul(result, 31) + this.o9f_1.hashCode() | 0;
    result = imul(result, 31) + this.p9f_1.hashCode() | 0;
    result = imul(result, 31) + this.q9f_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.r9f_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.s9f_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.s9f_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.t9f_1.hashCode() | 0;
    result = imul(result, 31) + (this.u9f_1 == null ? 0 : getStringHashCode(this.u9f_1)) | 0;
    result = imul(result, 31) + (this.v9f_1 == null ? 0 : getBooleanHashCode(this.v9f_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w9f_1) | 0;
    result = imul(result, 31) + this.x9f_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.y9f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z9f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a9g_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.b9g_1) | 0;
    result = imul(result, 31) + hashCode(this.c9g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d9g_1) | 0;
    result = imul(result, 31) + (this.e9g_1 == null ? 0 : getBooleanHashCode(this.e9g_1)) | 0;
    result = imul(result, 31) + (this.f9g_1 == null ? 0 : getBooleanHashCode(this.f9g_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.z9e_1, tmp0_other_with_cast.z9e_1))
      return false;
    if (!equals(this.a9f_1, tmp0_other_with_cast.a9f_1))
      return false;
    if (!equals(this.b9f_1, tmp0_other_with_cast.b9f_1))
      return false;
    if (!equals(this.c9f_1, tmp0_other_with_cast.c9f_1))
      return false;
    if (!equals(this.d9f_1, tmp0_other_with_cast.d9f_1))
      return false;
    if (!equals(this.e9f_1, tmp0_other_with_cast.e9f_1))
      return false;
    if (!equals(this.f9f_1, tmp0_other_with_cast.f9f_1))
      return false;
    if (!(this.g9f_1 === tmp0_other_with_cast.g9f_1))
      return false;
    if (!(this.h9f_1 === tmp0_other_with_cast.h9f_1))
      return false;
    if (!equals(this.i9f_1, tmp0_other_with_cast.i9f_1))
      return false;
    if (!(this.j9f_1 == tmp0_other_with_cast.j9f_1))
      return false;
    if (!(this.k9f_1 === tmp0_other_with_cast.k9f_1))
      return false;
    if (!(this.l9f_1 === tmp0_other_with_cast.l9f_1))
      return false;
    if (!(this.m9f_1 == tmp0_other_with_cast.m9f_1))
      return false;
    if (!(this.n9f_1 === tmp0_other_with_cast.n9f_1))
      return false;
    if (!this.o9f_1.equals(tmp0_other_with_cast.o9f_1))
      return false;
    if (!this.p9f_1.equals(tmp0_other_with_cast.p9f_1))
      return false;
    if (!this.q9f_1.equals(tmp0_other_with_cast.q9f_1))
      return false;
    if (!(this.r9f_1 === tmp0_other_with_cast.r9f_1))
      return false;
    var tmp = this.s9f_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.s9f_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.t9f_1.equals(tmp0_other_with_cast.t9f_1))
      return false;
    if (!(this.u9f_1 == tmp0_other_with_cast.u9f_1))
      return false;
    if (!(this.v9f_1 == tmp0_other_with_cast.v9f_1))
      return false;
    if (!(this.w9f_1 === tmp0_other_with_cast.w9f_1))
      return false;
    if (!this.x9f_1.equals(tmp0_other_with_cast.x9f_1))
      return false;
    if (!equals(this.y9f_1, tmp0_other_with_cast.y9f_1))
      return false;
    if (!(this.z9f_1 === tmp0_other_with_cast.z9f_1))
      return false;
    if (!equals(this.a9g_1, tmp0_other_with_cast.a9g_1))
      return false;
    if (!(this.b9g_1 === tmp0_other_with_cast.b9g_1))
      return false;
    if (!equals(this.c9g_1, tmp0_other_with_cast.c9g_1))
      return false;
    if (!equals(this.d9g_1, tmp0_other_with_cast.d9g_1))
      return false;
    if (!(this.e9g_1 == tmp0_other_with_cast.e9g_1))
      return false;
    if (!(this.f9g_1 == tmp0_other_with_cast.f9g_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.c9j_1 = new KorgeDisplayMode(Companion_getInstance_25().v2f_1, Companion_getInstance_26().r24(), true);
    this.d9j_1 = new KorgeDisplayMode(Companion_getInstance_25().v2f_1, Companion_getInstance_26().r24(), false);
    this.e9j_1 = new KorgeDisplayMode(Companion_getInstance_25().v2f_1, Companion_getInstance_26().f24_1, false);
    this.f9j_1 = new KorgeDisplayMode(Companion_getInstance_25().x2f_1, Companion_getInstance_26().f24_1, false);
  }
  h3p() {
    return this.c9j_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_40();
    this.i9j_1 = scaleMode;
    this.j9j_1 = scaleAnchor;
    this.k9j_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.i9j_1.toString() + ', scaleAnchor=' + this.j9j_1.toString() + ', clipBorders=' + this.k9j_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.i9j_1);
    result = imul(result, 31) + this.j9j_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k9j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.i9j_1, tmp0_other_with_cast.i9j_1))
      return false;
    if (!this.j9j_1.equals(tmp0_other_with_cast.j9j_1))
      return false;
    if (!(this.k9j_1 === tmp0_other_with_cast.k9j_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.z9l_1 = $config;
    this.a9m_1 = $views;
    this.b9m_1 = $entry;
    this.c9m_1 = $gameWindow;
  }
  w1n($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
  }
  qd(p1, $completion) {
    return this.w1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.f9r_1 = $config;
    this.g9r_1 = $views;
    this.h9r_1 = $entry;
    this.i9r_1 = $gameWindow;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.j9r_1 = $realGameWindow;
    this.k9r_1 = $windowSize;
    this.l9r_1 = $config;
    this.m9r_1 = $iconPath;
    this.n9r_1 = $imageFormats;
    this.o9r_1 = $entry;
  }
  w9r($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$loop), $completion);
  }
  qd(p1, $completion) {
    return this.w9r(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.x9r_1 = $views;
  }
  pd($completion) {
    this.x9r_1.c6();
  }
}
class KorgeRunner {
  i9g(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, config), $completion);
  }
  s9r(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.s9j_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.t63(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.r9j_1;
    injector.t63(getKClass(AG), instance);
    injector.t63(getKClass(Resources), views.z9r());
    var tmp = getKClass(ResourcesRoot);
    injector.w63(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.t9j_1;
    injector.t63(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.v9j_1;
    injector.t63(getKClass(Stats), instance_1);
    injector.t63(getKClass(CoroutineContext), views.q9j_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.x63(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.t63(getKClass(TimeProvider), views.u9j_1);
    configInjector(injector);
    var input = views.t9j_1;
    var ag = views.r9j_1;
    var downPos = {_v: Companion_getInstance_28().g25_1};
    var upPos = {_v: Companion_getInstance_28().g25_1};
    var downTime = {_v: new DateTime(Companion_getInstance_5().j1u_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_5().j1u_1)};
    var upTime = Companion_getInstance_5().j1u_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.a9s(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_7().t68_1.slice();
    eventDispatcher.a67(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_8().d68_1.slice();
    eventDispatcher.a67(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_9().u69_1.slice();
    eventDispatcher.a67(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_10().b6a_1.slice();
    eventDispatcher.a67(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.o66(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.o66(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.o66(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.o66(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_11().w6a_1.slice();
    eventDispatcher.a67(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_12().b6d_1.slice();
    eventDispatcher.a67(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.o66(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.o66(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.z66(new ReshapeEvent(0, 0, views.b9s(), views.c9s()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.o66(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.q9k_1 = clearEachFrame;
    views.r9k_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.w9j_1.e8j(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  l9g(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  qd(p1, $completion) {
    return this.l9g(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  l9g(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  qd(p1, $completion) {
    return this.l9g(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.m9s_1 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    this.n9s_1 = 128.0;
    this.o9s_1 = get_EASE(Companion_getInstance_36());
    this.p9s_1 = true;
  }
}
class RootAnimationNode {
  constructor($outer) {
    this.k9t_1 = $outer;
    this.i9t_1 = null;
    this.j9t_1 = fastArrayListOf([]);
  }
  c2q() {
    this.i9t_1 = null;
  }
  l9t(dt) {
    var dt_0 = !(this.k9t_1.c9t_1 === 1.0) ? FastDuration__times_impl_h6amcp(dt, this.k9t_1.c9t_1) : dt;
    ensureInit(this.k9t_1);
    if (this.k9t_1.u9s_1) {
      var completedTime = get_fastSeconds(0);
      this.j9t_1.h3();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = this.k9t_1.b9t_1.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.animate.RootAnimationNode.update.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var index_0 = checkIndexOverflow(tmp1);
        var result = item.l9t(dt_0);
        if (FastDuration__compareTo_impl_4fhnj7(result, get_fastSeconds(0)) >= 0) {
          this.j9t_1.h(item);
        }
        var tmp;
        if (index_0 === 0) {
          tmp = result;
        } else {
          // Inline function 'kotlin.math.min' call
          var a = _FastDuration___get_fastMilliseconds__impl__pe68va(completedTime);
          var b = _FastDuration___get_fastMilliseconds__impl__pe68va(result);
          var tmp$ret$0 = Math.min(a, b);
          tmp = get_fastMilliseconds(tmp$ret$0);
        }
        completedTime = tmp;
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.j9t_1.g1()) {
        this.k9t_1.b9t_1.x2l(this.j9t_1);
      }
      this.j9t_1.h3();
      this.k9t_1.f9t_1 = true;
      return completedTime;
    }
    $l$loop: while (true) {
      if (this.i9t_1 == null) {
        var tmp_0 = this;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.k9t_1.b9t_1.g1()) {
          tmp_1 = this.k9t_1.b9t_1.nk();
        } else {
          tmp_1 = null;
        }
        tmp_0.i9t_1 = tmp_1;
        var tmp0_safe_receiver = this.i9t_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.c2q();
        }
        if (this.k9t_1.v9s_1) {
          var tmp1_safe_receiver = this.i9t_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            this.k9t_1.b9t_1.m2l(tmp1_safe_receiver);
          }
        }
      }
      if (!(this.i9t_1 == null)) {
        var node = ensureNotNull(this.i9t_1);
        var extraTime = node.l9t(dt_0);
        if (FastDuration__compareTo_impl_4fhnj7_0(extraTime, Companion_getInstance().lj_1) >= 0) {
          this.i9t_1 = null;
          dt_0 = extraTime;
        }
        if (FastDuration__compareTo_impl_4fhnj7_0(extraTime, Companion_getInstance().lj_1) > 0) {
          continue $l$loop;
        }
      }
      var tmp_2;
      var tmp_3;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.k9t_1.b9t_1.g1()) {
        tmp_3 = true;
      } else {
        tmp_3 = !(this.i9t_1 == null);
      }
      if (tmp_3) {
        tmp_2 = get_fastSeconds(-1);
      } else {
        tmp_2 = Companion_instance_1.s1u();
      }
      return tmp_2;
    }
  }
  toString() {
    return 'RootAnimationNode(' + toString(this.k9t_1) + ')';
  }
}
class TweenNode {
  constructor(vs, lazyVs, time, lazyTime, easing, name) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? get_fastMilliseconds_0(1000) : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    name = name === VOID ? null : name;
    this.d9s_1 = vs;
    this.e9s_1 = lazyVs;
    this.f9s_1 = time;
    this.g9s_1 = lazyTime;
    this.h9s_1 = easing;
    this.i9s_1 = name;
    var tmp = this;
    tmp.j9s_1 = lazy(Animator$TweenNode$computedVs$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.k9s_1 = lazy(Animator$TweenNode$totalTime$delegate$lambda(this));
    this.l9s_1 = Companion_instance_1.s1u();
  }
  m9t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j9s_1;
    computedVs$factory();
    return this_0.r1();
  }
  toString() {
    return 'TweenNode(totalTime=' + FastDuration__toString_impl_c9xohb(_get_totalTime__xgts5c(this)) + ', name=' + this.i9s_1 + ', ' + toString(toList_0(this.m9t())) + ')';
  }
  c2q() {
    this.l9s_1 = Companion_instance_1.s1u();
  }
  l9t(dt) {
    if (equals(this.l9s_1, Companion_instance_1.s1u())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.m9t();
      var n = 0;
      while (n < this_0.e1()) {
        // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.d1(_unary__edvuaz).s35();
      }
    }
    this.l9s_1 = FastDuration__plus_impl_q1enab(this.l9s_1, dt);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.m9t();
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_1.d1(_unary__edvuaz_0);
      var ratio = equals(_get_totalTime__xgts5c(this), Companion_instance_1.s1u()) ? 1.0 : convertRange(_FastDuration___get_fastSeconds__impl__amo4s3(this.l9s_1), _FastDuration___get_fastSeconds__impl__amo4s3(it.n8e_1), _FastDuration___get_fastSeconds__impl__amo4s3(it.t8e(_get_totalTime__xgts5c(this))), 0.0, 1.0);
      if (ratio >= 0.0) {
        it.u8e(toRatio(this.h9s_1.ex(clamp01(ratio))));
      }
    }
    return FastDuration__minus_impl_evs237(this.l9s_1, _get_totalTime__xgts5c(this));
  }
}
class BlockNode {
  constructor(name, callback) {
    name = name === VOID ? null : name;
    this.n9t_1 = name;
    this.o9t_1 = callback;
    this.p9t_1 = false;
  }
  toString() {
    return 'BlockNode(name=' + this.n9t_1 + ')';
  }
  c2q() {
    this.p9t_1 = false;
  }
  l9t(dt) {
    this.q9t();
    return dt;
  }
  q9t() {
    if (this.p9t_1)
      return Unit_instance;
    this.p9t_1 = true;
    this.o9t_1();
  }
}
class Animator {
  constructor(root, fastDefaultTime, defaultSpeed, defaultEasing, parallel, looped, parent, lazyInit, level, startImmediately) {
    Companion_getInstance_41();
    parallel = parallel === VOID ? false : parallel;
    looped = looped === VOID ? false : looped;
    lazyInit = lazyInit === VOID ? null : lazyInit;
    this.q9s_1 = root;
    this.r9s_1 = fastDefaultTime;
    this.s9s_1 = defaultSpeed;
    this.t9s_1 = defaultEasing;
    this.u9s_1 = parallel;
    this.v9s_1 = looped;
    this.w9s_1 = parent;
    this.x9s_1 = lazyInit;
    this.y9s_1 = level;
    this.z9s_1 = startImmediately;
    this.a9t_1 = new Signal();
    this.b9t_1 = TGenDeque.l2l();
    this.c9t_1 = 1.0;
    this.d9t_1 = null;
    this.e9t_1 = false;
    this.f9t_1 = false;
    this.g9t_1 = new RootAnimationNode(this);
  }
  t9t() {
    return get_slow(this.r9s_1);
  }
  h9t() {
    var tmp0_safe_receiver = this.w9s_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h9t();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  u9t(props) {
    var _iterator__ex2g4s = this.b9t_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var node = _iterator__ex2g4s.c1();
      if (node instanceof TweenNode) {
        var tmp = node.m9t();
        retainAll(tmp, Animator$removeProps$lambda(props));
      }
    }
  }
  v9t(node) {
    this.b9t_1.u2l(node);
    ensure(this);
  }
  c6() {
    this.s9t();
  }
  wr(e) {
    this.s9t();
  }
  s9t() {
    this.g9t_1.c2q();
    this.b9t_1.h3();
    var tmp0_safe_receiver = this.h9t().d9t_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel_0(tmp0_safe_receiver);
    }
    this.h9t().d9t_1 = null;
    this.f9t_1 = false;
    invoke(this.a9t_1);
    return this;
  }
  w9t(vs, lazyVs, time, lazyTime, easing, name, replace) {
    if (replace && this.u9s_1) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(vs.length);
      var inductionVariable = 0;
      var last = vs.length;
      while (inductionVariable < last) {
        var item = vs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.Animator.__tween.<anonymous>' call
        var tmp$ret$0 = item.i8e_1;
        destination.h(tmp$ret$0);
      }
      this.u9t(toSet(destination));
    }
    this.v9t(new TweenNode(vs.slice(), lazyVs, time, lazyTime, easing, name));
  }
  x9t(vs, lazyVs, time, lazyTime, easing, name, replace, $super) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? this.r9s_1 : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    easing = easing === VOID ? this.t9s_1 : easing;
    replace = replace === VOID ? true : replace;
    var tmp;
    if ($super === VOID) {
      this.w9t(vs, lazyVs, time, lazyTime, easing, name, replace);
      tmp = Unit_instance;
    } else {
      tmp = $super.w9t.call(this, vs, lazyVs, new FastDuration(time), lazyTime, easing, name, replace);
    }
    return tmp;
  }
}
class ViewStageComponent {
  constructor(view) {
    this.y9t_1 = view;
    this.z9t_1 = new Signal();
    this.a9u_1 = new Signal();
  }
}
class KeysEvents$down$slambda {
  constructor($keys, $callback) {
    this.c9u_1 = $keys;
    this.d9u_1 = $callback;
  }
  u9u(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, it), $completion);
  }
  qd(p1, $completion) {
    return this.u9u(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$down$slambda_0 {
  constructor($callback) {
    this.e9u_1 = $callback;
  }
  u9u(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, it), $completion);
  }
  qd(p1, $completion) {
    return this.u9u(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$up$slambda {
  constructor($keys, $callback) {
    this.f9u_1 = $keys;
    this.g9u_1 = $callback;
  }
  u9u(e, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, e), $completion);
  }
  qd(p1, $completion) {
    return this.u9u(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$typed$slambda {
  constructor($callback) {
    this.h9u_1 = $callback;
  }
  u9u(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, it), $completion);
  }
  qd(p1, $completion) {
    return this.u9u(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.o9u_1 = this$0;
    this.p9u_1 = $event;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.q9u_1 = this$0;
    this.r9u_1 = $event;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.s9u_1 = this$0;
    this.t9u_1 = $event;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.i9u_1 = view;
    this.k9u_1 = new AsyncSignal();
    this.l9u_1 = new AsyncSignal();
    this.m9u_1 = new AsyncSignal();
    this.n9u_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.i9u_1.o66(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.i9u_1.o66(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.i9u_1.o66(tmp_1, KeysEvents$lambda_1(this));
  }
  v9u() {
    var tmp = this.j9u_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  w9u(keys, callback) {
    return this.k9u_1.l1w(KeysEvents$down$slambda_1(keys, callback));
  }
  x9u(callback) {
    return this.k9u_1.l1w(KeysEvents$down$slambda_2(callback));
  }
  y9u(keys, callback) {
    return this.w9u(toSet_0(keys), callback);
  }
  z9u(keys, callback) {
    return this.l9u_1.l1w(KeysEvents$up$slambda_0(keys, callback));
  }
  a9v(keys, callback) {
    return this.z9u(toSet_0(keys), callback);
  }
  b9v(callback) {
    return this.m9u_1.l1w(KeysEvents$typed$slambda_0(callback));
  }
  c6() {
    this.n9u_1.c6();
  }
}
class Companion_2 {
  y9w(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.t34_1) {
      this_0.t34_1 = true;
      // Inline function 'korlibs.korge.input.Companion.installDebugExtensionOnce.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = views.i9l_1;
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      this_1.h(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.b9x_1 = $outer;
    this.z9w_1 = new Mixin();
    this.a9x_1 = view;
    addUpdaterWithViews(this.a9x_1, MouseEvents$MouseEventsUpdate$lambda(this.b9x_1));
  }
  vx(value) {
    this.z9w_1.vx(value);
  }
  wx() {
    return this.z9w_1.wx();
  }
}
class MouseEvents {
  constructor(view) {
    this.i9v_1 = new Mixin();
    this.j9v_1 = view;
    this.j9v_1.f9x(true);
    this.l9v_1 = new Signal();
    this.m9v_1 = new Signal();
    this.n9v_1 = new Signal();
    this.o9v_1 = new Signal();
    this.p9v_1 = new Signal();
    this.q9v_1 = new Signal();
    this.r9v_1 = new Signal();
    this.s9v_1 = new Signal();
    this.t9v_1 = new Signal();
    this.u9v_1 = new Signal();
    this.v9v_1 = new Signal();
    this.w9v_1 = new Signal();
    this.x9v_1 = new Signal();
    this.y9v_1 = new Signal();
    this.z9v_1 = new Signal();
    this.a9w_1 = new Signal();
    this.b9w_1 = new Signal();
    this.c9w_1 = new Signal();
    this.d9w_1 = new Signal();
    this.e9w_1 = null;
    this.f9w_1 = false;
    this.g9w_1 = false;
    this.h9w_1 = false;
    this.i9w_1 = PerformanceCounter_getInstance().o64();
    this.j9w_1 = PerformanceCounter_getInstance().o64();
    this.k9w_1 = Vector2D.y27();
    this.l9w_1 = Vector2D.y27();
    this.m9w_1 = Vector2D.y27();
    this.n9w_1 = Vector2D.y27();
    this.o9w_1 = Vector2D.y27();
    this.p9w_1 = 0;
    this.q9w_1 = false;
    this.r9w_1 = null;
    this.s9w_1 = new MouseEvent();
    this.t9w_1 = false;
    this.u9w_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_7().t68_1.slice();
    tmp.v9w_1 = this.j9v_1.a67(tmp_0, MouseEvents$closeable$lambda(this));
    this.w9w_1 = new MouseEventsUpdate(this, this.j9v_1);
  }
  d9x() {
    var tmp = this.k9v_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  g9x() {
    return this.d9x().q9j_1;
  }
  h9x() {
    return this.j9v_1.i9x(this.o9w_1);
  }
  j9x() {
    var tmp0_safe_receiver = this.r9w_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.l67();
    }
  }
  e9x() {
    var tmp0_safe_receiver = this.e9w_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.j9v_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  k9x() {
    return !(this.d9x().t9j_1.s83_1 === 0);
  }
  toString() {
    return this.s9w_1.toString();
  }
  x9w(views, dt) {
    if (!this.j9v_1.c9x())
      return Unit_instance;
    this.k9v_1 = views;
    Companion_instance_17.y9w(views);
    this.e9w_1 = mouseHitTest(Companion_instance_17, views);
    var over = this.e9x();
    var inside = views.t9j_1.u83_1;
    if (over) {
      set_mouseHitResultUsed(views.t9j_1, this.j9v_1);
    }
    var overChanged = !(this.f9w_1 === over);
    var insideChanged = !(this.g9w_1 === inside);
    var pressingChanged = !(this.k9x() === this.h9w_1);
    this.o9w_1 = views.t9j_1.i84();
    if (!overChanged && over && !this.o9w_1.equals(this.n9w_1)) {
      this.x9v_1.z1v(this);
    }
    if (!overChanged && !over && !this.o9w_1.equals(this.n9w_1)) {
      this.z9v_1.z1v(this);
    }
    if (!this.o9w_1.equals(this.n9w_1)) {
      this.y9v_1.z1v(this);
    }
    if (overChanged && over) {
      this.n9v_1.z1v(this);
    }
    if (overChanged && !over) {
      this.o9v_1.z1v(this);
    }
    if (pressingChanged && this.k9x()) {
      this.m9w_1 = this.o9w_1;
      if (over) {
        this.p9v_1.z1v(this);
      }
      if (!over) {
        this.q9v_1.z1v(this);
      }
    }
    if (overChanged && this.k9x()) {
      this.r9v_1.z1v(this);
    }
    if (pressingChanged && !this.k9x()) {
      var tmp = this.u9w_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.p9w_1 > 0;
    if (insideChanged && !inside) {
      this.z9v_1.z1v(this);
      this.o9v_1.z1v(this);
      this.u9v_1.z1v(this);
      this.v9v_1.z1v(this);
      this.a9w_1.z1v(this);
    }
    this.f9w_1 = over;
    this.g9w_1 = inside;
    this.h9w_1 = this.k9x();
    this.n9w_1 = this.o9w_1;
    this.p9w_1 = 0;
  }
  c6() {
    this.v9w_1.c6();
  }
  vx(value) {
    this.i9v_1.vx(value);
  }
  wx() {
    return this.i9v_1.wx();
  }
}
class Info {
  constructor(index, id, local, startLocal, startTime, global, startGlobal, time) {
    index = index === VOID ? -1 : index;
    id = id === VOID ? 0 : id;
    local = local === VOID ? Vector2D.y27() : local;
    startLocal = startLocal === VOID ? Vector2D.y27() : startLocal;
    startTime = startTime === VOID ? Companion_getInstance_5().j1u_1 : startTime;
    global = global === VOID ? Vector2D.y27() : global;
    startGlobal = startGlobal === VOID ? Vector2D.y27() : startGlobal;
    time = time === VOID ? Companion_getInstance_5().j1u_1 : time;
    this.l9x_1 = new Mixin();
    this.m9x_1 = index;
    this.n9x_1 = id;
    this.o9x_1 = local;
    this.p9x_1 = startLocal;
    this.q9x_1 = startTime;
    this.r9x_1 = global;
    this.s9x_1 = startGlobal;
    this.t9x_1 = time;
  }
  v9x() {
    return DateTime__minus_impl_10njw8(this.t9x_1, this.q9x_1);
  }
  d9x() {
    var tmp = this.u9x_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  w9x() {
    return this.o9x_1.e25_1;
  }
  x9x() {
    return this.o9x_1.f25_1;
  }
  toString() {
    return 'Touch[' + this.n9x_1 + '](' + numberToInt(this.w9x()) + ', ' + numberToInt(this.x9x()) + ')';
  }
  hashCode() {
    var result = this.m9x_1;
    result = imul(result, 31) + this.n9x_1 | 0;
    result = imul(result, 31) + this.o9x_1.hashCode() | 0;
    result = imul(result, 31) + this.p9x_1.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.q9x_1) | 0;
    result = imul(result, 31) + this.r9x_1.hashCode() | 0;
    result = imul(result, 31) + this.s9x_1.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.t9x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    if (!(this.m9x_1 === tmp0_other_with_cast.m9x_1))
      return false;
    if (!(this.n9x_1 === tmp0_other_with_cast.n9x_1))
      return false;
    if (!this.o9x_1.equals(tmp0_other_with_cast.o9x_1))
      return false;
    if (!this.p9x_1.equals(tmp0_other_with_cast.p9x_1))
      return false;
    if (!equals(this.q9x_1, tmp0_other_with_cast.q9x_1))
      return false;
    if (!this.r9x_1.equals(tmp0_other_with_cast.r9x_1))
      return false;
    if (!this.s9x_1.equals(tmp0_other_with_cast.s9x_1))
      return false;
    if (!equals(this.t9x_1, tmp0_other_with_cast.t9x_1))
      return false;
    return true;
  }
  vx(value) {
    this.l9x_1.vx(value);
  }
  wx() {
    return this.l9x_1.wx();
  }
}
class TouchEvents {
  constructor(view) {
    this.y9x_1 = view;
    this.z9x_1 = new Signal();
    this.a9y_1 = new Signal();
    this.b9y_1 = new Signal();
    this.c9y_1 = new Signal();
    this.d9y_1 = new Signal();
    this.e9y_1 = new Signal();
    this.f9y_1 = new Signal();
    var tmp = this;
    tmp.g9y_1 = Pool.k2p(VOID, TouchEvents$infoPool$lambda);
    this.h9y_1 = FastIntMap();
    this.i9y_1 = FastArrayList.ny();
    var tmp_0 = Companion_getInstance_11().w6a_1.slice();
    this.y9x_1.a67(tmp_0, TouchEvents$lambda(this));
  }
  j9y(_this__u8e3s4, touch) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.TouchEvents.copyFrom.<anonymous>' call
    _this__u8e3s4.n9x_1 = touch.n6a_1;
    _this__u8e3s4.r9x_1 = touch.o6a_1;
    _this__u8e3s4.o9x_1 = this.y9x_1.i9x(touch.o6a_1);
    return _this__u8e3s4;
  }
  k9y(_this__u8e3s4) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.TouchEvents.start.<anonymous>' call
    _this__u8e3s4.p9x_1 = _this__u8e3s4.o9x_1;
    _this__u8e3s4.s9x_1 = _this__u8e3s4.r9x_1;
    return _this__u8e3s4;
  }
  l9y(views, globalXY) {
    var ev = new TouchEvent(Type_START_getInstance());
    ev.m6b(Type_START_getInstance());
    ev.r6b(0, globalXY, Status_ADD_getInstance());
    ev.n6b();
    onTouchEvent(this, views, ev);
    ev.m6b(Type_END_getInstance());
    ev.r6b(0, globalXY, Status_REMOVE_getInstance());
    ev.n6b();
    onTouchEvent(this, views, ev);
    get_mouse(this.y9x_1).m9v_1.z1v(get_mouse(this.y9x_1));
  }
}
class SingleTouchHandler {
  constructor() {
    this.m9y_1 = new Signal();
    this.n9y_1 = new Signal();
    this.o9y_1 = new Signal();
    this.p9y_1 = new Signal();
    this.q9y_1 = new Signal();
    this.r9y_1 = new Signal();
    this.s9y_1 = new Signal();
    this.t9y_1 = new Signal();
  }
}
class singleTouch$SingleTouchInfo {
  constructor(handler, startedInside) {
    handler = handler === VOID ? new SingleTouchHandler() : handler;
    startedInside = startedInside === VOID ? false : startedInside;
    this.u9y_1 = handler;
    this.v9y_1 = startedInside;
  }
  toString() {
    return 'SingleTouchInfo(handler=' + toString(this.u9y_1) + ', startedInside=' + this.v9y_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.u9y_1);
    result = imul(result, 31) + getBooleanHashCode(this.v9y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof singleTouch$SingleTouchInfo))
      return false;
    var tmp0_other_with_cast = other instanceof singleTouch$SingleTouchInfo ? other : THROW_CCE();
    if (!equals(this.u9y_1, tmp0_other_with_cast.u9y_1))
      return false;
    if (!(this.v9y_1 === tmp0_other_with_cast.v9y_1))
      return false;
    return true;
  }
}
class MaterialBlockUB extends UniformBlock {
  constructor() {
    MaterialBlockUB_instance = null;
    super(3);
    MaterialBlockUB_instance = this;
    this.b9z_1 = this.c6v().q6u(this, u_ShadowColor$factory());
    this.c9z_1 = this.y6u().q6u(this, u_ShadowRadius$factory());
    this.d9z_1 = this.a6v().q6u(this, u_ShadowOffset$factory());
    this.e9z_1 = this.a6v().q6u(this, u_HighlightPos$factory());
    this.f9z_1 = this.y6u().q6u(this, u_HighlightRadius$factory());
    this.g9z_1 = this.c6v().q6u(this, u_HighlightColor$factory());
    this.h9z_1 = this.a6v().q6u(this, u_Size$factory());
    this.i9z_1 = this.c6v().q6u(this, u_Radius$factory());
    this.j9z_1 = this.y6u().q6u(this, u_BorderSizeHalf$factory());
    this.k9z_1 = this.c6v().q6u(this, u_BorderColor$factory());
    this.l9z_1 = this.c6v().q6u(this, u_BackgroundColor$factory());
  }
  u9z() {
    return this.b9z_1.ko(this, u_ShadowColor$factory_0());
  }
  w9z() {
    return this.c9z_1.ko(this, u_ShadowRadius$factory_0());
  }
  v9z() {
    return this.d9z_1.ko(this, u_ShadowOffset$factory_0());
  }
  p9z() {
    return this.e9z_1.ko(this, u_HighlightPos$factory_0());
  }
  q9z() {
    return this.f9z_1.ko(this, u_HighlightRadius$factory_0());
  }
  r9z() {
    return this.g9z_1.ko(this, u_HighlightColor$factory_0());
  }
  n9z() {
    return this.h9z_1.ko(this, u_Size$factory_0());
  }
  m9z() {
    return this.i9z_1.ko(this, u_Radius$factory_0());
  }
  s9z() {
    return this.j9z_1.ko(this, u_BorderSizeHalf$factory_0());
  }
  t9z() {
    return this.k9z_1.ko(this, u_BorderColor$factory_0());
  }
  o9z() {
    return this.l9z_1.ko(this, u_BackgroundColor$factory_0());
  }
}
class MaterialRender {
  constructor() {
    MaterialRender_instance = this;
    this.x9z_1 = MaterialBlockUB_getInstance().u9z();
    this.y9z_1 = MaterialBlockUB_getInstance().w9z();
    this.z9z_1 = MaterialBlockUB_getInstance().v9z();
    this.aa0_1 = MaterialBlockUB_getInstance().p9z();
    this.ba0_1 = MaterialBlockUB_getInstance().q9z();
    this.ca0_1 = MaterialBlockUB_getInstance().r9z();
    this.da0_1 = MaterialBlockUB_getInstance().n9z();
    this.ea0_1 = MaterialBlockUB_getInstance().m9z();
    this.fa0_1 = MaterialBlockUB_getInstance().s9z();
    this.ga0_1 = MaterialBlockUB_getInstance().t9z();
    this.ha0_1 = MaterialBlockUB_getInstance().o9z();
    var tmp = this;
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var tmp1_$this = Companion_getInstance_6().n87_1;
    var tmp2_name = null == null ? Companion_getInstance_6().n87_1.q6n_1 : null;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.z6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>' call
    var size = MaterialRender_getInstance().da0_1;
    var roundedDist = this_0.h6y(this_0.k6y(SDFShaders_getInstance().n8d(), this_0.f6z(this_0.a6x(), this_0.j6z(size, 2.0)), this_0.j6z(size, 2.0), MaterialRender_getInstance().ea0_1));
    this_0.e6x(this_0.h6x(), this_0.i6x(MaterialRender_getInstance().ha0_1, this_0.i6y(SDFShaders_getInstance().h8d(), roundedDist)));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_0.p6z(MaterialRender_getInstance().ba0_1, 0.0);
    var body = this_0.v6x();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    var highlightDist = body.j6y(SDFShaders_getInstance().c8d(), roundedDist, body.j6y(SDFShaders_getInstance().m8d(), body.f6z(this_0.a6x(), MaterialRender_getInstance().aa0_1), MaterialRender_getInstance().ba0_1));
    var highlightAlpha = body.h6y(body.i6y(SDFShaders_getInstance().h8d(), highlightDist));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = body.p6z(highlightAlpha, 0.0);
    var body_0 = body.v6x();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>.<anonymous>' call
    body_0.e6x(body_0.h6x(), body_0.j6y(SDFShaders_getInstance().p8d(), body_0.h6x(), body_0.i6x(MaterialRender_getInstance().ca0_1, highlightAlpha)));
    var stmIf = new If(cond_0, body_0.x6x());
    // Inline function 'kotlin.collections.plusAssign' call
    body.d6x_1.h(stmIf);
    var stmIf_0 = new If(cond, body.x6x());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.d6x_1.h(stmIf_0);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_1 = this_0.p6z(MaterialRender_getInstance().fa0_1, 0.0);
    var body_1 = this_0.v6x();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    var borderDist = body_1.j6y(SDFShaders_getInstance().g8d(), roundedDist, body_1.i6z(MaterialRender_getInstance().fa0_1, 2.0));
    var borderAlpha = body_1.h6y(body_1.i6y(SDFShaders_getInstance().h8d(), borderDist));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_2 = body_1.p6z(borderAlpha, 0.0);
    var body_2 = body_1.v6x();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>.<anonymous>' call
    body_2.e6x(body_2.h6x(), body_2.j6y(SDFShaders_getInstance().p8d(), body_2.h6x(), body_2.i6x(MaterialRender_getInstance().ga0_1, borderAlpha)));
    var stmIf_1 = new If(cond_2, body_2.x6x());
    // Inline function 'kotlin.collections.plusAssign' call
    body_1.d6x_1.h(stmIf_1);
    var stmIf_2 = new If(cond_1, body_1.x6x());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.d6x_1.h(stmIf_2);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_3 = this_0.q6z(this_0.m6z(this_0.r6x(this_0.h6x()), 1.0), this_0.p6z(MaterialRender_getInstance().y9z_1, 0.0));
    var body_3 = this_0.v6x();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    var shadowSoftness = MaterialRender_getInstance().y9z_1;
    var shadowOffset = MaterialRender_getInstance().z9z_1;
    var shadowDistance = body_3.k6y(SDFShaders_getInstance().n8d(), body_3.f6z(body_3.h6z(body_3.n6x(this_0.a6x(), 'xy'), shadowOffset), body_3.j6z(size, 2.0)), body_3.j6z(size, 2.0), MaterialRender_getInstance().ea0_1);
    var shadowAlpha = body_3.g6z(1.0, body_3.y6y(body_3.e6z(shadowSoftness), shadowSoftness, shadowDistance));
    body_3.e6x(body_3.h6x(), body_3.j6y(SDFShaders_getInstance().p8d(), body_3.i6x(MaterialRender_getInstance().x9z_1, shadowAlpha), body_3.h6x()));
    var stmIf_3 = new If(cond_3, body_3.x6x());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.d6x_1.h(stmIf_3);
    this_0.e6x(this_0.h6x(), this_0.i6x(this_0.h6x(), this_0.f6x()));
    var tmp3_fragment = FragmentShader(this_0.m6x());
    tmp.ia0_1 = tmp1_$this.v7k(VOID, tmp3_fragment, tmp2_name);
  }
}
class SceneCancellationException extends CancellationException {
  static pa0(scene) {
    var $this = this.hd('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.oa0_1);
    $this.na0_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.qa0_1 = new Mixin();
    this.va0_1 = Container.na3();
    this.wa0_1 = new CancellableGroup();
    var tmp = this;
    tmp.xa0_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.ya0_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.za0_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  ba1() {
    var tmp = this.ra0_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  oa3(_set____db54di) {
    this.sa0_1 = _set____db54di;
  }
  d9x() {
    var tmp = this.sa0_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  ca1() {
    var tmp = this.ta0_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  t14() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.xa0_1;
    coroutineContext$factory();
    return this_0.r1();
  }
  pa3() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ya0_1;
    sceneView$factory();
    return this_0.r1();
  }
  da1(size) {
    return SContainer.ba6(size);
  }
  e64(injector) {
    this.ra0_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.c64(getKClass(Views));
    this.oa3(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.ta0_1 = injector.c64(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.ua0_1 = injector.c64(getKClass(ResourcesRoot));
  }
  ca6(_this__u8e3s4, $completion) {
  }
  da6(_this__u8e3s4, $completion) {
  }
  ea6($completion) {
  }
  fa6($completion) {
  }
  ga6($completion) {
  }
  ha6() {
    cancel_0(this.wa0_1);
    this.ba1().f64();
  }
  aa1($completion) {
  }
  ia6($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219.bind(VOID, this), $completion);
  }
  ja6(size) {
    size_0(this.pa3(), size);
  }
  vx(value) {
    this.qa0_1.vx(value);
  }
  wx() {
    return this.qa0_1.wx();
  }
}
class EmptyScene extends Scene {
  da6(_this__u8e3s4, $completion) {
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.aaa_1 = clazz;
    this.baa_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.aaa_1) + ', injects=' + toString(this.baa_1) + ')';
  }
  hashCode() {
    var result = this.aaa_1.hashCode();
    result = imul(result, 31) + hashCode(this.baa_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.aaa_1.equals(tmp0_other_with_cast.aaa_1))
      return false;
    if (!equals(this.baa_1, tmp0_other_with_cast.baa_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.ea7_1 = Companion_getInstance_0().mw('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.fa7_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.ua6_1 = this$0;
    this.va6_1 = $event;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.ha7_1 = $newScene;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.ia7_1 = $newScene;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.ja7_1 = $oldScene;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.ka7_1 = $oldScene;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.la7_1 = $oldScene;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.ma7_1 = $newScene;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
  }
}
class BaseView extends BaseEventListener {
  static nc2() {
    return this.m66();
  }
  r9t() {
  }
}
class View extends BaseView {
  static ic5(isContainer) {
    var $this = this.nc2();
    $this.h9m_1 = isContainer;
    var tmp = $this;
    tmp.i9m_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.j9m_1 = true;
    $this.k9m_1 = null;
    $this.l9m_1 = null;
    $this.m9m_1 = null;
    $this.n9m_1 = 0;
    $this.o9m_1 = null;
    $this.p9m_1 = 1.0;
    $this.q9m_1 = null;
    $this.r9m_1 = null;
    $this.s9m_1 = null;
    $this.t9m_1 = Companion_getInstance_13().j7z_1;
    $this.u9m_1 = 0.0;
    $this.v9m_1 = 0.0;
    $this.w9m_1 = 1.0;
    $this.x9m_1 = 1.0;
    $this.y9m_1 = Companion_getInstance_34().v24_1;
    $this.z9m_1 = Companion_getInstance_34().v24_1;
    $this.a9n_1 = Companion_getInstance_34().v24_1;
    $this.b9n_1 = 0.0;
    $this.c9n_1 = scale$factory($this);
    $this.d9n_1 = false;
    $this.e9n_1 = true;
    $this.f9n_1 = true;
    $this.g9n_1 = true;
    $this.h9n_1 = true;
    $this.i9n_1 = Companion_getInstance_33().x28_1;
    $this.j9n_1 = Companion_getInstance_33().x28_1;
    $this.k9n_1 = -1;
    $this.l9n_1 = Companion_getInstance_33().x28_1;
    $this.m9n_1 = -1;
    $this.n9n_1 = new ColorTransformMul();
    $this.o9n_1 = new ColorTransformMul();
    $this.p9n_1 = -1;
    $this.q9n_1 = Companion_getInstance_13().j7z_1;
    $this.r9n_1 = -1;
    $this.s9n_1 = true;
    $this.t9n_1 = 0;
    $this.u9n_1 = 0;
    $this.v9n_1 = false;
    $this.w9n_1 = false;
    $this.x9n_1 = null;
    $this.y9n_1 = false;
    $this.z9n_1 = null;
    $this.a9o_1 = 0;
    $this.b9o_1 = true;
    $this.c9o_1 = null;
    return $this;
  }
  sag() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i9m_1;
    bviewAll$factory();
    return this_0.r1();
  }
  static fcb() {
    return this.ic5(false);
  }
  tag() {
    return 0.0;
  }
  uag() {
    return 0.0;
  }
  zaf() {
    return null;
  }
  mc2(_set____db54di) {
    this.l9m_1 = _set____db54di;
  }
  vag() {
    return this.l9m_1;
  }
  wag() {
    return this.m9m_1;
  }
  xag(value) {
    this.n9m_1 = value;
  }
  m6d() {
    return this.n9m_1;
  }
  yag(value) {
    if (this.q9m_1 === value)
      return Unit_instance;
    this.q9m_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.zaf();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).yag(value);
      }
      tmp = Unit_instance;
    }
    this.zag();
  }
  zag() {
  }
  aah(value) {
    if (this.r9m_1 === value)
      return Unit_instance;
    this.r9m_1 = value;
    var parent = this.xaf();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.zaf();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).aah(parent);
      }
      tmp = Unit_instance;
    }
  }
  xaf() {
    return this.r9m_1;
  }
  bah() {
    var tmp0_safe_receiver = this.o9m_1;
    this.aah(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xaf());
  }
  cah(value) {
    if (this.o9m_1 === value)
      return Unit_instance;
    this.o9m_1 = value;
    var tmp0_safe_receiver = this.o9m_1;
    this.yag(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q9m_1);
    this.bah();
    this.lai();
    this.n66(value);
  }
  p23() {
    return this.o9m_1;
  }
  xau(value) {
    if (!this.t9m_1.equals(value)) {
      this.t9m_1 = value;
      this.aag();
    }
  }
  dah() {
    return !(this.p23() == null) ? ensureNotNull(this.p23()).dah() * this.p9m_1 : this.p9m_1;
  }
  eah(x, y) {
    this.bai();
    if (!(this.u9m_1 === x) || !(this.v9m_1 === y)) {
      this.u9m_1 = x;
      this.v9m_1 = y;
      this.jai();
    }
  }
  w50(value) {
    return this.eah(value.e25_1, value.f25_1);
  }
  fah(v) {
    this.eah(v, this.u6a());
  }
  t6a() {
    this.bai();
    return this.u9m_1;
  }
  gah(v) {
    this.eah(this.t6a(), v);
  }
  u6a() {
    this.bai();
    return this.v9m_1;
  }
  hah() {
    return this.b9n_1;
  }
  iah(v) {
    this.oah(Scale.g2d(v, v));
  }
  jah() {
    return this.pah().i2b();
  }
  kah(v) {
    this.bai();
    if (!(this.w9m_1 === v)) {
      this.w9m_1 = v;
      this.jai();
    }
  }
  lah() {
    this.bai();
    return this.w9m_1;
  }
  mah(v) {
    this.bai();
    if (!(this.x9m_1 === v)) {
      this.x9m_1 = v;
      this.jai();
    }
  }
  nah() {
    this.bai();
    return this.x9m_1;
  }
  oah(value) {
    this.kah(value.e2d_1);
    this.mah(value.f2d_1);
  }
  pah() {
    return Scale.g2d(this.lah(), this.nah());
  }
  qah() {
    this.bai();
    return this.y9m_1;
  }
  rah() {
    this.bai();
    return this.z9m_1;
  }
  wch(v) {
    this.bai();
    if (!equals(this.a9n_1, v)) {
      this.a9n_1 = v;
      this.jai();
    }
  }
  sah() {
    this.bai();
    return this.a9n_1;
  }
  tah() {
    var tmp0_safe_receiver = this.p23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rai(Vector2D.n27(this.t6a(), this.u6a()));
    return tmp1_elvis_lhs == null ? Vector2D.n27(this.t6a(), this.u6a()) : tmp1_elvis_lhs;
  }
  uah(value) {
    this.bad(value);
  }
  e1() {
    return this.cad();
  }
  bad(value) {
    var size = this.e1();
    this.oah(Scale.g2d((this.lah() === 0.0 ? 1.0 : this.lah()) * (value.j26_1 / size.j26_1), (this.nah() === 0.0 ? 1.0 : this.nah()) * (value.k26_1 / size.k26_1)));
  }
  cad() {
    return this.e9v().e1();
  }
  vah(value) {
    this.bad(this.cad().h2g(value));
  }
  wah() {
    return this.cad().j26_1;
  }
  xah(value) {
    this.bad(this.cad().h2g(VOID, value));
  }
  yah() {
    return this.cad().k26_1;
  }
  bbe(value) {
    this.vah(value);
  }
  m2i() {
    return this.wah();
  }
  cbe(value) {
    this.xah(value);
  }
  n2i() {
    return this.yah();
  }
  e4e(v) {
    if (!(v === this.n9n_1.g4e())) {
      this.n9n_1.e4e(v);
      this.bag();
    }
  }
  g4e() {
    return this.n9n_1.g4e();
  }
  zah(v) {
    if (!(this.n9n_1.d4e() === v)) {
      this.n9n_1.c4e(v);
      this.bag();
    }
  }
  aai() {
    return this.n9n_1.d4e();
  }
  bai() {
    if (this.g9n_1)
      return Unit_instance;
    this.g9n_1 = true;
    var t = this.i9n_1.k2a();
    this.u9m_1 = t.w2a_1;
    this.v9m_1 = t.x2a_1;
    this.w9m_1 = t.y2a_1;
    this.x9m_1 = t.z2a_1;
    this.y9m_1 = t.a2b_1;
    this.z9m_1 = t.b2b_1;
    this.a9n_1 = t.c2b_1;
  }
  j23() {
    var tmp0_safe_receiver = this.p23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j23();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  b9u() {
    return this.q9m_1;
  }
  f9x(_set____db54di) {
    this.d9n_1 = _set____db54di;
  }
  c9x() {
    return this.d9n_1;
  }
  cai() {
    return this.e9n_1;
  }
  l8j(value) {
    if (!(this.f9n_1 === value)) {
      this.f9n_1 = value;
      this.aag();
    }
  }
  dai() {
    return this.f9n_1;
  }
  eai() {
    if (!this.h9n_1) {
      this.h9n_1 = true;
      this.v9n_1 = true;
      this.i9n_1 = Companion_getInstance_33().j29(this.t6a(), this.u6a(), this.sah(), this.lah(), this.nah(), this.qah(), this.rah(), 0.0, 0.0);
    }
    return this.i9n_1;
  }
  g9v() {
    if (!(this.k9n_1 === this.t9n_1)) {
      this.k9n_1 = this.t9n_1;
      this.v9n_1 = true;
      this.j9n_1 = !(this.p23() == null) ? this.eai().l29(ensureNotNull(this.p23()).g9v()) : this.eai();
    }
    return this.j9n_1;
  }
  fai() {
    if (!(this.m9n_1 === this.t9n_1)) {
      this.m9n_1 = this.t9n_1;
      this.v9n_1 = true;
      this.l9n_1 = this.g9v().j2a();
    }
    return this.l9n_1;
  }
  gai() {
    updateRenderColorTransformIfRequired(this);
    return this.o9n_1;
  }
  hai() {
    updateRenderBlendModeIfRequired(this);
    return this.q9n_1;
  }
  iai() {
    updateRenderColorTransformIfRequired(this);
    return this.o9n_1.g4e();
  }
  lc5(views) {
    return this.i9x(views.t9j_1.i84());
  }
  jai() {
    this.h9n_1 = false;
    this.aag();
  }
  aag() {
    this.t9n_1 = this.t9n_1 + 1 | 0;
    this.v9n_1 = false;
    this.s9n_1 = true;
    this.r9t();
  }
  kai() {
    if (!(this.x9n_1 == null)) {
      this.x9n_1 = null;
      var tmp0_safe_receiver = this.p23();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.kai();
      }
    }
  }
  lai() {
    this.fad();
  }
  mai() {
    this.fad();
  }
  fad() {
  }
  r9t() {
    var tmp0_safe_receiver = this.r9m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.yaf(this);
    }
    this.kai();
  }
  bag() {
    this.u9n_1 = this.u9n_1 + 1 | 0;
    this.w9n_1 = false;
    this.s9n_1 = true;
    this.r9t();
  }
  dad(ctx) {
    if (!this.dai())
      return Unit_instance;
    var tmp0_safe_receiver = this.z9n_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.ly_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].ico(this, ctx);
      }
    }
    try {
      this.nai(ctx);
    }finally {
      var tmp1_safe_receiver = this.z9n_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.ly_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.e1() - n_0 | 0) - 1 | 0].jco(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  nai(ctx) {
    var oldPhase = this.a9o_1;
    try {
      this.a9o_1 = 0;
      this.oai(ctx);
    }finally {
      this.a9o_1 = oldPhase;
    }
  }
  oai(ctx) {
    var stages = this.z9n_1;
    if (!(stages == null) && this.a9o_1 < stages.e1()) {
      var _unary__edvuaz = this.a9o_1;
      this.a9o_1 = _unary__edvuaz + 1 | 0;
      stages.d1(_unary__edvuaz).kco(this, ctx);
    } else {
      var tmp = this.a9o_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.e1();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.had(ctx);
        this.a9o_1 = this.a9o_1 + 1 | 0;
      }
    }
  }
  lag(ctx) {
    if (this.y9n_1 || this === get_debugAnnotateView(ctx)) {
      this.pai(ctx);
    }
  }
  pai(ctx) {
    var local = this.e9v();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.d8a_1;
    if (!(this_1.f81_1 === this_0)) {
      this_1.f81_1 = this_0;
      this_1.p82();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.p8a_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().s7z_1;
          var doUpdate = !(this_0.o8a_1 === blending);
          var old = this_0.o8a_1;
          try {
            if (doUpdate) {
              this_0.d8a_1.p82();
              this_0.o8a_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().u3y_1;
            var m = this_0.p8a_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.g8a_1;
            this_0.g8a_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.y3o(this.daj());
              this_0.v8a(this_3, m);
            }finally {
              this_0.g8a_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.d8a_1.p82();
            }
            this_0.o8a_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().u3y_1;
        var m_0 = this_0.p8a_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.g8a_1;
        this_0.g8a_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.u3d(this.rai(Vector2D.n27(local.v25(), local.x25())));
          this_4.h3e(this.rai(Vector2D.n27(local.w25(), local.x25())));
          this_4.h3e(this.rai(Vector2D.n27(local.w25(), local.y25())));
          this_4.h3e(this.rai(Vector2D.n27(local.v25(), local.y25())));
          this_4.c6();
          this_0.v8a(this_4, m_0);
        }finally {
          this_0.g8a_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().i44_1;
        var m_1 = this_0.p8a_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.g8a_1;
        this_0.g8a_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).w89();
          this_5.d3p(this.rai(local.n26()), anchorSize);
          this_5.d3p(this.rai(local.g2e()), anchorSize);
          this_5.d3p(this.rai(local.p26()), anchorSize);
          this_5.d3p(this.rai(local.h2e()), anchorSize);
          this_5.d3p(this.rai(interpolate(Companion_getInstance_37().mx_1, local.n26(), local.g2e())), anchorSize);
          this_5.d3p(this.rai(interpolate(Companion_getInstance_37().mx_1, local.g2e(), local.p26())), anchorSize);
          this_5.d3p(this.rai(interpolate(Companion_getInstance_37().mx_1, local.p26(), local.h2e())), anchorSize);
          this_5.d3p(this.rai(interpolate(Companion_getInstance_37().mx_1, local.h2e(), local.n26())), anchorSize);
          this_0.v8a(this_5, m_1);
        }finally {
          this_0.g8a_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().w3y_1;
        var m_2 = this_0.p8a_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.g8a_1;
        this_0.g8a_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.tah();
          this_6.x3o(Vector2D.n27(center.e25_1, center.f25_1 - 5), Vector2D.n27(center.e25_1, center.f25_1 + 5));
          this_6.x3o(Vector2D.n27(center.e25_1 - 5, center.f25_1), Vector2D.n27(center.e25_1 + 5, center.f25_1));
          this_0.v8a(this_6, m_2);
        }finally {
          this_0.g8a_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.t6a() === 0.0) || !(this.u6a() === 0.0))
      out = out + (':pos=(' + this.qai(this.t6a()) + ',' + this.qai(this.u6a()) + ')');
    if (!(this.lah() === 1.0) || !(this.nah() === 1.0))
      out = out + (':scale=(' + this.qai(this.lah()) + ',' + this.qai(this.nah()) + ')');
    if (!equals(this.qah(), Companion_getInstance_34().v24_1) || !equals(this.rah(), Companion_getInstance_34().v24_1))
      out = out + (':skew=(' + this.qai(_Angle___get_degrees__impl__qg56vw(this.qah())) + ',' + this.qai(_Angle___get_degrees__impl__qg56vw(this.rah())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.sah()), Companion_getInstance_34().v24_1))
      out = out + (':rotation=(' + this.qai(_Angle___get_degrees__impl__qg56vw(this.sah())) + '\xBA)');
    if (!(this.s9m_1 == null))
      out = out + (':name=(' + this.s9m_1 + ')');
    if (!this.t9m_1.equals(Companion_getInstance_13().j7z_1))
      out = out + (':blendMode=(' + this.t9m_1.toString() + ')');
    if (!this.dai())
      out = out + (':visible=' + this.dai());
    if (!(this.aai() === 1.0))
      out = out + (':alpha=' + niceStr(this.aai(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.g4e()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().s3y_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.g4e()));
    return out;
  }
  qai(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  i9x(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.fai();
      if (this_0.t25()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.n27(this_0.p29(p.e25_1, p.f25_1), this_0.s29(p.e25_1, p.f25_1));
    }
    return tmp$ret$0;
  }
  rai(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.g9v();
      if (this_0.t25()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.n27(this_0.p29(p.e25_1, p.f25_1), this_0.s29(p.e25_1, p.f25_1));
    }
    return tmp$ret$0;
  }
  sai(globalPos, direction) {
    if (!this.b9o_1)
      return null;
    if (!this.dai())
      return null;
    var tmp0_safe_receiver = this.zaf();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.hitTest.<anonymous>' call
        var tmp0_safe_receiver_0 = tmp0_safe_receiver.d1((tmp0_safe_receiver.e1() - n | 0) - 1 | 0).sai(globalPos, direction);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          return tmp0_safe_receiver_0;
        }
        n = n + 1 | 0;
      }
    }
    var res = this.vai(globalPos);
    if (!(res == null))
      return res;
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  w9y(globalPos, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.sai(globalPos, direction) : $super.sai.call(this, globalPos, direction);
  }
  d9v(p) {
    if (!this.b9o_1)
      return null;
    if (!this.dai())
      return null;
    if (this.cai()) {
      var tmp0_safe_receiver = this.zaf();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.View.mouseHitTest.<anonymous>' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.d1((tmp0_safe_receiver.e1() - n | 0) - 1 | 0).d9v(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.c9x())
      return null;
    var tmp1_safe_receiver = this.vai(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var area = this.tai();
      if (!area.t25() && !area.e2e(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  tai() {
    var out = Companion_getInstance_31().b26_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p23();
    }
    while (!(view == null)) {
      // Inline function 'korlibs.korge.view.View.getClippingAreaInternal.<anonymous>' call
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.o5z();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.faj();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.p2e(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.p23();
    }
    return count === 0 ? Companion_getInstance_31().d26() : out;
  }
  uai(p, direction) {
    if (!this.b9o_1)
      return null;
    var ll = this.i9x(p);
    var bounds = this.e9v();
    if (!bounds.e2e(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.g2a(this.tag(), this.uag());
    var l = Vector2D.n27(ll.e25_1 + that.e25_1, ll.f25_1 + that.f25_1);
    if (this.c9o_1 === false)
      return this;
    var hitShape = this.vag();
    var hitShapes = this.wag();
    if (this.c9o_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.e1()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.d1(_unary__edvuaz).t3p(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.t3p(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  vai(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.uai(p, direction) : $super.uai.call(this, p, direction);
  }
  wai() {
    var tmp0_safe_receiver = this.p23();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.rag(this);
  }
  xai(target, inclusive) {
    var tmp;
    if (target === this.p23()) {
      tmp = this.eai();
    } else if (target === this) {
      tmp = Companion_getInstance_33().x28_1;
    } else {
      var commonAncestor = Companion_instance_28.hco(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.p23() == null && inclusive) {
          return this.g9v();
        }
        tmp_0 = this.g9v().l29(target.fai());
      } else {
        tmp_0 = Companion_getInstance_33().x28_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.l29(target.eai());
    }
    return out;
  }
  yai() {
    var tmp0_elvis_lhs = this.zai();
    return tmp0_elvis_lhs == null ? this.faj() : tmp0_elvis_lhs;
  }
  zai() {
    var stage = this.j23();
    if (!(stage instanceof Stage))
      return null;
    return this.aaj(stage);
  }
  aaj(bp) {
    return this.faj().x2e(bp.s89());
  }
  baj(ctx) {
    return ctx.d8b() ? this.aaj(ctx) : this.faj();
  }
  caj(ctx) {
    return this.baj(ctx);
  }
  daj() {
    return this.faj();
  }
  eaj(includeFilters) {
    return this.iaj(this.j23(), VOID, true, includeFilters);
  }
  faj(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.eaj(includeFilters) : $super.eaj.call(this, includeFilters);
  }
  gaj(concat, doAnchoring, includeFilters) {
    var out = this.jaj(doAnchoring, includeFilters);
    if (concat.u25() && !concat.m29()) {
      var tmp = Companion_getInstance_32();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.n26();
        if (concat.t25()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.n27(concat.p29(p.e25_1, p.f25_1), concat.s29(p.e25_1, p.f25_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.g2e();
        if (concat.t25()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.n27(concat.p29(p_0.e25_1, p_0.f25_1), concat.s29(p_0.e25_1, p_0.f25_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.p26();
        if (concat.t25()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.n27(concat.p29(p_1.e25_1, p_1.f25_1), concat.s29(p_1.e25_1, p_1.f25_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.h2e();
        if (concat.t25()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.n27(concat.p29(p_2.e25_1, p_2.f25_1), concat.s29(p_2.e25_1, p_2.f25_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.f26(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  haj(target, doAnchoring, inclusive, includeFilters) {
    return this.gaj(this.xai(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  iaj(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.haj(target, doAnchoring, inclusive, includeFilters) : $super.haj.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  jaj(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.x9n_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.ead();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.x9n_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.b2a(Vector2D.g2a(this.tag(), this.uag()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  e9v(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.jaj(doAnchoring, includeFilters) : $super.jaj.call(this, doAnchoring, includeFilters);
  }
  ead() {
    return Companion_getInstance_31().d26();
  }
  v66(type, event, result) {
    var tmp0_safe_receiver = this.p23();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.c67(type, event, result);
  }
}
class Container extends View {
  static na3(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.ic5(true);
    $this.ea3_1 = cull;
    $this.fa3_1 = FastArrayList.ny();
    $this.ga3_1 = new ContainerCollection($this, $this.fa3_1);
    $this.ha3_1 = null;
    $this.ia3_1 = new MMatrix();
    $this.ja3_1 = false;
    $this.ka3_1 = false;
    $this.la3_1 = FastArrayList.ny();
    return $this;
  }
  zaf() {
    return this.fa3_1;
  }
  aag() {
    super.aag();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ga3_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.v9n_1) {
        child.aag();
      }
    }
  }
  bag() {
    super.bag();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ga3_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.w9n_1) {
        child.bag();
      }
    }
  }
  cag() {
    return this.fa3_1.e1();
  }
  dag(view) {
  }
  eag(view) {
  }
  fad() {
    super.fad();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.zaf();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).mai();
      }
      tmp = Unit_instance;
    }
  }
  fag(index) {
    return this.fa3_1.d1(index);
  }
  gag(index) {
    return this.hag(index, 1) === 1;
  }
  hag(index, count) {
    if (count <= 0 || index < 0)
      return 0;
    var from = index;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = index + count | 0;
    var b = this.cag();
    var to = Math.min(a, b);
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var removedIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var view = this.fag(removedIndex);
        view.cah(null);
        view.xag(-1);
      }
       while (inductionVariable < to);
    this.fa3_1.qy(from, to);
    var inductionVariable_0 = index;
    var last = this.cag();
    if (inductionVariable_0 < last)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.fa3_1.d1(i).xag(i);
      }
       while (inductionVariable_0 < last);
    this.nag();
    this.oag();
    this.kai();
    return to - from | 0;
  }
  iag() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ga3_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      child.cah(null);
      child.xag(-1);
    }
    this.fa3_1.h3();
    this.nag();
  }
  jag(view) {
    return this.qag(view, this.cag());
  }
  ma3(view) {
    this.qag(view, this.cag());
  }
  d1(index) {
    return this.fag(index);
  }
  had(ctx) {
    if (!this.dai())
      return Unit_instance;
    this.kag(ctx);
  }
  kag(ctx) {
    if (!this.ea3_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.ja3_1) {
        this.ja3_1 = true;
        this.la3_1.h3();
        this.la3_1.f1(this.ga3_1);
        if (this.mag())
          this.ka3_1 = false;
      }
      if (!this.ka3_1) {
        this.ka3_1 = true;
        sortWith(this.la3_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.la3_1.ly_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].dad(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.faj();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_31().d26() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.ja3_1) {
      this.ja3_1 = true;
      this.la3_1.h3();
      this.la3_1.f1(this.ga3_1);
      if (this.mag())
        this.ka3_1 = false;
    }
    if (!this.ka3_1) {
      this.ka3_1 = true;
      sortWith(this.la3_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.la3_1.ly_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.t25() || bounds.m2e(child.eaj(true))) {
        child.dad(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  lag(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.ja3_1) {
      this.ja3_1 = true;
      this.la3_1.h3();
      this.la3_1.f1(this.ga3_1);
      if (this.mag())
        this.ka3_1 = false;
    }
    if (!this.ka3_1) {
      this.ka3_1 = true;
      sortWith(this.la3_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.la3_1.ly_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].lag(ctx);
    }
    super.lag(ctx);
  }
  ead() {
    var bb = Companion_getInstance_32().e26();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ga3_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.iaj(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  mag() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.fa3_1.ly_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].hah() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  nag() {
    this.ja3_1 = false;
    this.oag();
  }
  oag() {
    var tmp0_safe_receiver = this.b9u();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d9x();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.yaf(this);
    }
  }
  pag(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  qag(view, index) {
    this.pag(view);
    var tmp0_safe_receiver = view.p23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.nag();
    }
    view.wai();
    var aindex = clamp(index, 0, this.cag());
    var children = this.fa3_1;
    children.x6(aindex, view);
    var inductionVariable = aindex;
    var last = this.cag();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.d1(n).xag(n);
      }
       while (inductionVariable < last);
    view.cah(this);
    view.aag();
    this.dag(view);
    this.nag();
    this.oag();
    this.kai();
  }
  rag(view) {
    if (!((view == null ? null : view.p23()) === this))
      return false;
    return this.gag(view.m6d());
  }
  s66(type, event, result) {
    if (this.ha3_1 == null)
      this.ha3_1 = FastArrayList.my(this.ga3_1.e1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.fa3_1;
    var temp = ensureNotNull(this.ha3_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.ly_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].b67(type, event, result);
      }
    }finally {
      temp.h3();
    }
  }
}
class CachedContainer extends Container {
  static oc2(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.na3();
    $this.qaf_1 = cache;
    $this.raf_1 = renderQuality;
    $this.saf_1 = null;
    $this.taf_1 = true;
    $this.uaf_1 = -1.0;
    $this.vaf_1 = Companion_getInstance_31().a29();
    $this.waf_1 = Scale.p2f(1);
    return $this;
  }
  r9t() {
    super.r9t();
    this.taf_1 = true;
  }
  had(ctx) {
    if (!this.dai())
      return Unit_instance;
    if (!this.qaf_1) {
      return super.had(ctx);
    }
    if (this.saf_1 == null) {
      this.saf_1 = new CacheTexture(this, ctx);
      this.taf_1 = true;
    }
    var cache = ensureNotNull(this.saf_1);
    ctx.h8b(cache);
    var renderScale = ctx.x8a().n3_1 === 0 ? 1.0 : ctx.p8b();
    var tmp1_elvis_lhs = this.raf_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.x8a() : tmp1_elvis_lhs);
    if (this.taf_1 || !(this.uaf_1 === renderScale)) {
      this.uaf_1 = renderScale;
      this.vaf_1 = this.e9v(VOID, false);
      this.waf_1 = doExpensiveScaling ? this.yai().e1().r2f(this.vaf_1.e1()) : Scale.p2f(1);
      this.taf_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.vaf_1.q25_1 * renderScale * this.waf_1.e2d_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.vaf_1.r25_1 * renderScale * this.waf_1.f2d_1), 1);
      cache.uc2(texWidth, texHeight);
      ctx.p82();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.qc2_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.m8b(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.b81_1;
        var this_1 = this_0.k81_1;
        if (!(this_1.f81_1 === this_0)) {
          this_1.f81_1 = this_0;
          this_1.p82();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.s6q(0, 0, frameBuffer.t6f_1, frameBuffer.u6f_1);
          var temp = this_0.i82_1;
          this_0.r88();
          this_0.i82_1 = scissor;
          try {
            if (true) {
              ctx.f8b(Colors_getInstance().x3y_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.fai().d2a(-this.vaf_1.o25_1, -this.vaf_1.p25_1).x29(renderScale * this.waf_1.e2d_1, renderScale * this.waf_1.f2d_1);
            ctx.p82();
            var temp4 = ctx.q80_1;
            var temp2d = ctx.r80_1;
            ctx.r80_1 = matrix;
            ctx.q80_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.e6n(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.t6o();
              this_2.u7b(_unary__edvuaz + 1 | 0);
              this_2.v7b(this_2.t6o() + 1 | 0);
              var blockSize = this_2.x6m_1;
              var index0 = imul(this_2.t6o() - 1 | 0, blockSize);
              var index1 = imul(this_2.t6o(), blockSize);
              var texBlockSize = this_2.u6m_1.t6u().e1();
              var texIndex0 = imul(this_2.t6o() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.t6o(), texBlockSize);
              if (this_2.t6o() > 0) {
                arraycopy(this_2.z6m_1, index0, this_2.z6m_1, index1, blockSize);
              } else {
                arrayfill(this_2.z6m_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.u6m_1;
              this_2.a6n_1.j7c($this$push.s6u(), ctx.q80_1);
              if (true && this_2.t6o() >= 1) {
                var equals = arrayequal(this_2.z6m_1, index0, this_2.z6m_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.t6o();
                  this_2.u7b(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.had(ctx);
            }finally {
              ctx.p82();
              ctx.q80_1 = temp4;
              ctx.r80_1 = temp2d;
              ctx.e6n(ProjViewUB_getInstance()).w7b();
            }
            break $l$block_0;
          }finally {
            this_0.r88();
            this_0.i82_1 = temp;
          }
        }
      }finally {
        ctx.n8b();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.b81_1;
    var this_4 = this_3.k81_1;
    if (!(this_4.f81_1 === this_3)) {
      this_4.f81_1 = this_3;
      this_4.p82();
    }
    this_3.r82(cache.sc2_1, VOID, VOID, VOID, VOID, this.g9v().h2a(this.vaf_1.o25_1, this.vaf_1.p25_1).z29(1.0 / (renderScale * this.waf_1.e2d_1), 1.0 / (renderScale * this.waf_1.f2d_1)), VOID, this.iai(), this.t9m_1);
  }
  xaf() {
    return this;
  }
  yaf(view) {
    this.taf_1 = true;
    var tmp0_safe_receiver = this.p23();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r9m_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.yaf(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static ibw(size, cache, clip) {
    size = size === VOID ? Size2D.l26(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.oc2(cache);
    $this.fbw_1 = clip;
    $this.gbw_1 = size;
    $this.hbw_1 = Ref(false);
    return $this;
  }
  bad(_set____db54di) {
    this.gbw_1 = _set____db54di;
  }
  cad() {
    return this.gbw_1;
  }
  ead() {
    return new Rectangle(0.0, 0.0, this.m2i(), this.n2i());
  }
  had(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.fbw_1;
      var renderingInternalRef = this.hbw_1;
      if (renderingInternalRef.r1()) {
        super.had(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.g9v();
        var hasRotation = !(m.d29_1 === 0.0) || !(m.e29_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.r1();
          try {
            renderingInternalRef.s2q(true);
            renderFiltered(this, ctx, Companion_getInstance_58());
          }finally {
            renderingInternalRef.s2q(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.b81_1;
        if (!(ctx.f81_1 === batcher)) {
          ctx.f81_1 = batcher;
          ctx.p82();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.d81_1;
        var bounds = this.caj(ctx).x2e(ctx.r80_1).y2e();
        var rect = c2d.t8b_1.b88().a6r();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.m2e(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_16().v6q(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.t8b_1;
            var scissor_0 = c2d.g8c(scissor);
            var temp = this_0.i82_1;
            this_0.r88();
            this_0.i82_1 = scissor_0;
            try {
              super.had(ctx);
              break $l$block_1;
            }finally {
              this_0.r88();
              this_0.i82_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.had(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.had(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static wac(size, cache) {
    Companion_getInstance_45();
    size = size === VOID ? Companion_getInstance_45().jb4_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.ibw(size, cache, false);
    $this.uac_1 = size;
    $this.vac_1 = false;
    return $this;
  }
  bad(value) {
    if (!this.uac_1.equals(value)) {
      this.uac_1 = value;
      this.yac();
    }
  }
  cad() {
    return this.uac_1;
  }
  ead() {
    return new Rectangle(0.0, 0.0, this.m2i(), this.n2i());
  }
  lb4() {
    return this.c9x();
  }
  yac() {
    var tmp0_safe_receiver = this.p23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.eag(this);
    }
  }
  fad() {
    super.fad();
    this.gad();
  }
  gad() {
    this.aag();
  }
  had(ctx) {
    registerUISupportOnce(this);
    super.had(ctx);
  }
}
class SceneContainer extends UIView {
  static d9r(views, defaultTransition, name, size) {
    Companion_getInstance_43();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_36())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.c9l_1.e1() : size;
    var $this = this.wac(size);
    $this.x9q_1 = views;
    $this.y9q_1 = defaultTransition;
    $this.s9m_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.xac();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.ma3(this_0);
    tmp.z9q_1 = this_0;
    $this.a9r_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.o66(tmp_0, SceneContainer$lambda($this));
    $this.b9r_1 = arrayListOf([Companion_getInstance_43().fa7_1]);
    $this.c9r_1 = 0;
    return $this;
  }
  yac() {
    var tmp0_safe_receiver = this.a9r_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ja6(Size2D.b2e(this.m2i(), this.n2i()));
    }
  }
  zac(clazz, injects, time, transition, $completion) {
    this.aad(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  e9r(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.y9q_1 : transition;
    return $super === VOID ? this.zac(clazz, injects, time, transition, $completion) : $super.zac.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  ga7(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0.bind(VOID, this, newScene, time, transition), $completion);
  }
  aad(entry) {
    while (this.b9r_1.e1() <= this.c9r_1) {
      this.b9r_1.h(Companion_getInstance_43().fa7_1);
    }
    this.b9r_1.k3(this.c9r_1, entry);
  }
  t14() {
    return this.x9q_1.q9j_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static xac() {
    var $this = this.na3();
    dummyView($this);
    dummyView($this);
    $this.va9_1 = Companion_getInstance_37().kx_1;
    $this.wa9_1 = get_AlphaTransition();
    return $this;
  }
  b1i() {
    return this.d1(0);
  }
  y1h() {
    return this.d1(1);
  }
  ya9(next, transition) {
    this.wa9_1 = transition;
    this.va9_1 = Companion_getInstance_37().kx_1;
    this.xa9_1 = transition.naj();
    this.oaj(this.y1h(), next);
    _get_transitionProcess__5hlux5(this).kaj(this.b1i(), this.y1h());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.va9_1) + ':transition=' + toString(this.wa9_1));
  }
  za9() {
    this.va9_1 = Companion_getInstance_37().nx_1;
    _get_transitionProcess__5hlux5(this).laj(this.b1i(), this.y1h());
    this.oaj(dummyView(this), this.y1h());
  }
  oaj(prev, next) {
    this.iag();
    this.jag(prev);
    this.jag(next);
  }
  had(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.va9_1, Companion_getInstance_37().kx_1) <= 0) {
      this.b1i().dad(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.va9_1, Companion_getInstance_37().nx_1) >= 0) {
      this.y1h().dad(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).maj(ctx, this.b1i(), this.y1h(), this.va9_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.paj_1 = $render;
    this.qaj_1 = $name;
  }
  naj() {
    return this;
  }
  maj(ctx, prev, next, ratio) {
    return this.paj_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.qaj_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.raj_1 = $process;
    this.saj_1 = $easing;
  }
  kaj(prev, next) {
    return this.raj_1.kaj(prev, next);
  }
  laj(prev, next) {
    return this.raj_1.laj(prev, next);
  }
  maj(ctx, prev, next, ratio) {
    return this.raj_1.maj(ctx, prev, next, this.saj_1.fx(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.taj_1 = $this_withEasing;
    this.uaj_1 = $easing;
  }
  toString() {
    return toString(this.taj_1) + '.withEasing';
  }
  naj() {
    var process = this.taj_1.naj();
    return new withEasing$1$create$1(process, this.uaj_1);
  }
}
class ViewStyles {
  constructor(view) {
    this.vaj_1 = view;
    this.waj_1 = null;
    this.xaj_1 = atomic$int$1(0);
  }
  yaj(prop, default_0) {
    var tmp0_safe_receiver = this.waj_1;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c3(prop.callableName);
    var tmp1_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : null;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.vaj_1.p23();
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : get_styles(tmp2_safe_receiver);
      tmp_0 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.yaj(prop, default_0);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp4_elvis_lhs = tmp_0;
    return tmp4_elvis_lhs == null ? default_0 : tmp4_elvis_lhs;
  }
  zaj(updating) {
    if (updating === 0) {
      var tmp = this.vaj_1;
      var tmp0_safe_receiver = isInterface(tmp, StyleableView) ? tmp : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.aak();
      }
    }
  }
  bak(updating, $super) {
    updating = updating === VOID ? this.xaj_1.kotlinx$atomicfu$value : updating;
    var tmp;
    if ($super === VOID) {
      this.zaj(updating);
      tmp = Unit_instance;
    } else {
      tmp = $super.zaj.call(this, updating);
    }
    return tmp;
  }
}
class ViewStyle {
  constructor(default_0) {
    this.cak_1 = default_0;
  }
}
class StyleableView {}
function updatedStyles() {
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.dak_1 = this.hak(true, VOID, false);
    this.eak_1 = this.hak(true, VOID, true);
    this.fak_1 = this.iak(false, 'r', false);
    this.gak_1 = this.iak(false, 'a', false);
  }
  iak(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_6().n87_1;
    var tmp2_name = name == null ? Companion_getInstance_6().n87_1.q6n_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.z6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.s6y();
    var tmp_0 = this_0.s6y();
    var tmp_1 = this_0.s6y();
    var tmp_2 = this_0.s6y();
    var median$delegate = this_0.f6y(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).h6v(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_6().k87_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.m6y(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.a6z(this_0.s6x());
    var alpha = this_0.b6z(this_0.s6x());
    this_0.e6x(this_0.h6x(), this_0.f6z(this_0.h6x(), this_0.l6x([this_0.k6x(0.5)])));
    if (msdf) {
      this_0.e6x(d, this_0.k6y(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.n6x(this_0.h6x(), 'r'), this_0.n6x(this_0.h6x(), 'g'), this_0.n6x(this_0.h6x(), 'b')));
    } else {
      this_0.e6x(d, this_0.n6x(this_0.h6x(), sdf));
    }
    this_0.e6x(alpha, this_0.i6y(SDFShaders_getInstance().i8d(), d));
    if (inverted) {
      this_0.e6x(alpha, this_0.f6z(this_0.k6x(1.0), alpha));
    }
    this_0.e6x(this_0.h6x(), this_0.i6x(this_0.f6x(), alpha));
    var tmp3_fragment = FragmentShader(this_0.m6x());
    return tmp1_$this.v7k(VOID, tmp3_fragment, tmp2_name);
  }
  hak(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.iak(msdf, sdf, inverted) : $super.iak.call(this, msdf, sdf, inverted);
  }
}
class TextSnapshot {
  constructor(text, selectionRange) {
    this.xal_1 = text;
    this.yal_1 = selectionRange;
  }
  zal(out) {
    setTextNoSnapshot$default(out, this.xal_1);
    out.aam(this.yal_1);
  }
  toString() {
    return 'TextSnapshot(text=' + this.xal_1 + ', selectionRange=' + this.yal_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.xal_1);
    result = imul(result, 31) + this.yal_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSnapshot))
      return false;
    var tmp0_other_with_cast = other instanceof TextSnapshot ? other : THROW_CCE();
    if (!(this.xal_1 === tmp0_other_with_cast.xal_1))
      return false;
    if (!this.yal_1.equals(tmp0_other_with_cast.yal_1))
      return false;
    return true;
  }
}
class TextEditController$slambda {
  constructor(this$0) {
    this.aaq_1 = this$0;
  }
  u9u(it, $completion) {
    if (!get_focused(this.aaq_1))
      return Unit_instance;
    if (it.o68_1 || it.m68_1)
      return Unit_instance;
    // Inline function 'kotlin.code' call
    var this_0 = it.k68_1;
    var code = Char__toInt_impl_vasixd(this_0);
    switch (code) {
      case 8:
      case 127:
        break;
      case 9:
      case 10:
      case 13:
        if (code === 10 || code === 13) {
          this.aaq_1.sak_1.z1v(this.aaq_1);
        }

        break;
      case 27:
        this.aaq_1.rak_1.z1v(this.aaq_1);
        break;
      default:
        this.aaq_1.nal(it.r68());
        break;
    }
  }
  qd(p1, $completion) {
    return this.u9u(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class TextEditController$slambda_0 {
  constructor(this$0) {
    this.jak_1 = this$0;
  }
  u9u(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this, it), $completion);
  }
  qd(p1, $completion) {
    return this.u9u(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class UIFocusable {}
class TextEditController {
  constructor(textView, caretContainer, eventHandler, bg) {
    caretContainer = caretContainer === VOID ? textView : caretContainer;
    eventHandler = eventHandler === VOID ? textView : eventHandler;
    bg = bg === VOID ? null : bg;
    this.kak_1 = new SoftKeyboardConfig();
    this.lak_1 = textView;
    this.mak_1 = caretContainer;
    this.nak_1 = eventHandler;
    this.oak_1 = bg;
    set_focusable(this.lak_1, this);
    this.pak_1 = this.lak_1.w5q();
    this.qak_1 = new CancellableGroup();
    this.rak_1 = new Signal();
    this.sak_1 = new Signal();
    this.tak_1 = new Signal();
    this.uak_1 = new Signal();
    this.vak_1 = new Signal();
    this.wak_1 = new Signal();
    this.xak_1 = new Signal();
    this.yak_1 = new Signal();
    var tmp = this;
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.korge.view.debug.debugVertexView' call
    var this_0 = this.mak_1;
    // Inline function 'kotlin.collections.listOf' call
    var pointsList = emptyList();
    var color = Colors_getInstance().s3y_1;
    var type = Companion_getInstance_14().q6p_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = DebugVertexView.wau(pointsList, color, type);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.debug.debugVertexView.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.text.TextEditController.caret.<anonymous>' call
    this_2.xau(Companion_getInstance_13().s7z_1);
    this_2.l8j(false);
    tmp.zak_1 = this_2;
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_30();
    tmp_0.aal_1 = Margin.k28(numberToDouble(3.0), numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0));
    this.qak_1.yr(onNewAttachDetach(this.lak_1, TextEditController$lambda));
    this.yak_1.z1v(this);
    this.bal_1 = new HistoryStack();
    this.cal_1 = color$factory(this.lak_1);
    this.dal_1 = this.pak_1.length;
    this.eal_1 = this.dal_1;
    this.fal_1 = 0;
    var tmp_1 = this;
    tmp_1.gal_1 = TextEditController$acceptTextChange$lambda;
    set_cursor(this.nak_1, Cursor_TEXT_getInstance());
    var tmp_2 = get_timers(this.nak_1);
    // Inline function 'korlibs.time.seconds' call
    var tmp_3 = toDuration(0.5, DurationUnit_SECONDS_getInstance());
    this.qak_1.yr(tmp_2.dav(tmp_3, TextEditController$lambda_0(this)));
    // Inline function 'korlibs.korge.input.newKeys' call
    var this_3 = this.nak_1;
    // Inline function 'kotlin.also' call
    var this_4 = new KeysEvents(this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.newKeys.<anonymous>' call
    // Inline function 'korlibs.korge.text.TextEditController.<anonymous>' call
    this_4.b9v(TextEditController$slambda_1(this));
    this_4.x9u(TextEditController$slambda_2(this));
    this.qak_1.yr(this_4);
    // Inline function 'korlibs.korge.input.newMouse' call
    var this_5 = this.nak_1;
    // Inline function 'kotlin.also' call
    var this_6 = new MouseEvents(this_5);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.newMouse.<anonymous>' call
    // Inline function 'korlibs.korge.text.TextEditController.<anonymous>' call
    var dragging = {_v: false};
    var tmp0_safe_receiver = this.oak_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mas_1 = false;
    }
    this.xak_1.z1v(this);
    this_6.n9v_1.y1v(TextEditController$lambda_1(this));
    this_6.o9v_1.y1v(TextEditController$lambda_2(this));
    this_6.l9v_1.y1v(TextEditController$lambda_3(this, dragging));
    this_6.p9v_1.y1v(TextEditController$lambda_4(this, dragging));
    this_6.q9v_1.y1v(TextEditController$lambda_5(dragging, this));
    this_6.y9v_1.y1v(TextEditController$lambda_6(this, dragging));
    this_6.t9v_1.y1v(TextEditController$lambda_7(dragging, this));
    doubleClick(this_6, TextEditController$lambda_8(this));
    this.qak_1.yr(this_6);
    this.eav();
  }
  b9u() {
    return this.lak_1.b9u();
  }
  fav(_this__u8e3s4) {
    return this.lak_1;
  }
  lal(value) {
    var snapshot = setTextNoSnapshot$default(this, value);
    if (!(snapshot == null)) {
      this.bal_1.f2n(snapshot);
    }
  }
  w5q() {
    return this.lak_1.w5q();
  }
  hal() {
    var tmp0_safe_receiver = this.bal_1.g2n();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zal(this);
    }
  }
  ial() {
    var tmp0_safe_receiver = this.bal_1.h2n();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zal(this);
    }
  }
  nal(substr) {
    var tmp = withoutRange(this.w5q(), this.kal());
    // Inline function 'kotlin.math.min' call
    var a = this.sal();
    var b = this.wap();
    var tmp$ret$0 = Math.min(a, b);
    this.lal(withInsertion(tmp, tmp$ret$0, substr));
    this.ral(this.qal() + substr.length | 0);
  }
  gav(value) {
    this.lak_1.hav(value);
    this.eav();
  }
  t50() {
    var tmp = this.lak_1.rao_1;
    return isInterface(tmp, Font) ? tmp : THROW_CCE();
  }
  iav(value) {
    this.lak_1.iav(value);
    this.eav();
  }
  jav() {
    return this.lak_1.sao_1;
  }
  yap(value) {
    this.dal_1 = clampIndex(this, value);
    this.eav();
  }
  sal() {
    return this.dal_1;
  }
  pas(value) {
    this.eal_1 = clampIndex(this, value);
    this.eav();
  }
  wap() {
    return this.eal_1;
  }
  ral(value) {
    var value_0 = clampIndex(this, value);
    this.dal_1 = value_0;
    this.eal_1 = value_0;
    this.eav();
  }
  qal() {
    return this.sal();
  }
  xap(start, end) {
    this.dal_1 = clampIndex(this, start);
    this.eal_1 = clampIndex(this, end);
    this.eav();
  }
  aam(range) {
    this.xap(range.a2_1, range.b2_1 + 1 | 0);
  }
  oal() {
    this.xap(0, this.w5q().length);
  }
  zap() {
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.wap() - this.sal() | 0;
    return abs(this_0);
  }
  jal() {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.w5q();
    // Inline function 'kotlin.math.min' call
    var a = this.sal();
    var b = this.wap();
    var startIndex = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = this.sal();
    var b_0 = this.wap();
    var endIndex = Math.max(a_0, b_0);
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.substring(startIndex, endIndex);
  }
  kav(value) {
    this.aam(value);
  }
  kal() {
    // Inline function 'kotlin.math.min' call
    var a = this.sal();
    var b = this.wap();
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = this.sal();
    var b_0 = this.wap();
    var tmp$ret$1 = Math.max(a_0, b_0);
    return until(tmp, tmp$ret$1);
  }
  lav(index) {
    var glyphPositions = this.lak_1.mav().d4w_1;
    if (glyphPositions.g1())
      return Bezier.e3c(Vector2D.y27(), Vector2D.y27());
    // Inline function 'kotlin.math.min' call
    var b = glyphPositions.e1() - 1 | 0;
    var tmp$ret$0 = Math.min(index, b);
    var glyph = glyphPositions.d1(tmp$ret$0);
    return index < glyphPositions.e1() ? glyph.w4v() : glyph.x4v();
  }
  oas(pos) {
    var glyphPositions = this.lak_1.mav().d4w_1;
    var index = 0;
    var minDist = Infinity;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!glyphPositions.g1()) {
      var inductionVariable = 0;
      var last = glyphPositions.e1();
      if (inductionVariable <= last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.math.min' call
          var a = glyphPositions.e1() - 1 | 0;
          var b = n;
          var tmp$ret$1 = Math.min(a, b);
          var glyph = glyphPositions.d1(tmp$ret$1);
          var dist = glyph.a4w(pos);
          if (minDist > dist) {
            minDist = dist;
            index = n >= (glyphPositions.e1() - 1 | 0) && !(dist === 0.0) && glyph.z4v(pos, false) < glyph.z4v(pos, true) ? n + 1 | 0 : n;
          }
        }
         while (!(n === last));
    }
    return index;
  }
  eav() {
    var range = this.kal();
    var array = new PointArrayList(range.g1() ? 2 : imul(get_length(range) + 1 | 0, 2));
    if (range.g1()) {
      var last = range.a2_1 >= this.w5q().length;
      var caret = this.lav(range.a2_1);
      var sign = last ? -1.0 : +1.0;
      // Inline function 'korlibs.math.geom.Vector2D.times' call
      var this_0 = caret.d39(Companion_getInstance_37().kx_1);
      var scale = 2.0 * sign;
      var normal = Vector2D.n27(this_0.e25_1 * scale, this_0.f25_1 * scale);
      var p0 = caret.u39_1.r2l();
      var p1 = caret.u39_1.s2l();
      array.i2r(p0);
      array.i2r(p1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var tmp$ret$1 = Vector2D.n27(p0.e25_1 + normal.e25_1, p0.f25_1 + normal.f25_1);
      array.i2r(tmp$ret$1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var tmp$ret$2 = Vector2D.n27(p1.e25_1 + normal.e25_1, p1.f25_1 + normal.f25_1);
      array.i2r(tmp$ret$2);
    } else {
      var inductionVariable = range.a2_1;
      var last_0 = range.b2_1 + 1 | 0;
      if (inductionVariable <= last_0)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var caret_0 = this.lav(n);
          array.i2r(caret_0.u39_1.r2l());
          array.i2r(caret_0.u39_1.s2l());
        }
         while (!(n === last_0));
    }
    this.zak_1.e4e(Colors_getInstance().s3y_1);
    this.zak_1.nav(listOf(array));
    this.zak_1.l8j(get_focused(this));
    this.lak_1.r9t();
  }
  mal(selection, index) {
    if (selection) {
      this.yap(index);
    } else {
      this.ral(index);
    }
  }
  oav(index, direction, word) {
    var dir = get_sign(direction);
    if (word) {
      var sidx = index + dir | 0;
      var idx = sidx;
      while (true) {
        if (!(0 <= idx ? idx <= (charSequenceLength(this.w5q()) - 1 | 0) : false)) {
          return dir < 0 ? idx - dir | 0 : idx;
        }
        if (!isLetterOrDigit(charSequenceGet(this.w5q(), idx))) {
          return dir < 0 ? idx === sidx ? idx : idx - dir | 0 : idx;
        }
        idx = idx + dir | 0;
      }
    }
    return index + dir | 0;
  }
  ual(index, word) {
    return this.oav(index, -1, word);
  }
  wal(index, word) {
    return this.oav(index, 1, word);
  }
  pav() {
    return this.fal_1;
  }
  qav() {
    return true;
  }
  rav(value) {
    var tmp0_safe_receiver = this.oak_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.las_1 = value;
    }
    if (value) {
      this.zak_1.l8j(true);
      var tmp1_safe_receiver = this.b9u();
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_uiFocusManager(tmp1_safe_receiver);
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.vav(true, this);
      }
    } else {
      this.zak_1.l8j(false);
      var tmp5_safe_receiver = this.b9u();
      var tmp = tmp5_safe_receiver == null ? null : get_uiFocusedView(tmp5_safe_receiver);
      if (!(!(tmp == null) ? isInterface(tmp, ISoftKeyboardConfig) : false)) {
        var tmp3_safe_receiver = this.b9u();
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : get_uiFocusManager(tmp3_safe_receiver);
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.vav(false, null);
        }
      }
    }
    if (value) {
      this.uak_1.z1v(this);
    } else {
      this.vak_1.z1v(this);
    }
  }
  tal(_this__u8e3s4) {
    return Companion_getInstance_38().eu().bu() ? _this__u8e3s4.n68_1 : _this__u8e3s4.m68_1;
  }
  val(_this__u8e3s4) {
    return _this__u8e3s4.o68_1 && Companion_getInstance_38().eu().bu();
  }
  pal(_this__u8e3s4) {
    return _this__u8e3s4.s68();
  }
  c6() {
    set_cursor(this.lak_1, null);
    cancel_0(this.qak_1);
    set_focusable(this.lak_1, null);
  }
}
class TimerComponents {
  constructor(view) {
    this.yau_1 = view;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.zau_1 = ArrayList.h1();
    this.aav_1 = IntArrayList.n2j();
    this.bav_1 = IntArrayList.n2j();
    this.cav_1 = null;
  }
  dav(time, callback) {
    return this.yav(get_fast(time), callback);
  }
  yav(time, callback) {
    return _interval(this, time, true, callback);
  }
}
class TimerRef {
  constructor(index) {
    this.xav_1 = index;
  }
  toString() {
    return TimerRef__toString_impl_8hh2j7(this.xav_1);
  }
  hashCode() {
    return TimerRef__hashCode_impl_d9ou9o(this.xav_1);
  }
  equals(other) {
    return TimerRef__equals_impl_2fvpr4(this.xav_1, other);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.t1u() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.t1u() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.zav_1 = view;
    this.aaw_1 = vs;
    this.baw_1 = fastTime;
    this.caw_1 = easing;
    this.daw_1 = callback;
    this.eaw_1 = c;
    this.faw_1 = fastWaitTime;
    this.gaw_1 = autoInvalidate;
    this.haw_1 = Companion_instance_1.s1u();
    var tmp = this;
    var tmp_0;
    if (!equals(this.baw_1, Companion_instance_1.t1u())) {
      tmp_0 = this.baw_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.aaw_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.q8e_1);
        destination.h(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.iaw_1 = tmp_0;
    this.jaw_1 = false;
    this.kaw_1 = false;
    this.law_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.maw_1 = this.zav_1.o66(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.eaw_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.r17(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.s1u());
  }
  taw() {
    return get_slow(this.faw_1);
  }
  uaw() {
    if (this.law_1)
      return Unit_instance;
    this.law_1 = true;
    var tmp0_safe_receiver = this.eaw_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.oc(tmp$ret$0);
    }
  }
  saw() {
    if (this.kaw_1)
      return Unit_instance;
    this.kaw_1 = true;
    var tmp0_safe_receiver = this.maw_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c6();
    }
    this.maw_1 = null;
    this.uaw();
  }
  naw(elapsed) {
    if (equals(elapsed, Companion_instance_1.s1u())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.aaw_1;
      var n = 0;
      while (n < this_0.e1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.d1(_unary__edvuaz).s35();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.aaw_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.d1(_unary__edvuaz_0);
      var durationInTween = equals(v.o8e_1, Companion_instance_1.t1u()) ? FastDuration__minus_impl_evs237(this.iaw_1, v.n8e_1) : v.o8e_1;
      var elapsedInTween = get_fastMilliseconds(clamp_1(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.n8e_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7_0(durationInTween, Companion_getInstance().lj_1) <= 0 || FastDuration__compareTo_impl_4fhnj7(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.caw_1.ex(ratioInTween);
      v.u8e(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.zav_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.vaw_1 = $this_tween;
    this.waw_1 = $tc;
    this.xaw_1 = $vs;
    this.yaw_1 = $time;
    this.zaw_1 = $easing;
    this.aax_1 = $callback;
    this.bax_1 = $waitTime;
    this.cax_1 = $autoInvalidate;
  }
  w1n($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this, $this$withTimeoutNullable), $completion);
  }
  qd(p1, $completion) {
    return this.w1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_19 = this;
    this.hax_1 = get_UI_DEFAULT_SIZE();
  }
}
class UIButton$slambda {
  constructor($$this$mouse, this$0) {
    this.kb7_1 = $$this$mouse;
    this.lb7_1 = this$0;
  }
  mb7(it, $completion) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    this.kb7_1;
    this.lb7_1.nb7();
  }
  qd(p1, $completion) {
    return this.mb7(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$lambda$slambda {
  constructor($handler, $it) {
    this.dax_1 = $handler;
    this.eax_1 = $it;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this), $completion);
  }
}
class UIButton$slambda_0 {
  constructor($$this$mouse, this$0) {
    this.ob7_1 = $$this$mouse;
    this.pb7_1 = this$0;
  }
  mb7(it, $completion) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    this.ob7_1;
    this.pb7_1.qb7();
  }
  qd(p1, $completion) {
    return this.mb7(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$lambda$slambda_0 {
  constructor($handler, $it) {
    this.fax_1 = $handler;
    this.gax_1 = $it;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_21.bind(VOID, this), $completion);
  }
}
class UIButton$slambda_1 {
  constructor(this$0) {
    this.rb7_1 = this$0;
  }
  u9u(it, $completion) {
    if (get_focused(this.rb7_1)) {
      this.rb7_1.mb4(0.5, 0.5);
    }
  }
  qd(p1, $completion) {
    return this.u9u(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$slambda_2 {
  constructor(this$0, $$this$keys) {
    this.sb7_1 = this$0;
    this.tb7_1 = $$this$keys;
  }
  u9u(it, $completion) {
    if (this.sb7_1.rb0_1) {
      this.sb7_1.jb7();
      this.sb7_1.ub7(this.tb7_1.v9u());
    }
  }
  qd(p1, $completion) {
    return this.u9u(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class UIFocusableView extends UIView {
  static wb7(size, cache) {
    size = size === VOID ? Size2D.l26(90, 32) : size;
    cache = cache === VOID ? false : cache;
    var $this = this.wac(size, cache);
    $this.hb7_1 = 0;
    $this.ib7_1 = true;
    return $this;
  }
  fav(_this__u8e3s4) {
    return this;
  }
  pav() {
    return this.hb7_1;
  }
  qav() {
    return this.ib7_1;
  }
  rav(value) {
  }
}
class UIButton extends UIFocusableView {
  static vb7(size, text, icon, richText) {
    Companion_getInstance_44();
    size = size === VOID ? Companion_getInstance_44().hax_1 : size;
    text = text === VOID ? '' : text;
    icon = icon === VOID ? null : icon;
    richText = richText === VOID ? null : richText;
    var $this = this.wb7(size);
    $this.eb0_1 = false;
    $this.fb0_1 = Companion_getInstance_37().ox_1;
    $this.gb0_1 = 6.0;
    $this.hb0_1 = MaterialColors_getInstance().z4g_1;
    $this.ib0_1 = MaterialColors_getInstance().a4h_1;
    $this.jb0_1 = MaterialColors_getInstance().b4h_1;
    $this.kb0_1 = Colors_getInstance().k4e('#777777ff');
    $this.lb0_1 = true;
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiMaterialLayer' call
    // Inline function 'kotlin.apply' call
    var this_0 = addTo(UIMaterialLayer.xb7(size), $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.UIButton.background.<anonymous>' call
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_29();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    this_0.fb4(tmp$ret$0);
    tmp.mb0_1 = this_0;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.textBlock' call
    var text_0 = richText == null ? RichTextData.i5s(text, get_DefaultTtfFontAsBitmap()) : richText;
    var align = Companion_getInstance_3().y4w_1;
    var size_0 = Size2D.l26(100, 100);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = TextBlock.jbb(text_0, align, size_0);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.textBlock.<anonymous>' call
    tmp_0.nb0_1 = addTo(this_1, $this);
    $this.ob0_1 = align$factory($this.nb0_1);
    var tmp_1 = $this;
    // Inline function 'korlibs.korge.view.image' call
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var texture = get_Bitmaps_transparent();
    var anchor = Companion_getInstance_26().f24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Image.ubd(texture, anchor);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp_1.pb0_1 = addTo(this_2, $this);
    $this.qb0_1 = false;
    $this.rb0_1 = false;
    var tmp_2 = $this;
    var tmp0_defaultEasing = Companion_getInstance_36().hx_1;
    tmp_2.sb0_1 = animator($this, VOID, VOID, tmp0_defaultEasing, true);
    var tmp_3 = $this;
    var tmp0_defaultEasing_0 = Companion_getInstance_36().hx_1;
    tmp_3.tb0_1 = animator($this, VOID, VOID, tmp0_defaultEasing_0, true);
    $this.ub0_1 = text$factory($this.nb0_1);
    $this.vb0_1 = icon;
    $this.wb0_1 = new Signal();
    singleTouch($this, VOID, VOID, UIButton$lambda($this));
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$mouse = get_mouse($this);
    // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
    var handler = UIButton$slambda_3($this$mouse, $this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_4 = over$factory().get($this$mouse);
    tmp_4.x1v(UIButton$lambda_0($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
    var handler_0 = UIButton$slambda_4($this$mouse, $this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_5 = out$factory().get($this$mouse);
    tmp_5.x1v(UIButton$lambda_1($this$mouse, handler_0));
    set_cursor($this, Cursor_HAND_getInstance());
    setInitialState($this);
    $this.xb0_1 = false;
    $this.vbd(false, false, VOID, VOID, true);
    $this.yb0_1 = 0.0;
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.UIButton.<anonymous>' call
    var $this$keys = get_keys($this);
    var tmp_6 = [Key_SPACE_getInstance(), Companion_getInstance_15().s6d_1];
    $this$keys.y9u(tmp_6, UIButton$slambda_5($this));
    var tmp_7 = [Key_SPACE_getInstance(), Companion_getInstance_15().s6d_1];
    $this$keys.a9v(tmp_7, UIButton$slambda_6($this, $this$keys));
    return $this;
  }
  zb0() {
    return !isNaN_0(this.gb0_1) ? this.gb0_1 : _Ratio___get_value__impl__57cli6(this.fb0_1) * _get_halfSide__37ya73(this);
  }
  lb4() {
    return super.lb4();
  }
  yac() {
    setInitialState(this);
  }
  nb7() {
    if (this.qb0_1)
      return Unit_instance;
    this.qb0_1 = true;
    this.vbd(VOID, true);
  }
  qb7() {
    if (!this.qb0_1)
      return Unit_instance;
    this.qb0_1 = false;
    this.vbd(VOID, false);
  }
  mb4(x, y) {
    return this.wbd(Vector2D.n27(x, y));
  }
  wbd(p) {
    if (this.rb0_1)
      return Unit_instance;
    this.rb0_1 = true;
    this.vbd(true, VOID, VOID, p);
  }
  jb7() {
    if (!this.rb0_1)
      return Unit_instance;
    this.rb0_1 = false;
    this.vbd(false);
  }
  ub7(views) {
    get_touch(this).l9y(views, this.rai(Vector2D.n27(this.m2i() * 0.5, this.n2i() * 0.5)));
  }
  xbd(down, over, enable, pos, immediate) {
    if (this.lb4() && !(down == null)) {
      if (down) {
        this.mb0_1.zbd(pos);
      } else {
        this.mb0_1.ybd();
      }
    }
    var bgColor = enable === false || !this.lb4() ? this.kb0_1 : over === true ? this.ib0_1 : this.xb0_1 ? this.jb0_1 : this.hb0_1;
    if (immediate) {
      this.mb0_1.abe(bgColor);
    } else {
      // Inline function 'korlibs.korge.tween.get' call
      var this_0 = bgColor$factory(this.mb0_1);
      var tmp = this_0.get();
      var tmp_0 = [new V2(this_0, tmp, new RGBA(bgColor), _interpolateColor$ref(), false)];
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$1 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
      tween(this.sb0_1, tmp_0, tmp$ret$1);
    }
  }
  vbd(down, over, enable, pos, immediate, $super) {
    down = down === VOID ? null : down;
    over = over === VOID ? null : over;
    enable = enable === VOID ? null : enable;
    pos = pos === VOID ? Companion_getInstance_28().g25_1 : pos;
    immediate = immediate === VOID ? false : immediate;
    var tmp;
    if ($super === VOID) {
      this.xbd(down, over, enable, pos, immediate);
      tmp = Unit_instance;
    } else {
      tmp = $super.xbd.call(this, down, over, enable, pos, immediate);
    }
    return tmp;
  }
  gad() {
    super.gad();
    this.vbd(VOID, VOID, VOID, VOID, true);
  }
  rav(value) {
    this.vbd(VOID, value);
  }
}
class Scope {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.gbe_1 = function_0;
  }
  ui(a, b) {
    return this.gbe_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  k4() {
    return this.gbe_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class UIFocusManager {
  constructor(view) {
    this.sav_1 = view;
    this.tav_1 = this.sav_1;
    this.uav_1 = null;
    var tmp = Type_DOWN_getInstance_0();
    this.sav_1.o66(tmp, UIFocusManager$lambda(this));
  }
  d9x() {
    return this.tav_1.d9x();
  }
  ibe() {
    return this.sav_1.ibe();
  }
  fbe(value) {
    if (equals(this.uav_1, value))
      return Unit_instance;
    var tmp0_safe_receiver = this.uav_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rav(false);
    }
    this.uav_1 = value;
    var tmp1_safe_receiver = this.uav_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.rav(true);
    }
    if (!(value == null)) {
      this.d9x().jbe(_get_rfocusView__qys03k(value, this), true);
    }
  }
  vav(show, view) {
    if (show) {
      if (view == null)
        null;
      else {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.ui.UIFocusManager.requestToggleSoftKeyboard.<anonymous>' call
        this.ibe().v8i(view.fav(Scope_instance).aaj(this.tav_1).a2e());
      }
      var tmp = this.ibe();
      tmp.x8i(VOID, (view == null ? true : isInterface(view, ISoftKeyboardConfig)) ? view : null);
    } else {
      this.ibe().y8i();
    }
  }
  hbe(dir) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = descendantsWith(this.tav_1, VOID, UIFocusManager$changeFocusIndex$lambda);
    var destination = ArrayList.h1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      var tmp0_safe_receiver = get_focusable(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    var focusables = destination;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = UIFocusManager$changeFocusIndex$lambda_0;
    var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp);
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = sortedWith(focusables, tmp$ret$4);
    var destination_0 = ArrayList.h1();
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      if (element_0.qav()) {
        destination_0.h(element_0);
      }
    }
    var sortedFocusables = destination_0;
    // Inline function 'kotlin.takeIf' call
    var this_2 = indexOf(sortedFocusables, this.uav_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
    if (this_2 >= 0) {
      tmp_0 = this_2;
    } else {
      tmp_0 = null;
    }
    var index = tmp_0;
    var tmp0_safe_receiver_0 = getCyclicOrNull(sortedFocusables, !(index == null) ? index + dir | 0 : dir < 0 ? -1 : 0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      focus(tmp0_safe_receiver_0);
      scrollParentsToMakeVisible(_get_rfocusView__qys03k(tmp0_safe_receiver_0, this));
    }
  }
}
class Highlight {
  constructor(pos, radiusRatio, alpha, below, scale) {
    below = below === VOID ? false : below;
    scale = scale === VOID ? 1.0 : scale;
    this.nbe_1 = pos;
    this.obe_1 = radiusRatio;
    this.pbe_1 = alpha;
    this.qbe_1 = below;
    this.rbe_1 = scale;
  }
}
class Highlights {
  constructor(view) {
    this.kbe_1 = view;
    this.lbe_1 = fastArrayListOf([]);
    this.mbe_1 = fastArrayListOf([]);
  }
  sbe(pos, below, scale, startRadius) {
    this.ybd();
    var highlight = new Highlight(pos, startRadius, 1.0, below, scale);
    // Inline function 'kotlin.collections.plusAssign' call
    this.lbe_1.h(highlight);
    // Inline function 'kotlin.collections.plusAssign' call
    this.mbe_1.h(highlight);
    var tmp = get_simpleAnimator(this.kbe_1);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = radiusRatio$factory(highlight);
    var tmp_0 = this_0.get();
    var tmp_1 = new V2(this_0, tmp_0, 1.0, _interpolate$ref(), false);
    var tmp_2 = [tmp_1, V2Callback(VOID, UIMaterialLayer$Highlights$addHighlight$lambda(this))];
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(0.5, DurationUnit_SECONDS_getInstance());
    tween(tmp, tmp_2, tmp$ret$1, get_EASE_IN(Companion_getInstance_36()));
    return highlight;
  }
  tbe(highlight) {
    // Inline function 'korlibs.korge.animate.Animator.sequence' call
    var this_0 = get_simpleAnimator(this.kbe_1);
    var defaultTime = this_0.t9t();
    var defaultSpeed = this_0.s9s_1;
    var easing = this_0.t9s_1;
    var startImmediately = this_0.z9s_1;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var tmp0_root = this_0.q9s_1;
    var tmp1_fastDefaultTime = get_fast(defaultTime);
    var tmp2_level = this_0.y9s_1 + 1 | 0;
    var this_1 = new Animator(tmp0_root, tmp1_fastDefaultTime, defaultSpeed, easing, false, false, this_0, VOID, tmp2_level, startImmediately);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.Animator.sequence.<anonymous>' call
    // Inline function 'korlibs.korge.ui.Highlights.removeHighlight.<anonymous>' call
    var tmp;
    if (highlight.qbe_1) {
      // Inline function 'korlibs.korge.tween.get' call
      var this_2 = radiusRatio$factory_0(highlight);
      var tmp_0 = this_2.get();
      tmp = new V2(this_2, tmp_0, 0.0, _interpolate$ref_0(), false);
    } else {
      // Inline function 'korlibs.korge.tween.get' call
      var this_3 = alpha$factory(highlight);
      var tmp_1 = this_3.get();
      tmp = new V2(this_3, tmp_1, 0.0, _interpolate$ref_1(), false);
    }
    var tmp_2 = tmp;
    var tmp_3 = [tmp_2, V2Callback(VOID, UIMaterialLayer$Highlights$removeHighlight$lambda(this))];
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration(0.3, DurationUnit_SECONDS_getInstance());
    tween(this_1, tmp_3, tmp$ret$2, get_EASE_IN(Companion_getInstance_36()));
    block(this_1, VOID, UIMaterialLayer$Highlights$removeHighlight$lambda_0(this, highlight));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.Animator.sequence.<anonymous>' call
    this_0.v9t(this_1.g9t_1);
    this.mbe_1.j3(highlight);
  }
  ube(highlights) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = toList_0(highlights);
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.ui.Highlights.removeHighlights.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      this.tbe(it);
    }
  }
  ybd() {
    this.ube(this.mbe_1);
  }
}
class UIMaterialLayer extends UIView {
  static xb7(size) {
    size = size === VOID ? Size2D.l26(100, 100) : size;
    var $this = this.wac(size);
    $this.ub3_1 = Colors_getInstance().s3y_1;
    $this.vb3_1 = null;
    $this.wb3_1 = null;
    $this.xb3_1 = Colors_getInstance().t3y_1;
    $this.yb3_1 = 0.0;
    $this.zb3_1 = RGBA__withAf_impl_dpdu32(Colors_getInstance().t3y_1, 0.3);
    $this.ab4_1 = 10.0;
    $this.bb4_1 = Companion_getInstance_28().g25_1;
    $this.cb4_1 = RGBA__withAd_impl_cralao(Colors_getInstance().s3y_1, 0.4);
    $this.db4_1 = new Highlights($this);
    $this.eb4_1 = Companion_getInstance_26().f24_1;
    return $this;
  }
  abe(value) {
    this.ub3_1 = value;
    this.r9t();
  }
  fb4(value) {
    this.vb3_1 = value;
    this.r9t();
  }
  gb4(value) {
    this.ab4_1 = value;
    this.r9t();
  }
  vbe(value) {
    if (!this.eb4_1.equals(value)) {
      this.eb4_1 = value;
      this.kai();
    }
  }
  tag() {
    return this.m2i() * this.eb4_1.o24_1;
  }
  uag() {
    return this.n2i() * this.eb4_1.p24_1;
  }
  ead() {
    return new Rectangle(-this.tag(), -this.uag(), this.m2i(), this.n2i());
  }
  had(ctx) {
    if (!this.dai())
      return Unit_instance;
    // Inline function 'korlibs.korge.render.renderCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var batcher = ctx.b81_1;
    if (!(ctx.f81_1 === batcher)) {
      ctx.f81_1 = batcher;
      ctx.p82();
    }
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
    // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
    var context = ctx.d81_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
    $l$block_3: {
      // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
      var old = context.x8b_1;
      try {
        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
        $l$block_2: {
          // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
          var oldBlendFactors = context.y8b_1;
          try {
            // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
              var multiplyColor = context.z8b_1;
              try {
                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                $l$block_0: {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                  var filtering = context.a8c_1;
                  try {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    $l$block: {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                      var size = context.v8b_1;
                      try {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        context.v8b_1 = Size2D.b2e(this.m2i(), this.n2i());
                        context.y8b_1 = this.hai();
                        context.z8b_1 = this.iai();
                        context.b8c(this.g9v());
                        this.wbe(context, true);
                        materialRoundRect(context, -this.tag(), -this.uag(), this.m2i(), this.n2i(), this.ub3_1, _get_computedRadius__cigsus(this), this.bb4_1, this.zb3_1, this.ab4_1, VOID, VOID, VOID, this.yb3_1, this.xb3_1);
                        this.wbe(context, false);
                        break $l$block;
                      }finally {
                        context.v8b_1 = size;
                      }
                    }
                    break $l$block_0;
                  }finally {
                    context.a8c_1 = filtering;
                  }
                }
                break $l$block_1;
              }finally {
                context.z8b_1 = multiplyColor;
              }
            }
            break $l$block_2;
          }finally {
            context.y8b_1 = oldBlendFactors;
          }
        }
        break $l$block_3;
      }finally {
        context.x8b_1 = old;
      }
    }
  }
  wbe(ctx2d, below) {
    // Inline function 'korlibs.korge.ui.Highlights.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.db4_1.lbe_1.ly_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.ui.UIMaterialLayer.renderHighlights.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      if (below === it.qbe_1) {
        materialRoundRect(ctx2d, -this.tag() * it.rbe_1, -this.uag() * it.rbe_1, this.m2i() * it.rbe_1, this.n2i() * it.rbe_1, Colors_getInstance().x3y_1, _get_computedRadius__cigsus(this).t2d(it.rbe_1), VOID, VOID, VOID, it.nbe_1, it.obe_1 * this.jah(), RGBA__withAd_impl_cralao(this.cb4_1, _RGBA___get_ad__impl__pt5rdj(this.cb4_1) * it.pbe_1));
      }
    }
  }
  sbe(pos, below, scale, startRadius) {
    return this.db4_1.sbe(pos, below, scale, startRadius);
  }
  zbd(pos, below, scale, startRadius, $super) {
    below = below === VOID ? false : below;
    scale = scale === VOID ? 1.0 : scale;
    startRadius = startRadius === VOID ? 0.0 : startRadius;
    return $super === VOID ? this.sbe(pos, below, scale, startRadius) : $super.sbe.call(this, pos, below, scale, startRadius);
  }
  ybd() {
    this.db4_1.ybd();
  }
}
class UIScrollable extends UIView {
  wbh() {
    return this.n2i() * this.vbh_1;
  }
  xbh() {
    return this.m2i() * this.vbh_1;
  }
  ybh() {
    return this.wbh();
  }
  zbh() {
    return this.wbh();
  }
  abi() {
    return this.xbh();
  }
  bbi() {
    return this.xbh();
  }
  cbi(rect, anchor) {
    this.ubh_1.nbi(rect.v25(), rect.w25(), anchor.o24_1);
    this.tbh_1.nbi(rect.x25(), rect.y25(), anchor.p24_1);
  }
  obi(view, anchor) {
    this.cbi(view.iaj(this), anchor);
    scrollParentsToMakeVisible(this);
  }
  pbi(view, anchor, $super) {
    anchor = anchor === VOID ? Companion_getInstance_26().r24() : anchor;
    var tmp;
    if ($super === VOID) {
      this.obi(view, anchor);
      tmp = Unit_instance;
    } else {
      tmp = $super.obi.call(this, view, anchor);
    }
    return tmp;
  }
}
class ViewRenderer {}
class sam$korlibs_korge_view_ViewRenderer$0 {
  constructor(function_0) {
    this.sbi_1 = function_0;
  }
  tbi(_this__u8e3s4) {
    return this.sbi_1(_this__u8e3s4);
  }
  k4() {
    return this.sbi_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ViewRenderer) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class UITextInput extends UIView {
  static fbm(initialText, size) {
    initialText = initialText === VOID ? '' : initialText;
    size = size === VOID ? Size2D.l26(128, 24) : size;
    var $this = this.wac(size);
    $this.obl_1 = new SoftKeyboardConfig();
    var tmp = $this;
    // Inline function 'korlibs.korge.view.renderableView' call
    var viewRenderer = UITextInput$bg$lambda;
    tmp.pbl_1 = addTo(RenderableView.gbm(size, new sam$korlibs_korge_view_ViewRenderer$0(viewRenderer)), $this);
    $this.qbl_1 = viewRenderer$factory($this.pbl_1);
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.clipContainer' call
    var size_0 = Companion_getInstance_27().c2g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = ClipContainer.sbo(size_0);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.clipContainer.<anonymous>' call
    tmp_0.rbl_1 = addTo(this_0, $this);
    var tmp_1 = $this;
    // Inline function 'korlibs.korge.view.text' call
    var this_1 = $this.rbl_1;
    var color = Colors_getInstance().t3y_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_3().l4w_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance_26.ubo_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Text.vbo(initialText, numberToDouble(16.0), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    tmp_1.sbl_1 = addTo(this_2, this_1);
    $this.tbl_1 = new TextEditController($this.sbl_1, $this.sbl_1, $this, $this.pbl_1);
    $this.ubl_1 = text$factory_0($this.tbl_1);
    $this.vbl_1 = textSize$factory($this.tbl_1);
    $this.wbl_1 = font$factory($this.tbl_1);
    $this.xbl_1 = onReturnPressed$factory($this.tbl_1);
    $this.ybl_1 = onEscPressed$factory($this.tbl_1);
    $this.zbl_1 = onFocusLost$factory($this.tbl_1);
    $this.abm_1 = selectionRange$factory($this.tbl_1);
    $this.bbm_1 = selectionStart$factory($this.tbl_1);
    $this.cbm_1 = selectionEnd$factory($this.tbl_1);
    $this.dbm_1 = selectionLength$factory($this.tbl_1);
    var tmp_2 = $this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_30();
    tmp_2.ebm_1 = Margin.k28(numberToDouble(3.0), numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0));
    $this.yac();
    return $this;
  }
  lal(_set____db54di) {
    var this_0 = this.ubl_1;
    text$factory_1();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  w5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ubl_1;
    text$factory_2();
    return this_0.get();
  }
  yac() {
    size(this.pbl_1, this.m2i(), this.n2i());
    bounds(this.rbl_1, (new Rectangle(0.0, 0.0, this.m2i(), this.n2i())).l2e(this.ebm_1));
  }
}
class sam$korlibs_korge_view_ViewRenderer$0_0 {
  constructor(function_0) {
    this.wbo_1 = function_0;
  }
  tbi(_this__u8e3s4) {
    return this.wbo_1(_this__u8e3s4);
  }
  k4() {
    return this.wbo_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ViewRenderer) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_20 = this;
    this.hb4_1 = 90.0;
    this.ib4_1 = 32.0;
    this.jb4_1 = Size2D.w2d(90.0, 32.0);
  }
  kb4(iconView, bmp, width, height, anchor_0) {
    var iconScaleX = width / bmp.b3g_1;
    var iconScaleY = height / bmp.c3g_1;
    // Inline function 'kotlin.math.min' call
    var iconScale = Math.min(iconScaleX, iconScaleY);
    iconView.pbt(bmp);
    anchor(iconView, anchor_0);
    position(iconView, width * anchor_0.o24_1, height * anchor_0.p24_1);
    scale(iconView, iconScale, iconScale);
  }
}
class InternalViewAutoscaling {
  constructor() {
    this.ibz_1 = 1.0;
    this.jbz_1 = 1.0;
    this.kbz_1 = 1.0;
    this.lbz_1 = 1.0;
    this.mbz_1 = 1.0;
    this.nbz_1 = MatrixTransform.g2b();
  }
  obz(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.nbz_1 = globalMatrix.k2a();
      // Inline function 'kotlin.math.abs' call
      var x = this.nbz_1.y2a_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.nbz_1.z2a_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.kbz_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.lbz_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.kbz_1 = sx;
        this.lbz_1 = sy;
        this.mbz_1 = sxy;
        this.ibz_1 = 1.0 / sx;
        this.jbz_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.kbz_1 = 1.0;
      this.lbz_1 = 1.0;
      this.mbz_1 = 1.0;
      this.ibz_1 = 1.0;
      this.jbz_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static cc9(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().f24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.fcb();
    $this.xc1_1 = smoothing;
    $this.mc2(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.yc1_1 = get_Bitmaps_white();
    $this.zc1_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_17();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.ac2_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.bc2_1 = null;
    $this.cc2_1 = null;
    return $this;
  }
  jc2(v) {
    if (!(this.yc1_1 === v)) {
      this.yc1_1 = v;
      this.s9n_1 = true;
      this.r9t();
    }
  }
  vbe(v) {
    if (!this.zc1_1.equals(v)) {
      this.zc1_1 = v;
      this.s9n_1 = true;
      this.r9t();
    }
  }
  dc2() {
    return this.zc1_1;
  }
  vbz() {
    return 0.0;
  }
  wbz() {
    return 0.0;
  }
  tag() {
    return this.dc2().o24_1 * this.vbz();
  }
  uag() {
    return this.dc2().p24_1 * this.wbz();
  }
  ec2() {
    return -this.tag();
  }
  fc2() {
    return -this.uag();
  }
  had(ctx) {
    if (!this.dai())
      return Unit_instance;
    var tmp = this.yc1_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.s9n_1) {
      this.s9n_1 = false;
      this.lc2();
    }
    this.kc2(ctx);
  }
  kc2(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.b81_1;
    var this_1 = this_0.k81_1;
    if (!(this_1.f81_1 === this_0)) {
      this_1.f81_1 = this_0;
      this_1.p82();
    }
    var tmp0_safe_receiver = this.cc2_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.ac2_1;
    var tex = ctx.g8b(this.yc1_1).b3h();
    var smoothing = this.xc1_1;
    var blendMode = this.hai();
    var program = this.bc2_1;
    var vcount = array.l88_1;
    var icount = array.m88_1;
    var matrix = Companion_getInstance_33().y28_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.l85_1;
      this_0.e88(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_6().n87_1 : program;
      if (this_0.t88(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.v87();
      if (!contains(this_0.a82_1, tex_0)) {
        this_0.z81_1 = 0;
        this_0.a82_1[0] = tex_0;
      }
      this_0.b82_1 = smoothing;
      this_0.c82_1 = blendMode;
      this_0.d82_1 = pprogram;
    }
    this_0.q88(array, matrix, vcount, icount);
  }
  lc2() {
    this.ac2_1.t8d(0, this.ec2(), this.fc2(), this.vbz(), this.wbz(), this.g9v(), this.yc1_1, this.iai());
  }
  ead() {
    return Companion_getInstance_31().v2d(this.ec2(), this.fc2(), this.vbz(), this.wbz());
  }
  toString() {
    var out = super.toString();
    if (!this.dc2().equals(Companion_getInstance_26().f24_1))
      out = out + (':anchor=(' + this.qai(this.dc2().o24_1) + ', ' + this.qai(this.dc2().p24_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static pch(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().f24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.cc9(anchor, hitShape, smoothing);
    $this.nbt_1 = false;
    $this.obt_1 = bitmap;
    $this.gc2();
    return $this;
  }
  static qbz(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().f24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.pch(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  pbt(value) {
    if (equals(this.yc1_1, value))
      return Unit_instance;
    this.nbt_1 = true;
    this.jc2(value);
  }
  x5i() {
    return this.yc1_1;
  }
  gc2() {
    if (this.nbt_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  had(ctx) {
    this.gc2();
    super.had(ctx);
  }
  vbz() {
    return this.yc1_1.m2i();
  }
  wbz() {
    return this.yc1_1.n2i();
  }
  u3h() {
    return this.yc1_1.u3h();
  }
  v3h() {
    return this.yc1_1.v3h();
  }
  e3h() {
    return this.yc1_1.e3h();
  }
  f3h() {
    return this.yc1_1.f3h();
  }
  hc2() {
    return this.dc2().o24_1 * this.e3h();
  }
  ic2() {
    return this.dc2().p24_1 * this.f3h();
  }
  tag() {
    return this.hc2() - this.u3h();
  }
  uag() {
    return this.ic2() - this.v3h();
  }
  ead() {
    return Companion_getInstance_31().v2d(-this.hc2(), -this.ic2(), this.e3h(), this.f3h());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.x5i()));
  }
}
class BaseGraphics extends BaseImage {
  static pbz(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.qbz(tmp$ret$0);
    $this.rby_1 = autoScaling;
    $this.sby_1 = true;
    $this.tby_1 = false;
    $this.uby_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.vby_1 = ArrayList.h1();
    $this.wby_1 = new InternalViewAutoscaling();
    $this.xby_1 = 1;
    $this.yby_1 = true;
    $this.zby_1 = true;
    $this.abz_1 = null;
    $this.bbz_1 = 1.0;
    $this.cbz_1 = 1.0;
    $this.dbz_1 = true;
    $this.ebz_1 = true;
    $this.fbz_1 = Companion_getInstance_31().a29();
    $this.gbz_1 = Companion_getInstance_31().a29();
    return $this;
  }
  rbz(value) {
    this.sby_1 = value;
    this.sbz();
  }
  sbz() {
    this.yby_1 = true;
    this.zby_1 = true;
    this.kai();
  }
  fad() {
    super.fad();
    if (this.p23() == null || this.b9u() == null) {
      var tmp = this.x5i().b3h();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.vby_1.h(this.x5i().b3h());
      }
      clearBitmaps(this, true);
    }
  }
  had(ctx) {
    this.abz_1 = ctx;
    clearBitmaps(this, false);
    this.tbz();
    super.had(ctx);
  }
  tbz() {
    if (this.wby_1.obz(this.rby_1, this.tby_1, this.g9v())) {
      this.yby_1 = true;
    }
    if (!this.yby_1)
      return false;
    this.yby_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.vby_1.h(this.x5i().b3h());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.q25_1 * this.wby_1.kbz_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.r25_1 * this.wby_1.lbz_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.xby_1 | 0, imageHeight + this.xby_1 | 0, this.sby_1, true);
    this.bbz_1 = this.wby_1.kbz_1;
    this.cbz_1 = this.wby_1.lbz_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.p3x_1;
    if (true) {
      image.y3x();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.h45(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.m5h(this.bbz_1, this.cbz_1);
        ctx.q50(-boundsWithShapes.o25_1, -boundsWithShapes.p25_1);
        this.ubz(ctx);
      }finally {
        ctx.d18();
      }
    }finally {
      result = true ? image.a3y(rect) : 0;
    }
    this.pbt(slice(image));
    return true;
  }
  vbz() {
    return _get_bitmapWidth__ndy7bu(this) / this.bbz_1;
  }
  wbz() {
    return _get_bitmapHeight__5t1vx1(this) / this.cbz_1;
  }
  e3h() {
    return this.vbz();
  }
  f3h() {
    return this.wbz();
  }
  tag() {
    return this.dc2().o24_1 * this.vbz();
  }
  uag() {
    return this.dc2().p24_1 * this.wbz();
  }
  ec2() {
    return _getLocalBoundsInternal(this, this.dbz_1).o25_1;
  }
  fc2() {
    return _getLocalBoundsInternal(this, this.dbz_1).p25_1;
  }
  ead() {
    return _getLocalBoundsInternal$default(this);
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.tc2_1 = $outer;
    this.pc2_1 = ctx;
    this.qc2_1 = this.pc2_1.k8b(16, 16, VOID, VOID, VOID, false);
    this.rc2_1 = TextureBase.o85(this.qc2_1.t6k(), 16, 16);
    this.sc2_1 = Texture(this.rc2_1);
  }
  uc2(width, height) {
    this.qc2_1.v6k(0, 0, width, height);
    this.rc2_1.p85(width);
    this.rc2_1.q85(height);
    this.sc2_1 = Texture(this.rc2_1);
  }
  c6() {
    this.tc2_1.saf_1 = null;
    this.pc2_1.l8b(this.qc2_1);
  }
}
class FixedSizeContainer extends Container {
  static gc5(size, clip) {
    size = size === VOID ? Size2D.l26(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.na3();
    $this.dc5_1 = clip;
    $this.ec5_1 = size;
    $this.fc5_1 = Ref(false);
    return $this;
  }
  o5z() {
    return this.dc5_1;
  }
  bad(_set____db54di) {
    this.ec5_1 = _set____db54di;
  }
  cad() {
    return this.ec5_1;
  }
  ead() {
    return new Rectangle(0.0, 0.0, this.m2i(), this.n2i());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.m2i()) + 'x' + get_niceStr(this.n2i()) + ')');
    return out;
  }
  had(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.o5z();
      var renderingInternalRef = this.fc5_1;
      if (renderingInternalRef.r1()) {
        super.had(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.g9v();
        var hasRotation = !(m.d29_1 === 0.0) || !(m.e29_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.r1();
          try {
            renderingInternalRef.s2q(true);
            renderFiltered(this, ctx, Companion_getInstance_58());
          }finally {
            renderingInternalRef.s2q(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.b81_1;
        if (!(ctx.f81_1 === batcher)) {
          ctx.f81_1 = batcher;
          ctx.p82();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.d81_1;
        var bounds = this.caj(ctx).x2e(ctx.r80_1).y2e();
        var rect = c2d.t8b_1.b88().a6r();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.m2e(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_16().v6q(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.t8b_1;
            var scissor_0 = c2d.g8c(scissor);
            var temp = this_0.i82_1;
            this_0.r88();
            this_0.i82_1 = scissor_0;
            try {
              super.had(ctx);
              break $l$block_1;
            }finally {
              this_0.r88();
              this_0.i82_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.had(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.had(ctx);
      }
    }
  }
}
class ClipContainer extends FixedSizeContainer {
  static sbo(size) {
    size = size === VOID ? Size2D.l26(100, 100) : size;
    return this.gc5(size, true);
  }
}
class ZIndexComparator {
  hc5(a, b) {
    return compareTo(a.hah(), b.hah());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.hc5(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.nc5_1 = this$0;
    this.mc5_1 = 0;
  }
  b1() {
    return this.mc5_1 < this.nc5_1.kc5_1.cag();
  }
  c1() {
    var _unary__edvuaz = this.mc5_1;
    this.mc5_1 = _unary__edvuaz + 1 | 0;
    return this.nc5_1.kc5_1.fag(_unary__edvuaz);
  }
  g6() {
    this.mc5_1 = this.mc5_1 - 1 | 0;
    this.nc5_1.kc5_1.gag(this.mc5_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.jc5_1 = children;
    this.kc5_1 = container;
  }
  e1() {
    return this.kc5_1.cag();
  }
  oc5(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.p23() === this.kc5_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  x2(elements) {
    return this.oc5(elements);
  }
  g1() {
    return this.kc5_1.cag() === 0;
  }
  pc5(element) {
    this.kc5_1.jag(element);
    return true;
  }
  h(element) {
    return this.pc5(element instanceof View ? element : THROW_CCE());
  }
  qc5(elements) {
    if (elements.g1())
      return false;
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.kc5_1.jag(element);
    }
    return true;
  }
  f1(elements) {
    return this.qc5(elements);
  }
  a1() {
    return new ContainerCollection$iterator$1(this);
  }
  rc5(element) {
    return this.kc5_1.rag(element);
  }
  j3(element) {
    if (!(element instanceof View))
      return false;
    return this.rc5(element instanceof View ? element : THROW_CCE());
  }
  d1(index) {
    return this.jc5_1.d1(index);
  }
  sc5(element) {
    return this.jc5_1.l1(element);
  }
  l1(element) {
    if (!(element instanceof View))
      return -1;
    return this.sc5(element instanceof View ? element : THROW_CCE());
  }
  y2() {
    return this.jc5_1.y2();
  }
  i1(index) {
    return this.jc5_1.i1(index);
  }
  z2(fromIndex, toIndex) {
    return this.jc5_1.z2(fromIndex, toIndex);
  }
}
class CpuGraphics extends BaseGraphics {
  static zc8(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.pbz(autoScaling);
    $this.rc8_1 = 0;
    $this.sc8_1 = null;
    $this.tc8_1 = true;
    $this.uc8_1 = -1;
    $this.vc8_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.wc8_1 = ArrayList.h1();
    $this.xc8_1 = null;
    $this.yc8_1 = null;
    $this.c9o_1 = true;
    return $this;
  }
  ac9(value) {
    this.sc8_1 = value;
    this.rc8_1 = this.rc8_1 + 1 | 0;
    this.sbz();
  }
  mc2(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.yc8_1 = tmp_0;
  }
  vag() {
    var tmp0_safe_receiver = this.wag();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  wag() {
    if (!(this.yc8_1 == null))
      return this.yc8_1;
    if (!(this.uc8_1 === this.rc8_1)) {
      this.uc8_1 = this.rc8_1;
      this.wc8_1.h3();
      var tmp = this.wc8_1;
      var tmp0_safe_receiver = this.sc8_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c52();
      tmp.h(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.wc8_1;
  }
  ubz(ctx) {
    var tmp0_safe_receiver = this.sc8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j51(ctx);
    }
  }
  hbz(includeStrokes) {
    var tmp0_safe_receiver = this.sc8_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g5z(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_31().a26_1 : tmp1_elvis_lhs;
  }
}
class CustomContextRenderizableView extends RectBase {
  static bc9(size) {
    var $this = this.cc9();
    $this.dbr_1 = size;
    return $this;
  }
  bad(value) {
    if (!this.dbr_1.equals(value)) {
      this.dbr_1 = value;
      this.s9n_1 = true;
    }
  }
  cad() {
    return this.dbr_1;
  }
  gbr() {
    var tmp = this.fbr_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('ctx2d');
    }
  }
  had(ctx) {
    if (!this.dai())
      return Unit_instance;
    this.ebr_1 = ctx;
    // Inline function 'korlibs.korge.render.renderCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var batcher = ctx.b81_1;
    if (!(ctx.f81_1 === batcher)) {
      ctx.f81_1 = batcher;
      ctx.p82();
    }
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
    // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
    var context = ctx.d81_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
    $l$block_3: {
      // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
      var old = context.x8b_1;
      try {
        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
        $l$block_2: {
          // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
          var oldBlendFactors = context.y8b_1;
          try {
            // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
              var multiplyColor = context.z8b_1;
              try {
                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                $l$block_0: {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                  var filtering = context.a8c_1;
                  try {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    $l$block: {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                      var size = context.v8b_1;
                      try {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        context.v8b_1 = Size2D.b2e(this.m2i(), this.n2i());
                        context.y8b_1 = this.hai();
                        context.z8b_1 = this.iai();
                        context.b8c(this.g9v());
                        this.fbr_1 = context;
                        this.dc9(context, Size2D.b2e(this.m2i(), this.n2i()));
                        break $l$block;
                      }finally {
                        context.v8b_1 = size;
                      }
                    }
                    break $l$block_0;
                  }finally {
                    context.a8c_1 = filtering;
                  }
                }
                break $l$block_1;
              }finally {
                context.z8b_1 = multiplyColor;
              }
            }
            break $l$block_2;
          }finally {
            context.y8b_1 = oldBlendFactors;
          }
        }
        break $l$block_3;
      }finally {
        context.x8b_1 = old;
      }
    }
  }
}
class DummyView extends View {
  static ecb() {
    return this.fcb();
  }
  had(ctx) {
    return Unit_instance;
  }
}
class Companion_6 {}
class SContainer extends FixedSizeContainer {
  static ba6(size, clip) {
    size = size === VOID ? Size2D.l26(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.gc5(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.hcb_1 = capacity;
    this.icb_1 = IntDeque.g2m(this.hcb_1);
    this.jcb_1 = 0;
  }
  e1() {
    return this.icb_1.e1();
  }
  kcb() {
    return this.icb_1.e1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.jcb_1 / this.icb_1.e1());
  }
  lcb() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.kcb());
  }
  mcb(index) {
    return get_fastMicroseconds_0(this.icb_1.d1(index));
  }
  ncb(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.icb_1.l2m(intValue);
    this.jcb_1 = this.jcb_1 + intValue | 0;
    if (this.icb_1.e1() > this.hcb_1) {
      this.jcb_1 = this.jcb_1 - this.icb_1.nk() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  static gch(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.na3();
    $this.wcd_1 = null;
    $this.xcd_1 = null;
    $this.ycd_1 = true;
    $this.zcd_1 = false;
    $this.ace_1 = true;
    $this.bce_1 = true;
    $this.cce_1 = EmptyShape_instance;
    $this.dce_1 = renderer;
    $this.ech(shape);
    return $this;
  }
  hch() {
    var tmp0_elvis_lhs = this.wcd_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.xcd_1 : tmp0_elvis_lhs);
  }
  vbe(value) {
    _get_anchorable__ebfoik(this).vbe(value);
    this.r9t();
  }
  tag() {
    return this.hch().tag();
  }
  uag() {
    return this.hch().uag();
  }
  ich(value) {
    if (this.ace_1 === value)
      return Unit_instance;
    this.ace_1 = value;
    var tmp0_safe_receiver = this.wcd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.xc1_1 = value;
    }
    var tmp1_safe_receiver = this.xcd_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.gcg_1 = value;
    }
    this.r9t();
  }
  jch(value) {
    if (this.bce_1 === value)
      return Unit_instance;
    this.bce_1 = value;
    var tmp0_safe_receiver = this.wcd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rby_1 = value;
    }
    var tmp1_safe_receiver = this.xcd_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ecg_1 = value;
    }
    this.r9t();
  }
  ech(value) {
    if (this.cce_1 === value)
      return Unit_instance;
    this.cce_1 = value;
    ensure_0(this);
    var tmp0_safe_receiver = this.wcd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ac9(value);
    }
    var tmp1_safe_receiver = this.xcd_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ech(value);
    }
    this.r9t();
  }
  kch() {
    ensure_0(this);
    var tmp0_safe_receiver = this.wcd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.sbz();
    }
    var tmp1_safe_receiver = this.wcd_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.tbz();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.n9k_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.rch(views, currentVfs, sourceFile, $completion) : $super.rch.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static och(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().f24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.pch(bitmap, anchor, hitShape, smoothing);
    $this.sbd_1 = new Mixin_0();
    $this.tbd_1 = sourceFile$factory($this);
    return $this;
  }
  static ubd(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().f24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.och(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  had(ctx) {
    this.qch(ctx, this);
    super.had(ctx);
  }
  rch(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos.bind(VOID, this, views, currentVfs, sourceFile), $completion);
  }
  tch(_set____db54di) {
    this.sbd_1.mch_1 = _set____db54di;
  }
  uch(_set____db54di) {
    this.sbd_1.uch(_set____db54di);
  }
  vch() {
    return this.sbd_1.nch_1;
  }
  lch(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b.bind(VOID, _this__u8e3s4, this, views, currentVfs, sourceFile), $completion);
  }
  qch(ctx, view) {
    this.sbd_1.qch(ctx, view);
  }
}
class RenderableView extends CustomContextRenderizableView {
  static gbm(size, viewRenderer) {
    var $this = this.bc9(size);
    $this.kas_1 = viewRenderer;
    $this.las_1 = false;
    $this.mas_1 = false;
    $this.nas_1 = false;
    return $this;
  }
  dc9(context, size) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.RenderableView.renderer.<anonymous>' call
    this.kas_1.tbi(this);
  }
}
class Companion_7 {}
class Companion_8 {}
class SolidRect extends RectBase {
  static eck(size, color) {
    color = color === VOID ? Colors_getInstance().s3y_1 : color;
    var $this = this.cc9();
    $this.dck_1 = size;
    $this.e4e(color);
    return $this;
  }
  bad(value) {
    if (this.dck_1.equals(value))
      return Unit_instance;
    this.dck_1 = value;
    this.s9n_1 = true;
    this.r9t();
  }
  cad() {
    return this.dck_1;
  }
  vbz() {
    return this.m2i();
  }
  wbz() {
    return this.n2i();
  }
}
class Sprite extends BaseImage {
  static kcn(bitmap, anchor, hitShape, smoothing) {
    var tmp;
    if (bitmap === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      tmp = get_Bitmaps_white();
    } else {
      tmp = bitmap;
    }
    bitmap = tmp;
    anchor = anchor === VOID ? Companion_getInstance_26().f24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.qbz(bitmap, anchor, hitShape, smoothing);
    $this.ncm_1 = false;
    $this.ocm_1 = 0;
    $this.pcm_1 = 0;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    tmp_0.qcm_1 = _AnimationType___init__impl__l3ftd1(0);
    $this.rcm_1 = null;
    $this.scm_1 = null;
    $this.tcm_1 = null;
    $this.ucm_1 = null;
    $this.vcm_1 = get_fastMilliseconds_0(50);
    $this.wcm_1 = false;
    $this.xcm_1 = get_fastSeconds(0);
    $this.ycm_1 = get_fastSeconds(0);
    $this.zcm_1 = null;
    $this.acn_1 = 0;
    $this.bcn_1 = false;
    addFastUpdater_0($this, Sprite$lambda);
    return $this;
  }
  static lcn(initialAnimation, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_26().f24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.kcn(initialAnimation.mcn(), anchor, hitShape, smoothing);
    $this.zcm_1 = initialAnimation;
    $this.ncn(0);
    return $this;
  }
  ecn() {
    if (this.rcm_1 == null)
      this.rcm_1 = new Signal();
    return ensureNotNull(this.rcm_1);
  }
  dcn() {
    if (this.scm_1 == null)
      this.scm_1 = new Signal();
    return ensureNotNull(this.scm_1);
  }
  ocn(spriteAnimation, spriteDisplayTime, startFrame, reversed) {
    var tmp = get_fast(spriteDisplayTime);
    var tmp_0 = startFrame >= 0 ? startFrame : this.acn_1;
    // Inline function 'korlibs.korge.view.Companion.LOOPED' call
    var tmp$ret$0 = _AnimationType___init__impl__l3ftd1(1);
    return updateCurrentAnimation$default(this, spriteAnimation, tmp, VOID, VOID, tmp_0, VOID, true, reversed, tmp$ret$0);
  }
  pcn(spriteAnimation, spriteDisplayTime, startFrame, reversed, $super) {
    spriteAnimation = spriteAnimation === VOID ? this.zcm_1 : spriteAnimation;
    startFrame = startFrame === VOID ? -1 : startFrame;
    reversed = reversed === VOID ? false : reversed;
    var tmp;
    if ($super === VOID) {
      this.ocn(spriteAnimation, spriteDisplayTime, startFrame, reversed);
      tmp = Unit_instance;
    } else {
      tmp = $super.ocn.call(this, spriteAnimation, new Duration(spriteDisplayTime), startFrame, reversed);
    }
    return tmp;
  }
  ccn() {
    this.ncm_1 = false;
    triggerEvent(this, this.scm_1);
  }
  fcn() {
    var tmp0_elvis_lhs = this.zcm_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ca = tmp;
    return ca.e1();
  }
  ncn(index) {
    _set_currentSpriteIndex__7b2y7x(this, index);
  }
}
class Companion_9 {}
class Companion_10 {
  qcn(spriteMap, spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows, numberOfFrames, byRows) {
    return this.rcn(slice(spriteMap), spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows, numberOfFrames, byRows);
  }
  scn(spriteMap, spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows, numberOfFrames, byRows, $super) {
    spriteWidth = spriteWidth === VOID ? 16 : spriteWidth;
    spriteHeight = spriteHeight === VOID ? 16 : spriteHeight;
    marginTop = marginTop === VOID ? 0 : marginTop;
    marginLeft = marginLeft === VOID ? 0 : marginLeft;
    columns = columns === VOID ? 1 : columns;
    rows = rows === VOID ? 1 : rows;
    offsetBetweenColumns = offsetBetweenColumns === VOID ? 0 : offsetBetweenColumns;
    offsetBetweenRows = offsetBetweenRows === VOID ? 0 : offsetBetweenRows;
    numberOfFrames = numberOfFrames === VOID ? imul(rows, columns) : numberOfFrames;
    byRows = byRows === VOID ? true : byRows;
    return $super === VOID ? this.qcn(spriteMap, spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows, numberOfFrames, byRows) : $super.qcn.call(this, spriteMap, spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows, numberOfFrames, byRows);
  }
  rcn(spriteMap, spriteWidth, spriteHeight, marginTop, marginLeft, columns, rows, offsetBetweenColumns, offsetBetweenRows, numberOfFrames, byRows) {
    // Inline function 'kotlin.apply' call
    var this_0 = FastArrayList.ny();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.invoke.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable < numberOfFrames)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var col = byRows ? n % columns | 0 : n / rows | 0;
        var row = byRows ? n / columns | 0 : n % rows | 0;
        this_0.h(spriteMap.j3h(marginLeft + imul(spriteWidth + offsetBetweenColumns | 0, col) | 0, marginTop + imul(spriteHeight + offsetBetweenRows | 0, row) | 0, spriteWidth, spriteHeight, 'slice' + this_0.e1()));
      }
       while (inductionVariable < numberOfFrames);
    return new SpriteAnimation(this_0);
  }
}
class SpriteAnimation {
  constructor(sprites, fastDefaultTimePerFrame) {
    fastDefaultTimePerFrame = fastDefaultTimePerFrame === VOID ? Companion_instance_1.t1u() : fastDefaultTimePerFrame;
    this.gcn_1 = sprites;
    this.hcn_1 = fastDefaultTimePerFrame;
  }
  jcn() {
    return this.gcn_1.e1();
  }
  mcn() {
    return this.gcn_1.d1(0);
  }
  icn(index) {
    return this.gcn_1.d1(umod(index, this.gcn_1.e1()));
  }
  tcn(elements) {
    return this.gcn_1.x2(elements);
  }
  x2(elements) {
    return this.tcn(elements);
  }
  g1() {
    return this.gcn_1.g1();
  }
  a1() {
    return this.gcn_1.a1();
  }
  e1() {
    return this.gcn_1.e1();
  }
}
class Stage extends FixedSizeContainer {
  static b9j(views) {
    var $this = this.gc5();
    $this.x9i_1 = views.a9k_1;
    $this.y9i_1 = views;
    $this.z9i_1 = clipBorders$factory($this.d9x());
    $this.a9j_1 = virtualSizeDouble$factory($this.d9x());
    $this.yag($this);
    $this.aah($this);
    return $this;
  }
  d9x() {
    return this.y9i_1;
  }
  ucn(_set____db54di) {
    var this_0 = this.z9i_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  o5z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z9i_1;
    clip$factory_0();
    return this_0.get();
  }
  bad(_set____db54di) {
    var this_0 = this.a9j_1;
    unscaledSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  cad() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a9j_1;
    unscaledSize$factory_0();
    return this_0.get();
  }
  ibe() {
    return this.d9x().w9j_1;
  }
  b9u() {
    return this;
  }
  xaf() {
    return this;
  }
  i84() {
    return this.lc5(this.d9x());
  }
  yaf(view) {
    this.d9x().yaf(view);
  }
  toString() {
    return 'Stage';
  }
  t14() {
    return this.y9i_1.q9j_1;
  }
  y89(pos) {
    return this.x9i_1.y89(pos);
  }
  n89(value) {
    this.x9i_1.n89(value);
  }
  o89() {
    return this.x9i_1.o89();
  }
  p89(value) {
    this.x9i_1.p89(value);
  }
  q89() {
    return this.x9i_1.q89();
  }
  r89(value) {
    this.x9i_1.r89(value);
  }
  s89() {
    return this.x9i_1.s89();
  }
  t89(value) {
    this.x9i_1.t89(value);
  }
  u89() {
    return this.x9i_1.u89();
  }
  v89(value) {
    this.x9i_1.v89(value);
  }
  w89() {
    return this.x9i_1.w89();
  }
  x89() {
    return this.x9i_1.x89();
  }
}
class Companion_11 {
  constructor() {
    this.tbo_1 = 16.0;
    this.ubo_1 = true;
  }
}
class Text$_renderInternal$slambda {
  constructor(this$0, $ctx, $fontSource) {
    this.xcn_1 = this$0;
    this.ycn_1 = $ctx;
    this.zcn_1 = $fontSource;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_22.bind(VOID, this), $completion);
  }
}
class Text extends Container {
  static vbo(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_26.tbo_1 : textSize;
    color = color === VOID ? Colors_getInstance().s3y_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_3().l4w_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_26.ubo_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.na3();
    $this.jao_1 = true;
    $this.kao_1 = -1;
    $this.lao_1 = -1;
    $this.mao_1 = 0;
    $this.nao_1 = 0;
    $this.oao_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.pao_1 = fill == null ? new RGBA(color) : fill;
    $this.qao_1 = stroke;
    $this.rao_1 = font;
    $this.sao_1 = numberToDouble(textSize);
    $this.tao_1 = textSize$factory_0($this);
    $this.uao_1 = 0;
    $this.vao_1 = 2147483647;
    $this.wao_1 = renderer;
    $this.xao_1 = alignment;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.na3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.yao_1 = addTo(this_0, $this);
    $this.zao_1 = new Text2TextRendererActions();
    $this.aap_1 = false;
    $this.bap_1 = autoScaling;
    $this.cap_1 = false;
    $this.dap_1 = null;
    $this.eap_1 = Companion_getInstance_31().u2d(0, 0, 2048, 2048);
    $this.fap_1 = true;
    $this.gap_1 = -1;
    $this.hap_1 = new MMatrix();
    $this.iap_1 = -1;
    $this.jap_1 = null;
    $this.kap_1 = new Entry();
    $this.lap_1 = new FontMetrics();
    $this.map_1 = new TextMetrics();
    $this.nap_1 = null;
    $this.oap_1 = null;
    $this.pap_1 = null;
    $this.qap_1 = null;
    $this.rap_1 = new MMatrix();
    $this.sap_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.tap_1 = true;
    $this.uap_1 = null;
    $this.vap_1 = fontSource$factory($this);
    return $this;
  }
  lal(value) {
    if (!(this.oao_1 === value)) {
      this.oao_1 = value;
      updateLineCount(this);
      this.aag();
      this.r9t();
    }
  }
  w5q() {
    return this.oao_1;
  }
  cco(value) {
    if (!equals(this.pao_1, value)) {
      this.pao_1 = value;
      this.aag();
    }
  }
  wav(value) {
    this.cco(new RGBA(value));
  }
  h5e() {
    var tmp = this.pao_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.m4e_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().s3y_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  hav(value) {
    if (!equals(this.rao_1, value)) {
      this.rao_1 = value;
      this.aag();
    }
  }
  iav(value) {
    if (!(this.sao_1 === value)) {
      this.sao_1 = value;
      this.aag();
    }
  }
  dco(_set____db54di) {
    var this_0 = this.tao_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  f4p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.tao_1;
    fontSize$factory_0();
    return this_0.get();
  }
  aag() {
    this.mao_1 = this.mao_1 + 1 | 0;
    super.aag();
  }
  eco(value) {
    if (!this.xao_1.equals(value)) {
      this.xao_1 = value;
      this.aag();
    }
  }
  y5x() {
    return this.xao_1.d4y_1;
  }
  s5u() {
    return this.xao_1.e4y_1;
  }
  bco(value) {
    this.dap_1 = value;
    this.aap_1 = false;
    this.aag();
  }
  aco(currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadFontSource__wlrz09.bind(VOID, this, currentVfs, sourceFile), $completion);
  }
  ead() {
    this.fco(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.ead();
    } else {
      return this.eap_1;
    }
  }
  had(ctx) {
    this.fco(ctx);
    var tva = this.qap_1;
    if (!(tva == null)) {
      this.hap_1.b3r(this.g9v());
      this.hap_1.c3r(this.yao_1.t6a(), this.yao_1.u6a());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.b81_1;
      var this_1 = this_0.k81_1;
      if (!(this_1.f81_1 === this_0)) {
        this_1.f81_1 = this_0;
        this_1.p82();
      }
      var tmp = this.rao_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.k4p();
      this_0.v88(tex, this.jao_1, this.hai(), get_agProgram(bmpfont), tva.m88_1, tva.l88_1);
      this_0.q88(tva, this.hap_1.a2e());
    } else {
      super.had(ctx);
    }
  }
  mav() {
    this.fco(null);
    if (!(this.iap_1 === this.mao_1)) {
      this.iap_1 = this.mao_1;
      var tmp = this;
      var tmp0_safe_receiver = this.rao_1.zy();
      tmp.jap_1 = tmp0_safe_receiver == null ? null : getTextBoundsWithGlyphs(tmp0_safe_receiver, this.f4p(), this.w5q(), this.wao_1, this.xao_1);
    }
    var tmp1_elvis_lhs = this.jap_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = 'Must ensure font is resolved before calling getGlyphMetrics';
      throw IllegalStateException.w4(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  fco(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.dap_1;
      if (!this.aap_1 && !(fontSource == null)) {
        this.aap_1 = true;
        launchImmediately_0(ctx.h80_1, Text$_renderInternal$slambda_0(this, ctx, fontSource));
      }
    }
    var font = this.rao_1.zy();
    var tmp;
    var tmp_0;
    if (this.fap_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.gap_1 === this.mao_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.gap_1 = this.mao_1;
      var metrics = getTextBounds(font, this.sao_1, this.w5q(), this.map_1, this.wao_1, this.xao_1);
      this.eap_1 = new Rectangle(metrics.v25(), VerticalAlign__getOffsetY_impl_iso0y6(this.xao_1.e4y_1, metrics.n2i(), -metrics.l4y()), metrics.m2i(), font.o4p(this.sao_1, this.lap_1).g4p() * this.nao_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.wao_1.l5t();
        if (!(this.oap_1 === this.jao_1) || !(this.kao_1 === this.mao_1) || !(this.lao_1 === rversion)) {
          this.oap_1 = this.jao_1;
          this.lao_1 = rversion;
          this.kao_1 = this.mao_1;
          if (!(this.uap_1 == null)) {
            this.uap_1 = null;
            this.yao_1.iag();
          }
          this.zao_1.w5u();
          this.zao_1.j5u_1 = Companion_getInstance_3().p4w_1;
          invoke_0(this.wao_1, this.zao_1, this.w5q(), this.sao_1, font);
          while (this.yao_1.cag() < this.zao_1.e1()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.yao_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_26().f24_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image.ubd(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.yao_1.cag() > this.zao_1.e1()) {
            this.yao_1.d1(this.yao_1.cag() - 1 | 0).wai();
          }
          var bounds = this.zao_1.l3a();
          var firstBounds = this.zao_1.u5u(0);
          var lineInfos = this.zao_1.t5u();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var tmp0_iterator = lineInfos.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.s5t_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.q25_1;
          var textHeight = bounds.r25_1;
          var dx = this.fap_1 ? this.eap_1.o25_1 : this.eap_1.o25_1 + 1 + (this.eap_1.q25_1 - textWidth) * _HorizontalAlign___get_ratio__impl__x9wlea(this.y5x());
          var tmp_2;
          if (this.fap_1) {
            tmp_2 = this.eap_1.p25_1 + firstLineInfos.q5t_1;
          } else {
            var tmp2_subject = this.s5u();
            tmp_2 = equals(tmp2_subject, Companion_getInstance_4().f5t_1) ? this.eap_1.p25_1 : this.eap_1.p25_1 + firstLineInfos.q5t_1 + (this.eap_1.r25_1 - totalHeight) * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.s5u());
          }
          var dy = tmp_2;
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.zao_1.e1();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.zao_1.v5u(n, this.kap_1);
              var tmp_3 = this.yao_1.d1(n);
              var it = tmp_3 instanceof Image ? tmp_3 : THROW_CCE();
              it.bc2_1 = program;
              it.e4e(this.h5e());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.s24(numberToDouble(0), numberToDouble(0)));
              it.xc1_1 = this.jao_1;
              it.pbt(entry.t5t_1);
              it.w50(Vector2D.n27(entry.u5t_1 + dx, entry.v5t_1 + dy));
              it.oah(Scale.g2d(entry.w5t_1, entry.x5t_1));
              it.wch(entry.y5t_1);
              var containsLower = this.uao_1;
              it.l8j(n < this.vao_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.oap_1 === this.jao_1) || !(this.pap_1 === this.tap_1)) {
          this.mao_1 = this.mao_1 + 1 | 0;
          this.pap_1 = this.tap_1;
          this.nap_1 = this.bap_1;
          this.oap_1 = this.jao_1;
        }
        if (!(this.kao_1 === this.mao_1)) {
          this.kao_1 = this.mao_1;
          var realTextSize = this.sao_1;
          if (this.uap_1 == null) {
            this.yao_1.iag();
            var tmp_4 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.yao_1;
            var renderer = this.sap_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(Graphics.gch(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).i4v();
            this_3.ech(tmp$ret$10);
            this_3.kch();
            tmp_4.uap_1 = this_3;
            var tmp3_safe_receiver = this.uap_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.jch(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.uap_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.w5q();
          var tmp1_pos = Companion_getInstance_28().g25_1;
          var tmp2_paint = this.h5e();
          var tmp3_renderer = this.wao_1;
          var tmp4_align = this.xao_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.pao_1;
          var tmp7_stroke = this.qao_1;
          var tmp8_textRangeStart = this.uao_1;
          var tmp9_textRangeEnd = this.vao_1;
          result_0 = this_5.t5s(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$16 = this_5.i4v();
          this_4.ech(tmp$ret$16);
          var metrics_0 = result_0;
          this.iap_1 = this.mao_1;
          this.jap_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_28().g25_1, font.o4p(this.f4p(), this.lap_1).s4p_1);
        }
        var tmp4_safe_receiver = this.uap_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.ich(this.jao_1);
        }
      }
    }
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_27 = this;
    this.gco_1 = until(0, 2147483647);
  }
}
class TextBlock extends UIView {
  static jbb(text, align, size) {
    Companion_getInstance_52();
    var tmp;
    if (text === VOID) {
      var tmp0_font = get_DefaultTtfFontAsBitmap();
      tmp = RichTextData.i5s('', tmp0_font, 16.0);
    } else {
      tmp = text;
    }
    text = tmp;
    align = align === VOID ? Companion_getInstance_3().l4w_1 : align;
    size = size === VOID ? Size2D.l26(100, 100) : size;
    var $this = this.wac(size);
    $this.sba_1 = true;
    $this.tba_1 = text;
    $this.uba_1 = align;
    $this.vba_1 = false;
    $this.wba_1 = true;
    $this.xba_1 = new RGBA($this.g4e());
    $this.yba_1 = null;
    $this.zba_1 = true;
    $this.abb_1 = '...';
    $this.bbb_1 = Companion_getInstance_30().f28_1;
    $this.cbb_1 = false;
    $this.dbb_1 = 0;
    $this.ebb_1 = 2147483647;
    $this.fbb_1 = true;
    $this.gbb_1 = null;
    $this.hbb_1 = null;
    invalidateText($this);
    $this.ibb_1 = null;
    return $this;
  }
  ebe(value) {
    if (!this.tba_1.equals(value)) {
      this.tba_1 = value;
      invalidateText(this);
    }
  }
  dbe(value) {
    if (!this.uba_1.equals(value)) {
      this.uba_1 = value;
      invalidProps(this);
    }
  }
  yac() {
    invalidProps(this);
  }
  had(ctx) {
    if (_get_allBitmap__bdn8f(this) === true) {
      if (this.sba_1 || this.ibb_1 == null) {
        this.sba_1 = false;
        this.ibb_1 = place(this.tba_1, new Rectangle(this.bbb_1.j28_1, this.bbb_1.g28_1, this.m2i() - this.bbb_1.h28_1, this.n2i() - this.bbb_1.i28_1), this.zba_1, this.vba_1, this.abb_1, this.xba_1, this.yba_1, this.uba_1, this.wba_1);
      }
      var tmp0_safe_receiver = this.gbb_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.wai();
      }
      this.gbb_1 = null;
      // Inline function 'korlibs.korge.render.renderCtx2d' call
      // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var batcher = ctx.b81_1;
      if (!(ctx.f81_1 === batcher)) {
        ctx.f81_1 = batcher;
        ctx.p82();
      }
      // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
      // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
      var context = ctx.d81_1;
      // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
      $l$block_3: {
        // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
        var old = context.x8b_1;
        try {
          // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
          $l$block_2: {
            // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
            var oldBlendFactors = context.y8b_1;
            try {
              // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
              $l$block_1: {
                // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
                var multiplyColor = context.z8b_1;
                try {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                  $l$block_0: {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                    var filtering = context.a8c_1;
                    try {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      $l$block: {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                        var size = context.v8b_1;
                        try {
                          // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                          context.v8b_1 = Size2D.b2e(this.m2i(), this.n2i());
                          context.y8b_1 = this.hai();
                          context.z8b_1 = this.iai();
                          context.b8c(this.g9v());
                          drawText_0(context, ensureNotNull(this.ibb_1), this.dbb_1, this.ebb_1, this.fbb_1);
                          break $l$block;
                        }finally {
                          context.v8b_1 = size;
                        }
                      }
                      break $l$block_0;
                    }finally {
                      context.a8c_1 = filtering;
                    }
                  }
                  break $l$block_1;
                }finally {
                  context.z8b_1 = multiplyColor;
                }
              }
              break $l$block_2;
            }finally {
              context.y8b_1 = oldBlendFactors;
            }
          }
          break $l$block_3;
        }finally {
          context.x8b_1 = old;
        }
      }
    } else {
      ensureTexture(this);
    }
    super.had(ctx);
  }
}
class ColorReference {}
class Companion_13 {
  hco(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p23();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p23();
      }
    }
    return null;
  }
}
class ViewRenderPhase {}
function render_0(view, ctx) {
  return view.oai(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.qco_1 = $view;
    this.rco_1 = $ctx;
    this.sco_1 = this$0;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_23.bind(VOID, this), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.mch_1 = true;
    this.nch_1 = null;
  }
  tch(_set____db54di) {
    this.mch_1 = _set____db54di;
  }
  uch(value) {
    this.mch_1 = false;
    this.nch_1 = value;
  }
  lch(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.uch(sourceFile);
    _this__u8e3s4.tch(true);
  }
  rch(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.od('An operation is not implemented: ' + reason);
  }
  qch(ctx, view) {
    if (this.mch_1)
      return Unit_instance;
    this.tco(ctx, view);
  }
  tco(ctx, view) {
    if (!this.mch_1 && !(this.nch_1 == null)) {
      this.mch_1 = true;
      launchImmediately_0(ctx.h80_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.uco_1 = this$0;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_24.bind(VOID, this), $completion);
  }
}
class Views extends BaseEventListener {
  static p9r(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().g87_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.m66();
    $this.p9j_1 = new Mixin();
    $this.q9j_1 = coroutineContext;
    $this.r9j_1 = ag;
    $this.s9j_1 = injector;
    $this.t9j_1 = input;
    $this.u9j_1 = timeProvider;
    $this.v9j_1 = stats;
    $this.w9j_1 = gameWindow;
    $this.x9j_1 = gameId;
    $this.y9j_1 = settingsFolder;
    $this.z9j_1 = batchMaxQuads;
    $this.a9k_1 = bp;
    $this.b9k_1 = stageBuilder;
    $this.c9k_1 = quality$factory($this.w9j_1);
    $this.d9k_1 = $this;
    $this.e9k_1 = false;
    $this.f9k_1 = continuousRenderMode$factory($this.w9j_1);
    $this.g9k_1 = new ReshapeEvent(0, 0);
    $this.h9k_1 = new UpdateEvent();
    $this.i9k_1 = new ViewsUpdateEvent($this);
    $this.j9k_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.k9k_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.m9k_1 = null;
    $this.n9k_1 = get_resourcesVfs();
    $this.o9k_1 = get_RegisteredImageFormats();
    $this.p9k_1 = new RenderContext($this.r9j_1, $this, $this.w9j_1, $this.v9j_1, $this.q9j_1, $this.z9j_1, $this.w9j_1);
    $this.q9k_1 = true;
    $this.r9k_1 = Colors_getInstance().t3y_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.s9k_1 = HashMap.i8();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.t9k_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.u9k_1 = new Resources($this.q9j_1, $this.n9k_1);
    $this.v9k_1 = false;
    $this.w9k_1 = 1280;
    $this.x9k_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.y9k_1 = ArrayList.h1();
    $this.z9k_1 = Companion_getInstance_25().v2f_1;
    $this.a9l_1 = Companion_getInstance_26().j24_1;
    $this.b9l_1 = true;
    $this.c9l_1 = $this.b9k_1($this);
    $this.d9l_1 = $this.c9l_1;
    $this.e9l_1 = true;
    $this.f9l_1 = false;
    $this.g9l_1 = debugExtraFontScale$factory($this.p9k_1);
    $this.h9l_1 = debugExtraFontColor$factory($this.p9k_1);
    $this.i9l_1 = FastArrayList.ny();
    $this.j9l_1 = $this.u9j_1.n1u();
    var tmp_4 = $this;
    tmp_4.k9l_1 = Pool.k2p(VOID, Views$tempViewsPool$lambda);
    $this.l9l_1 = SizeInt.l2g();
    $this.m9l_1 = SizeInt.l2g();
    $this.n9l_1 = SizeInt.l2g();
    $this.o9l_1 = new Signal();
    $this.p9l_1 = new Signal();
    $this.q9l_1 = -1.0;
    $this.s9j_1.t63(getKClass(CoroutineContext), $this.q9j_1);
    $this.s9j_1.t63(getKClass(AG), $this.r9j_1);
    $this.s9j_1.t63(getKClass(Views), $this);
    $this.p9l_1.y1v(Views$lambda($this));
    $this.o9l_1.y1v(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.r9l_1 = Companion_instance_11.bi('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.s9l_1 = new EventResult();
    $this.t9l_1 = new Signal();
    $this.u9l_1 = Companion_getInstance_0().mw('debugHightlightView');
    $this.v9l_1 = new Signal();
    $this.w9l_1 = new Signal();
    $this.x9l_1 = ArrayList.h1();
    $this.y9l_1 = updatedSinceFrame$factory($this.w9j_1);
    return $this;
  }
  t14() {
    return this.q9j_1;
  }
  d9x() {
    return this.d9k_1;
  }
  a9s(_set____db54di) {
    var this_0 = this.f9k_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  u9r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f9k_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  wco() {
    return replace(replace(replace(this.x9j_1, '\\', ''), '/', ''), '..', '');
  }
  h9v() {
    var tmp = this.l9k_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  y22($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this), $completion);
  }
  z9r() {
    return this.u9k_1;
  }
  b9s() {
    return this.r9j_1.a6g().t6f_1;
  }
  c9s() {
    return this.r9j_1.a6g().u6f_1;
  }
  xco(value) {
    this.w9k_1 = numberToInt(value);
  }
  yco() {
    return this.w9k_1;
  }
  zco(value) {
    this.x9k_1 = numberToInt(value);
  }
  acp() {
    return this.x9k_1;
  }
  wcn(value) {
    this.xco(value.j26_1);
    this.zco(value.k26_1);
  }
  vcn() {
    return Size2D.b2e(this.yco(), this.acp());
  }
  c6() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  vco($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw.bind(VOID, this), $completion);
  }
  c9v() {
    return this.c9l_1.i84();
  }
  q9r(_set____db54di) {
    var this_0 = this.g9l_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  bcp() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g9l_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  r9r(_set____db54di) {
    var this_0 = this.h9l_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  ccp() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h9l_1;
    debugFontColor$factory_0();
    return this_0.get().m4e_1;
  }
  gcb(block) {
    this.i9l_1.h(block);
  }
  q66(type, event, result, up, down) {
    event.j67(false);
    var result_0 = super.q66(type, event, result, up, down);
    var e = event;
    e.i67(this.d9k_1);
    if (e instanceof KeyEvent) {
      this.t9j_1.p84(e);
      this.t9j_1.w83_1.g83(e);
      if (e.g68_1.equals(Type_UP_getInstance_0()) && this.e9l_1 && (e.i68_1.equals(Key_F12_getInstance()) || e.i68_1.equals(Key_F7_getInstance()))) {
        this.f9l_1 = !this.f9l_1;
        this.w9j_1.p8j(this.f9l_1);
        this.yaf(this.c9l_1);
      }
    }
    try {
      return this.c9l_1.z66(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  dcp(frameBuffer) {
    this.p9k_1.g81_1 = frameBuffer;
    if (this.q9k_1) {
      var tmp0_$this = this.p9k_1;
      var tmp1_color = this.r9k_1;
      tmp0_$this.f8b(tmp1_color, 1.0, 0, true, true, true);
    }
    this.o9l_1.z1v(this.p9k_1);
    this.p9k_1.p82();
    this.c9l_1.dad(this.p9k_1);
    this.p9k_1.p82();
    this.c9l_1.lag(this.p9k_1);
    if (this.f9l_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.i9l_1.ly_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.p9k_1);
      }
    }
    this.p9l_1.z1v(this.p9k_1);
    this.p9k_1.p82();
  }
  ecp(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.r9j_1.a6g() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.dcp(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.dcp.call(this, frameBuffer);
    }
    return tmp;
  }
  fcp() {
    this.r9j_1.e6g();
    this.ecp();
  }
  v9r(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.u9j_1.n1u();
    this.d9k_1.v9j_1.e6g();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_39().j9g_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.j9l_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.d9k_1.t9k_1) > 0 ? this.d9k_1.t9k_1 : delta;
    this.j9l_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.t1u())) {
        this.hcp(fixedSizeStep);
      } else {
        this.gcp(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.icp() > 0);
    if (doRender2) {
      if (this.r9l_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_5().p1u().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.icp() + ']');
      }
      this.fcp();
      this.e6g();
    }
  }
  gcp(elapsed) {
    return this.hcp(get_fast(elapsed));
  }
  hcp(elapsed) {
    this.t9j_1.n84(elapsed);
    this.s9l_1.c2q();
    updateSingleViewWithViewsAll(this.c9l_1, this, elapsed);
    this.t9j_1.o84(elapsed);
  }
  t9r() {
  }
  y9r(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.m9l_1 = SizeInt.k2g(actualWidth, actualHeight);
    this.jcp();
  }
  jcp() {
    setBoundsInfo(this.a9k_1, Size2D.l26(this.w9k_1, this.x9k_1), toFloat(this.m9l_1), this.z9k_1, this.a9l_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.p9k_1.n80_1 = this.a9k_1.s89();
    this.p9k_1.o80_1 = this.a9k_1.o89();
    // Inline function 'kotlin.also' call
    var this_0 = this.g9k_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.a68_1 = this.m9l_1.i2g_1;
    this_0.b68_1 = this.m9l_1.j2g_1;
    this.z66(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.j9k_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.ncp_1 = this.l9l_1;
    this.z66(this_1);
    this.c9l_1.aag();
  }
  jbe(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.w9j_1.q8j())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.u9l_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.t9l_1.z1v(viewToHightlight);
  }
  f9v(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.jbe(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.jbe.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  ocp(_set____db54di) {
    var this_0 = this.y9l_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  icp() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y9l_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  e6g() {
    this.w9j_1.e6g();
  }
  yaf(view) {
    this.w9j_1.e8k();
  }
  vx(value) {
    this.p9j_1.vx(value);
  }
  wx() {
    return this.p9j_1.wx();
  }
  y89(pos) {
    return this.a9k_1.y89(pos);
  }
  n89(value) {
    this.a9k_1.n89(value);
  }
  o89() {
    return this.a9k_1.o89();
  }
  p89(value) {
    this.a9k_1.p89(value);
  }
  q89() {
    return this.a9k_1.q89();
  }
  r89(value) {
    this.a9k_1.r89(value);
  }
  s89() {
    return this.a9k_1.s89();
  }
  t89(value) {
    this.a9k_1.t89(value);
  }
  u89() {
    return this.a9k_1.u89();
  }
  v89(value) {
    this.a9k_1.v89(value);
  }
  w89() {
    return this.a9k_1.w89();
  }
  x89() {
    return this.a9k_1.x89();
  }
  p8b() {
    return this.w9j_1.p8b();
  }
  q8b() {
    return this.w9j_1.q8b();
  }
  r8b() {
    return this.w9j_1.r8b();
  }
  a8b() {
    return this.w9j_1.a8b();
  }
}
class Companion_14 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.s1u() : fastDelta;
    super();
    this.nco_1 = views;
    this.oco_1 = fastDelta;
  }
  pco() {
    return toDuration_0(this.oco_1);
  }
  n29() {
    return Companion_instance_29;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.oco_1) + ')';
  }
}
class Companion_15 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.k2g(0, 0) : size;
    super();
    this.mcp_1 = views;
    this.ncp_1 = size;
  }
  n29() {
    return Companion_instance_30;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.ncp_1.toString() + ')';
  }
}
class UB extends UniformBlock {
  constructor() {
    UB_instance = null;
    super(6);
    UB_instance = this;
    this.tcp_1 = this.c6v().q6u(this, u_Col$factory());
    this.ucp_1 = this.g6u().q6u(this, u_Matrix$factory());
  }
  vcp() {
    return this.tcp_1.ko(this, u_Col$factory_0());
  }
  wcp() {
    return this.ucp_1.ko(this, u_Matrix$factory_0());
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    var tmp_0 = DefaultShaders_getInstance().j6t_1;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.z6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.debug.Companion.PROGRAM.<anonymous>' call
    this_0.e6x(this_0.h6x(), this_0.i6x(this_0.i6x(this_0.i6x(this_0.r6u(), this_0.s6u()), UB_getInstance().wcp()), this_0.l6x([this_0.j6x(), this_0.k6x(0.0), this_0.k6x(1.0)])));
    var tmp_1 = VertexShader(this_0.m6x());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.korge.view.debug.Companion.PROGRAM.<anonymous>' call
    builder.e6x(builder.h6x(), UB_getInstance().vcp());
    var tmp$ret$2 = FragmentShader(builder.m6x());
    tmp.xcp_1 = tmp_0.v7k(tmp_1, tmp$ret$2);
  }
}
class Batch {
  constructor(offset, count) {
    this.ycp_1 = offset;
    this.zcp_1 = count;
  }
}
class DebugVertexView extends View {
  static wau(pointsList, color, type) {
    Companion_getInstance_56();
    color = color === VOID ? Colors_getInstance().s3y_1 : color;
    type = type === VOID ? Companion_getInstance_14().q6p_1 : type;
    var $this = this.fcb();
    $this.e4e(color);
    $this.qau_1 = colorMul$factory($this);
    $this.rau_1 = pointsList;
    $this.sau_1 = type;
    var tmp = $this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.tau_1 = new Float32Array([0.0, 0.0, 100.0, 0.0, 0.0, 100.0, 100.0, 100.0]);
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.uau_1 = ArrayList.h1();
    $this.vau_1 = Companion_getInstance_32().e26();
    updatedPoints($this);
    return $this;
  }
  nav(value) {
    if (!(this.rau_1 === value)) {
      this.rau_1 = value;
      updatedPoints(this);
    }
  }
  ead() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.vau_1);
  }
  had(ctx) {
    ctx.p82();
    ctx.b89();
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = ctx.e6n(UB_getInstance());
      var _unary__edvuaz = this_0.t6o();
      this_0.u7b(_unary__edvuaz + 1 | 0);
      this_0.v7b(this_0.t6o() + 1 | 0);
      var blockSize = this_0.x6m_1;
      var index0 = imul(this_0.t6o() - 1 | 0, blockSize);
      var index1 = imul(this_0.t6o(), blockSize);
      var texBlockSize = this_0.u6m_1.t6u().e1();
      var texIndex0 = imul(this_0.t6o() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.t6o(), texBlockSize);
      if (this_0.t6o() > 0) {
        arraycopy(this_0.z6m_1, index0, this_0.z6m_1, index1, blockSize);
      } else {
        arrayfill(this_0.z6m_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.view.debug.DebugVertexView.renderInternal.<anonymous>' call
      var $this$push = this_0.u6m_1;
      var it = this_0.a6n_1;
      it.e7c($this$push.vcp(), this.iai());
      it.j7c($this$push.wcp(), toMatrix4(this.g9v()));
      if (true && this_0.t6o() >= 1) {
        var equals = arrayequal(this_0.z6m_1, index0, this_0.z6m_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.t6o();
          this_0.u7b(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    $l$block_0: {
      // Inline function 'korlibs.datastructure.Pool.alloc' call
      var this_1 = ctx.c81_1;
      var temp = this_1.m2p();
      try {
        temp.h6j(this.tau_1);
        var vData = AGVertexArrayObject.y6o([new AGVertexData(DefaultShaders_getInstance().h6t_1, temp)], true);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_2 = this.uau_1;
        var n = 0;
        while (n < this_2.e1()) {
          // Inline function 'korlibs.korge.view.debug.DebugVertexView.renderInternal.<anonymous>.<anonymous>' call
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var batch = this_2.d1(_unary__edvuaz_1);
          var tmp0_$receiver = ctx.d80_1;
          var tmp1_frameBuffer = ctx.g81_1;
          var tmp2_drawType = this.sau_1;
          var tmp3_program = Companion_getInstance_56().xcp_1;
          var tmp4_uniformBlocks = ctx.w8a(Companion_getInstance_56().xcp_1);
          var tmp5_textureUnits = ctx.m80_1.sx();
          var tmp6_vertexCount = batch.zcp_1;
          var tmp7_drawOffset = batch.ycp_1;
          var tmp8_blending = this.hai().s82_1;
          draw(tmp0_$receiver, tmp1_frameBuffer, vData, tmp3_program, tmp2_drawType, tmp6_vertexCount, VOID, VOID, tmp7_drawOffset, tmp8_blending, tmp4_uniformBlocks, tmp5_textureUnits);
        }
        break $l$block_0;
      }finally {
        this_1.n2p(temp);
      }
    }
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_32 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.acq_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  bcq(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.acq_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_35().p28_1;
}
class RenderToTextureResult {
  constructor() {
    this.fcq_1 = null;
    this.gcq_1 = 0;
    this.hcq_1 = 0;
    this.icq_1 = 0;
    this.jcq_1 = 0;
    this.kcq_1 = 1.0;
    this.lcq_1 = Companion_getInstance_33().x28_1;
    this.mcq_1 = null;
    this.ncq_1 = null;
    this.ocq_1 = null;
    this.pcq_1 = null;
  }
  d18() {
    if (this.ncq_1 == null || this.pcq_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.ncq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.pcq_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.l8b(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.fcq_1 = null;
    this.mcq_1 = null;
    this.ncq_1 = null;
    this.pcq_1 = null;
    this.ocq_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_58();
    this.qcq_1 = smoothing;
  }
  ecq(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.b81_1;
    var this_1 = this_0.k81_1;
    if (!(this_1.f81_1 === this_0)) {
      this_1.f81_1 = this_0;
      this_1.p82();
    }
    this_0.r82(texture, VOID, VOID, VOID, VOID, matrix, this.qcq_1, renderColorMul, blendMode, Companion_getInstance_6().n87_1);
  }
}
class Companion_18 extends IdentityFilter {
  constructor() {
    Companion_instance_33 = null;
    super(true);
    Companion_instance_33 = this;
  }
}
class ViewRenderPhaseBackdropFilter {}
class ViewRenderPhaseFilter {}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.dcs_1 = bounds;
    this.ecs_1 = vertexCount;
    this.fcs_1 = vertexStart;
    this.gcs_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  static dch(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.fcb();
    $this.ecg_1 = autoScaling;
    $this.fcg_1 = true;
    $this.gcg_1 = true;
    $this.hcg_1 = true;
    $this.icg_1 = new GpuShapeViewCommands();
    $this.jcg_1 = 1000;
    $this.kcg_1 = 1000;
    $this.lcg_1 = Companion_getInstance_26().f24_1;
    $this.mcg_1 = true;
    $this.ncg_1 = false;
    $this.ocg_1 = antialiased;
    $this.pcg_1 = shape;
    $this.qcg_1 = false;
    $this.rcg_1 = false;
    $this.scg_1 = false;
    $this.tcg_1 = 0;
    $this.ucg_1 = Companion_getInstance_31().a29();
    $this.vcg_1 = Companion_getInstance_31().a29();
    $this.wcg_1 = false;
    $this.xcg_1 = 1.0;
    $this.ycg_1 = NaN;
    $this.zcg_1 = Companion_getInstance_33().a29();
    $this.ach_1 = 100000;
    $this.bch_1 = false;
    $this.cch_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  vbe(value) {
    this.lcg_1 = value;
    this.aag();
  }
  dc2() {
    return this.lcg_1;
  }
  fch(value) {
    this.ocg_1 = value;
    invalidateShape(this);
  }
  ech(value) {
    this.pcg_1 = value;
    invalidateShape(this);
  }
  tag() {
    return _get_shapeBounds__actvvf(this).q25_1 * this.dc2().o24_1;
  }
  uag() {
    return _get_shapeBounds__actvvf(this).r25_1 * this.dc2().p24_1;
  }
  aag() {
    super.aag();
    invalidateShape(this);
  }
  ead() {
    return new Rectangle(_get_shapeBounds__actvvf(this).o25_1 - this.tag(), _get_shapeBounds__actvvf(this).p25_1 - this.uag(), _get_shapeBounds__actvvf(this).q25_1, _get_shapeBounds__actvvf(this).r25_1);
  }
  ics(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.t5z_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.g1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.ics(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.ics(_this__u8e3s4.m60());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.r5z();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  had(ctx) {
    this.xcg_1 = this.g9v().k2a().i2b() * ctx.e80_1.x89();
    if (!(this.ycg_1 === this.xcg_1)) {
      invalidateShape(this);
    }
    ctx.p82();
    var doRequireTexture = this.ics(this.pcg_1);
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.ej();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.d80_1.a6g();
      this.jcg_1 = currentFrameBuffer.t6f_1;
      this.kcg_1 = currentFrameBuffer.u6f_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.jcg_1;
      var height = this.kcg_1;
      ctx.p82();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.k8b(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.m8b(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.b81_1;
          var this_1 = this_0.k81_1;
          if (!(this_1.f81_1 === this_0)) {
            this_1.f81_1 = this_0;
            this_1.p82();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor.s6q(0, 0, rb.t6f_1, rb.u6f_1);
            var temp = this_0.i82_1;
            this_0.r88();
            this_0.i82_1 = scissor;
            try {
              if (true) {
                ctx.f8b(Colors_getInstance().x3y_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.r88();
              this_0.i82_1 = temp;
            }
          }
        }finally {
          ctx.n8b();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture_0(rb).j3h(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.b81_1;
        var this_3 = this_2.k81_1;
        if (!(this_3.f81_1 === this_2)) {
          this_3.f81_1 = this_2;
          this_3.p82();
        }
        this_2.r82(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.e80_1.o89()));
        ctx.p82();
      }finally {
        ctx.l8b(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.jcs_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.jcs_1.toString() + ')';
  }
  hashCode() {
    return this.jcs_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.jcs_1.equals(tmp0_other_with_cast.jcs_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.kcs_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.kcs_1 + ')';
  }
  hashCode() {
    return this.kcs_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.kcs_1 === tmp0_other_with_cast.kcs_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_14().m6p_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_23().d6h_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().a6h_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_19().y6g_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_22().o6h_1 : cullFace;
    this.lcs_1 = drawType;
    this.mcs_1 = vertexIndex;
    this.ncs_1 = vertexEnd;
    this.ocs_1 = paintShader;
    this.pcs_1 = program;
    this.qcs_1 = colorMask;
    this.rcs_1 = stencilOpFunc;
    this.scs_1 = stencilRef;
    this.tcs_1 = blendMode;
    this.ucs_1 = cullFace;
  }
  z87() {
    return this.ncs_1 - this.mcs_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.lcs_1) + ', vertexIndex=' + this.mcs_1 + ', vertexEnd=' + this.ncs_1 + ', paintShader=' + toString_0(this.ocs_1) + ', program=' + toString_0(this.pcs_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.qcs_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.rcs_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.scs_1) + ', blendMode=' + toString_0(this.tcs_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.ucs_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.lcs_1);
    result = imul(result, 31) + this.mcs_1 | 0;
    result = imul(result, 31) + this.ncs_1 | 0;
    result = imul(result, 31) + (this.ocs_1 == null ? 0 : this.ocs_1.hashCode()) | 0;
    result = imul(result, 31) + (this.pcs_1 == null ? 0 : this.pcs_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.qcs_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.rcs_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.scs_1) | 0;
    result = imul(result, 31) + (this.tcs_1 == null ? 0 : this.tcs_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.ucs_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.lcs_1 === tmp0_other_with_cast.lcs_1))
      return false;
    if (!(this.mcs_1 === tmp0_other_with_cast.mcs_1))
      return false;
    if (!(this.ncs_1 === tmp0_other_with_cast.ncs_1))
      return false;
    if (!equals(this.ocs_1, tmp0_other_with_cast.ocs_1))
      return false;
    if (!equals(this.pcs_1, tmp0_other_with_cast.pcs_1))
      return false;
    if (!(this.qcs_1 === tmp0_other_with_cast.qcs_1))
      return false;
    if (!(this.rcs_1 === tmp0_other_with_cast.rcs_1))
      return false;
    if (!equals(this.scs_1, tmp0_other_with_cast.scs_1))
      return false;
    if (!equals(this.tcs_1, tmp0_other_with_cast.tcs_1))
      return false;
    if (!(this.ucs_1 === tmp0_other_with_cast.ucs_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.tcq_1 = 0;
    this.ucq_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.vcq_1 = ArrayList.h1();
    this.wcq_1 = null;
    this.xcq_1 = FastArrayList.ny();
    this.ycq_1 = 0;
    this.zcq_1 = 0;
    this.acr_1 = MatrixTransform.g2b();
    this.bcr_1 = FastArrayList.ny();
    this.ccr_1 = AGTextureUnits.n6j();
  }
  h3() {
    this.tcq_1 = 0;
    this.ucq_1.h3();
    this.vcq_1.h3();
  }
  hcr(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.ycq_1;
      this.ycq_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.ucq_1.f2j(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.tcq_1;
    this.tcq_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  gcr() {
    this.zcq_1 = this.tcq_1;
    return this.zcq_1;
  }
  icr() {
    return this.tcq_1;
  }
  hcs(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.vcq_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.h(element);
  }
  ccs(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_23().d6h_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().a6h_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_19().y6g_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_13().i7z_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_22().o6h_1 : cullFace;
    startIndex = startIndex === VOID ? this.zcq_1 : startIndex;
    endIndex = endIndex === VOID ? this.tcq_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.hcs(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.hcs.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  i76(i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.vcq_1;
    var element = new ClearCommand(i);
    this_0.h(element);
  }
  dcr(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.i76(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.i76.call(this, i);
    }
    return tmp;
  }
  ecr(scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.vcq_1;
    var element = new ScissorCommand(scissor);
    this_0.h(element);
  }
  c6g() {
    var tmp0_safe_receiver = this.wcq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.xcq_1.h(tmp0_safe_receiver);
    }
    this.wcq_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.ucq_1.k2j())));
  }
  fcr(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.wcq_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.x80_1.d87(this.xcq_1);
    this.xcq_1.h3();
    ctx.p82();
    var ag = ctx.d80_1;
    var vao = AGVertexArrayObject.x6o(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().scr_1, ctx.a87(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.b81_1;
    var this_1 = this_0.k81_1;
    if (!(this_1.f81_1 === this_0)) {
      this_1.f81_1 = this_0;
      this_1.p82();
    }
    this_0.b89();
    var tempMat = (doRequireTexture ? Companion_getInstance_33().x28_1 : this_0.x87()).i2a(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.k81_1;
    this_2.p82();
    var temp4 = this_2.q80_1;
    var temp2d = this_2.r80_1;
    this_2.r80_1 = tempMat;
    this_2.q80_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.e6n(ProjViewUB_getInstance());
      var _unary__edvuaz = this_3.t6o();
      this_3.u7b(_unary__edvuaz + 1 | 0);
      this_3.v7b(this_3.t6o() + 1 | 0);
      var blockSize = this_3.x6m_1;
      var index0 = imul(this_3.t6o() - 1 | 0, blockSize);
      var index1 = imul(this_3.t6o(), blockSize);
      var texBlockSize = this_3.u6m_1.t6u().e1();
      var texIndex0 = imul(this_3.t6o() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.t6o(), texBlockSize);
      if (this_3.t6o() > 0) {
        arraycopy(this_3.z6m_1, index0, this_3.z6m_1, index1, blockSize);
      } else {
        arrayfill(this_3.z6m_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.u6m_1;
      this_3.a6n_1.j7c($this$push.s6u(), this_2.q80_1);
      if (true && this_3.t6o() >= 1) {
        var equals = arrayequal(this_3.z6m_1, index0, this_3.z6m_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_3.t6o();
          this_3.u7b(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.acr_1 = globalMatrix.k2a();
      var program = GpuShapeViewPrograms_getInstance().zcr_1;
      var scissor = Companion_getInstance_16().m6h_1;
      var this_4 = this.vcq_1;
      var n = 0;
      while (n < this_4.e1()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_4.d1(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.jcs_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.kcs_1;
            ctx.f8b(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.ocs_1;
              this_0.h89(cmd.z87());
              var pixelScale = this.acr_1.i2b() / ctx.e80_1.x89();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.k81_1.e6n(ShapeViewUB_getInstance());
                  var _unary__edvuaz_2 = this_5.t6o();
                  this_5.u7b(_unary__edvuaz_2 + 1 | 0);
                  this_5.v7b(this_5.t6o() + 1 | 0);
                  var blockSize_0 = this_5.x6m_1;
                  var index0_0 = imul(this_5.t6o() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.t6o(), blockSize_0);
                  var texBlockSize_0 = this_5.u6m_1.t6u().e1();
                  var texIndex0_0 = imul(this_5.t6o() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.t6o(), texBlockSize_0);
                  if (this_5.t6o() > 0) {
                    arraycopy(this_5.z6m_1, index0_0, this_5.z6m_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(this_5.z6m_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.u6m_1;
                  var it = this_5.a6n_1;
                  it.y7b(paintShader.vcs_1);
                  it.z7b($this$push_0.kct(), pixelScale);
                  it.g7c($this$push_0.lct(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && this_5.t6o() >= 1) {
                    var equals_0 = arrayequal(this_5.z6m_1, index0_0, this_5.z6m_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = this_5.t6o();
                      this_5.u7b(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.wcs_1 == null)) {
                  var tex = ctx.t80_1.m2p();
                  tex.l6l(paintShader.wcs_1);
                  this.ccr_1.e6k(DefaultShaders_getInstance().o6x(), tex);
                  this.bcr_1.h(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.pcs_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.g81_1.m6f_1;
              var tmp5_frameBufferInfo = ctx.g81_1.s6h();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.w8a(_program);
              var tmp8_textureUnits = this.ccr_1.sx();
              var tmp9_stencilOpFunc = cmd.rcs_1;
              var tmp10_stencilRef = cmd.scs_1;
              var tmp11_colorMask = cmd.qcs_1;
              var tmp3_elvis_lhs = cmd.tcs_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_13().i7z_1 : tmp3_elvis_lhs).s82_1;
              var tmp13_cullFace = cmd.ucs_1;
              var tmp14_drawType = cmd.lcs_1;
              var tmp15_drawOffset = cmd.mcs_1;
              var tmp16_vertexCount = cmd.z87();
              draw_0(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.p82();
      this_2.q80_1 = temp4;
      this_2.r80_1 = temp2d;
      this_2.e6n(ProjViewUB_getInstance()).w7b();
    }
    var _iterator__ex2g4s = this.bcr_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var tex_0 = _iterator__ex2g4s.c1();
      ctx.t80_1.n2p(tex_0);
    }
    this.bcr_1.h3();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    this.cct_1 = this.y6u().q6u(this, u_ProgramType$factory());
    this.dct_1 = this.c6v().q6u(this, u_Color$factory());
    this.ect_1 = this.c6v().q6u(this, u_ColorMul$factory());
    this.fct_1 = this.y6u().q6u(this, u_GlobalAlpha$factory());
    this.gct_1 = this.y6u().q6u(this, u_GlobalPixelScale$factory());
    this.hct_1 = this.g6u().q6u(this, u_Transform$factory());
    this.ict_1 = this.c6v().q6u(this, u_Gradientp0$factory());
    this.jct_1 = this.c6v().q6u(this, u_Gradientp1$factory());
  }
  mct() {
    return this.cct_1.ko(this, u_ProgramType$factory_0());
  }
  nct() {
    return this.dct_1.ko(this, u_Color$factory_0());
  }
  lct() {
    return this.ect_1.ko(this, u_ColorMul$factory_0());
  }
  oct() {
    return this.fct_1.ko(this, u_GlobalAlpha$factory_0());
  }
  kct() {
    return this.gct_1.ko(this, u_GlobalPixelScale$factory_0());
  }
  pct() {
    return this.hct_1.ko(this, u_Transform$factory_0());
  }
  qct() {
    return this.ict_1.ko(this, u_Gradientp0$factory_0());
  }
  rct() {
    return this.jct_1.ko(this, u_Gradientp1$factory_0());
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().zcr_1 : program;
    this.vcs_1 = uniforms;
    this.wcs_1 = texture;
    this.xcs_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.vcs_1.toString() + ', texture=' + toString_0(this.wcs_1) + ', program=' + this.xcs_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.vcs_1);
    result = imul(result, 31) + (this.wcs_1 == null ? 0 : hashCode(this.wcs_1)) | 0;
    result = imul(result, 31) + this.xcs_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.vcs_1, tmp0_other_with_cast.vcs_1))
      return false;
    if (!equals(this.wcs_1, tmp0_other_with_cast.wcs_1))
      return false;
    if (!this.xcs_1.equals(tmp0_other_with_cast.xcs_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.jcr_1 = Attribute.y6v('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.kcr_1 = Attribute.y6v('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.lcr_1 = Varying.k6w('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.mcr_1 = Varying.k6w('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.ncr_1 = ProgramLayout.h6p([DefaultShaders_getInstance().r6s_1]);
    this.ocr_1 = ProgramLayout.h6p([DefaultShaders_getInstance().s6s_1]);
    this.pcr_1 = ProgramLayout.h6p([this.kcr_1]);
    this.qcr_1 = ProgramLayout.h6p([DefaultShaders_getInstance().r6s_1, DefaultShaders_getInstance().s6s_1]);
    this.rcr_1 = ProgramLayout.h6p([DefaultShaders_getInstance().r6s_1, this.kcr_1]);
    this.scr_1 = ProgramLayout.h6p([DefaultShaders_getInstance().r6s_1, this.kcr_1, this.jcr_1]);
    this.tcr_1 = 0;
    this.ucr_1 = 1;
    this.vcr_1 = 2;
    this.wcr_1 = 3;
    this.xcr_1 = 4;
    this.ycr_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.z6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.e6x(this_0.h6x(), this_0.i6x(this_0.i6x(this_0.r6u(), this_0.s6u()), this_0.l6x([this_0.j6x(), this_0.k6x(0.0), this_0.k6x(1.0)])));
    this_0.e6x(this_0.a6x(), DefaultShaders_getInstance().r6s_1);
    this_0.e6x(GpuShapeViewPrograms_getInstance().mcr_1, GpuShapeViewPrograms_getInstance().kcr_1);
    this_0.e6x(GpuShapeViewPrograms_getInstance().lcr_1, GpuShapeViewPrograms_getInstance().jcr_1);
    var tmp0_vertex = VertexShader(this_0.m6x());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.z6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.k6z(GpuShapeViewPrograms_getInstance().mct(), this_1.k6x(5));
    var body = this_1.v6x();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.e6x(body.h6x(), body.l6x([body.k6x(1.0), body.k6x(0.0), body.k6x(0.0), body.k6x(1.0)]));
    body.q6y();
    var stmIf = new If(cond, body.x6x());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.d6x_1.h(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.o6z(this_1.w6y(GpuShapeViewPrograms_getInstance().mcr_1), GpuShapeViewPrograms_getInstance().lcr_1);
    var body_0 = this_1.v6x();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.o6y();
    var stmIf_0 = new If(cond_0, body_0.x6x());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.d6x_1.h(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().mct();
    this_1.n6y(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.f6z(this_1.k6x(1.0), this_1.y6y(this_1.f6z(this_1.i6x(GpuShapeViewPrograms_getInstance().lcr_1, GpuShapeViewPrograms_getInstance().kct()), this_1.k6x(1.5)), this_1.i6x(GpuShapeViewPrograms_getInstance().lcr_1, GpuShapeViewPrograms_getInstance().kct()), this_1.w6y(this_1.i6x(GpuShapeViewPrograms_getInstance().mcr_1, GpuShapeViewPrograms_getInstance().kct()))));
    this_1.e6x(this_1.h6x(), this_1.i6x(this_1.i6x(this_1.i6x(this_1.h6x(), GpuShapeViewPrograms_getInstance().lct()), GpuShapeViewPrograms_getInstance().oct()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.m6x());
    tmp.zcr_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.c2q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.t6o();
      this_2.u7b(_unary__edvuaz + 1 | 0);
      this_2.v7b(this_2.t6o() + 1 | 0);
      var blockSize = this_2.x6m_1;
      var index0 = imul(this_2.t6o() - 1 | 0, blockSize);
      var index1 = imul(this_2.t6o(), blockSize);
      var texBlockSize = this_2.u6m_1.t6u().e1();
      var texIndex0 = imul(this_2.t6o() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.t6o(), texBlockSize);
      if (this_2.t6o() > 0) {
        arraycopy(this_2.z6m_1, index0, this_2.z6m_1, index1, blockSize);
      } else {
        arrayfill(this_2.z6m_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.u6m_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.a6n_1.a7c(ShapeViewUB_getInstance().mct(), 5);
      if (true && this_2.t6o() >= 1) {
        var equals = arrayequal(this_2.z6m_1, index0, this_2.z6m_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.t6o();
          this_2.u7b(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.acs_1 = new PaintShader(this_2, null);
  }
  mct() {
    return ShapeViewUB_getInstance().mct().n6o_1;
  }
  nct() {
    return ShapeViewUB_getInstance().nct().n6o_1;
  }
  lct() {
    return ShapeViewUB_getInstance().lct().n6o_1;
  }
  oct() {
    return ShapeViewUB_getInstance().oct().n6o_1;
  }
  kct() {
    return ShapeViewUB_getInstance().kct().n6o_1;
  }
  pct() {
    return ShapeViewUB_getInstance().pct().n6o_1;
  }
  qct() {
    return ShapeViewUB_getInstance().qct().n6o_1;
  }
  rct() {
    return ShapeViewUB_getInstance().rct().n6o_1;
  }
  sct(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$ExpressionBuilder = Companion_getInstance_24().n7i_1;
    return $this$ExpressionBuilder.u6y(_this__u8e3s4, $this$ExpressionBuilder.k6x(2.0));
  }
  bcs(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.c2q();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.t6o();
          this_0.u7b(_unary__edvuaz + 1 | 0);
          this_0.v7b(this_0.t6o() + 1 | 0);
          var blockSize = this_0.x6m_1;
          var index0 = imul(this_0.t6o() - 1 | 0, blockSize);
          var index1 = imul(this_0.t6o(), blockSize);
          var texBlockSize = this_0.u6m_1.t6u().e1();
          var texIndex0 = imul(this_0.t6o() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.t6o(), texBlockSize);
          if (this_0.t6o() > 0) {
            arraycopy(this_0.z6m_1, index0, this_0.z6m_1, index1, blockSize);
          } else {
            arrayfill(this_0.z6m_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.u6m_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.a6n_1;
          it.a7c($this$push.mct(), 0);
          it.g7c($this$push.nct(), _RGBA___get_premultiplied__impl__3bulqc(paint.m4e_1));
          it.a7c($this$push.oct(), globalAlpha);
          if (true && this_0.t6o() >= 1) {
            var equals = arrayequal(this_0.z6m_1, index0, this_0.z6m_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.t6o();
              this_0.u7b(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_33().x28_1.p2a(paint.o5p_1).p2a(stateTransform).j2a().x29(1.0 / paint.n5p_1.l3x_1, 1.0 / paint.n5p_1.m3x_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.c2q();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.t6o();
            this_1.u7b(_unary__edvuaz_1 + 1 | 0);
            this_1.v7b(this_1.t6o() + 1 | 0);
            var blockSize_0 = this_1.x6m_1;
            var index0_0 = imul(this_1.t6o() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.t6o(), blockSize_0);
            var texBlockSize_0 = this_1.u6m_1.t6u().e1();
            var texIndex0_0 = imul(this_1.t6o() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.t6o(), texBlockSize_0);
            if (this_1.t6o() > 0) {
              arraycopy(this_1.z6m_1, index0_0, this_1.z6m_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.z6m_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.u6m_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.a6n_1;
            it_0.a7c($this$push_0.mct(), 1);
            it_0.j7c($this$push_0.pct(), toMatrix4(mat));
            it_0.a7c($this$push_0.oct(), globalAlpha);
            if (true && this_1.t6o() >= 1) {
              var equals_0 = arrayequal(this_1.z6m_1, index0_0, this_1.z6m_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.t6o();
                this_1.u7b(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.n5p_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.e3x(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.p3x_1;
            if (true) {
              gradientBitmap.y3x();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.z5o(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.b3x_1));
            }finally {
              result = true ? gradientBitmap.a3y(rect) : 0;
            }
            var npaint = paint.a5p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_33().x28_1.p2a(paint.v5c_1).p2a(stateTransform));
            var mat_0 = paint.l5c_1.n3_1 === 0 ? npaint.b5d_1 : npaint.v5c_1.j2a();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.c2q();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.t6o();
              this_2.u7b(_unary__edvuaz_3 + 1 | 0);
              this_2.v7b(this_2.t6o() + 1 | 0);
              var blockSize_1 = this_2.x6m_1;
              var index0_1 = imul(this_2.t6o() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.t6o(), blockSize_1);
              var texBlockSize_1 = this_2.u6m_1.t6u().e1();
              var texIndex0_1 = imul(this_2.t6o() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.t6o(), texBlockSize_1);
              if (this_2.t6o() > 0) {
                arraycopy(this_2.z6m_1, index0_1, this_2.z6m_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.z6m_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.u6m_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.a6n_1;
              var tmp_0 = $this$push_1.mct();
              var tmp0 = paint.l5c_1.n3_1;
              it_1.a7c(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.j7c($this$push_1.pct(), toMatrix4(mat_0));
              it_1.h7c($this$push_1.qct(), new Vector4F(paint.m5c_1, paint.n5c_1, paint.o5c_1, 1.0));
              it_1.h7c($this$push_1.rct(), new Vector4F(paint.p5c_1, paint.q5c_1, paint.r5c_1, 1.0));
              it_1.a7c($this$push_1.oct(), globalAlpha);
              if (true && this_2.t6o() >= 1) {
                var equals_1 = arrayequal(this_2.z6m_1, index0_1, this_2.z6m_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.t6o();
                  this_2.u7b(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.od('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.i9g($this.x9e_1.h9g(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.y9e_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_14;
function Companion_getInstance_39() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().l1v($this.e9g_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.l9g(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.b9j(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.w1n($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_15;
function Companion_getInstance_40() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.z9l_1.c9f_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.a9m_1.c9l_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_36()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_27().c2g_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.fl();
    var height = size.gl();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp1_elvis_lhs = base == null ? null : base.m2i();
      rwidth = tmp1_elvis_lhs == null ? views_0.c9l_1.m2i() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.n2i();
      rheight = tmp3_elvis_lhs == null ? views_0.c9l_1.n2i() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.d9r(views_0, defaultTransition, name, Size2D.b2e(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).e9r($this.z9l_1.c9f_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.b9m_1($this.a9m_1.c9l_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.z9l_1.k9f_1) {
    var tmp_3 = $this.c9m_1.v8j($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.f9r_1, $this.g9r_1, $this.h9r_1, $this.i9r_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.w1n($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_38().hu()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().n64();
    try {
      var tmp0_elvis_lhs = $this.l9r_1.s9f_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().t3y_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.j9r_1, $this.k9r_1, $this.l9r_1.r9f_1, null, $this.l9r_1.j9f_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().n64();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.h8j(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().n64();
    try {
      try {
        if (!($this.m9r_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().bi($this.m9r_1), $this.n9r_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.j8j(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_39().j9g_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.j2t(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.k2t(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().n64();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.h8j('setIcon', tmp$ret$5);
    }
  }
  $this$loop.o8j($this$loop.x8a());
  if (Companion_getInstance_38().hu()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.mc();
  var this_3 = Views.p9r(tmp$ret$6.an(gameWindow.c8j()).an(new InjectorContext($this.l9r_1.e9f_1)).an(SupervisorJob()).an(CoroutineName.n1b('Views')), $this.l9r_1.z9f_1 ? AGPrint.a7a() : $this$loop.b8j(), $this.l9r_1.e9f_1, input, $this.l9r_1.d9f_1, stats, gameWindow, $this.l9r_1.l9f_1, $this.l9r_1.m9f_1, $this.l9r_1.n9f_1, VOID, $this.l9r_1.c9g_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.y22($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_38().ku()) {
    Dyn__set_impl_2ozvx8(Companion_instance_13.z2w(), 'views', this_3);
  }
  var views = this_3;
  $this.l9r_1.e9f_1.t63(getKClass(GameWindow), gameWindow);
  $this.l9r_1.e9f_1.t63(getKClass(Korge), $this.l9r_1);
  views.f9l_1 = $this$loop.q8j();
  views.q9r($this.l9r_1.a9g_1);
  views.r9r($this.l9r_1.b9g_1);
  views.w9k_1 = numberToInt($this.l9r_1.p9f_1.j26_1);
  views.x9k_1 = numberToInt($this.l9r_1.p9f_1.k26_1);
  views.a9l_1 = $this.l9r_1.q9f_1.j9j_1;
  views.z9k_1 = $this.l9r_1.q9f_1.i9j_1;
  views.b9l_1 = $this.l9r_1.q9f_1.k9j_1;
  views.q9l_1 = $this.l9r_1.d9g_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().n64();
    try {
      KorgeReload_getInstance().g7z(gameWindow);
      var tmp_4 = KorgeRunner_instance.s9r(views, gameWindow, true, $this$loop.n8j(), Companion_instance_1.t1u(), $this.l9r_1.w9f_1, $this.l9r_1.f9f_1).k17($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().n64();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.h8j(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().n64();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().n64();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.h8j(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.l9r_1, views, $this.o9r_1, gameWindow));
  if ($this.l9r_1.k9f_1) {
    var tmp_5 = gameWindow.v8j($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.t8j();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
  beforeStartingKorge(config);
  if (null == null) {
    $l$block: {
      // Inline function 'korlibs.io.worker.Companion.init' call
      get_workerImpl().s35();
      if (get_workerImpl().t35()) {
        if (get_DEBUG_WORKER()) {
          println('INSIDE WORKER');
        }
        break $l$block;
      } else {
        if (get_DEBUG_WORKER()) {
          println('**NOT** INSIDE WORKER');
        }
      }
      // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
      get_nativeSoundProvider();
      get_RegisteredImageFormats().o5l([config.a9f_1]);
      var iconPath = config.u9f_1;
      var imageFormats = config.a9f_1;
      var entry = config.y9f_1;
      var windowSize = config.o9f_1;
      if (!Companion_getInstance_38().ku()) {
        var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().bi('klogger.properties'), $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0_elvis_lhs = config.b9f_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        tmp_0 = $completion.mc().zc(CoroutineKey_getInstance());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_0;
      var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.x9f_1.z8k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.r9f_1)) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = config.s9f_1;
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
        tmp_1 = Colors_getInstance().t3y_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      realGameWindow.m8j(tmp_1);
      var tmp_3 = realGameWindow.w8j(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.y89(Vector2D.n27(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.k84(button, true);
  input.j84(p, false);
  input.j84(p, true);
  $views.t9r();
  downPos._v = input.i84();
  downTime._v = new DateTime(Companion_getInstance_5().n1u());
  input.u83_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.k84(button, false);
  input.j84(p, false);
  $views.t9r();
  upPos._v = $views.t9j_1.i84();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.t9j_1.j84(p, false);
  $views.t9j_1.u83_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.t9r();
  moveTime._v = new DateTime(Companion_getInstance_5().n1u());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.t9j_1.j84(p, false);
  $views.t9r();
  moveTime._v = new DateTime(Companion_getInstance_5().n1u());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.b6b_1 = 0;
  mouseTouchEvent.e6b_1 = true;
  mouseTouchEvent.c6b_1 = Companion_getInstance_5().n1u();
  mouseTouchEvent.d6b_1 = false;
  mouseTouchEvent.m6b(type);
  mouseTouchEvent.r6b(button.s6e_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.n6b();
  $views.z66(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.m6c_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.e84_1[gamepad.n6c_1].v6c(gamepad);
  }
  input.l84();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.v9r($fixedSizeStep, $views.u9r(), event.p67_1, event.q67_1);
    $views.t9j_1.t83_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.t9j_1.t83_1 = true;
      $views.t9j_1.u83_1 = false;
      $views.t9r();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_39().j9g_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.j2t(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.k2t(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.e9k_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.w9r($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_39().j9g_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.b69_1, e.c69_1, e.m69_1);
    var tmp_0;
    switch (e.z68_1.n3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.d69_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d69_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.d69_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d69_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.d69_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.z66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_39().j9g_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.z66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_39().j9g_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.z66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.z66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.z66(e);
    get_nativeSoundProvider().y2q(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.z66(e);
    get_nativeSoundProvider().y2q(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.z66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.z66(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_39().j9g_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.h84(e);
    var ee = $input.m83_1;
    var _iterator__ex2g4s = ee.j6b().a1();
    while (_iterator__ex2g4s.b1()) {
      var t = _iterator__ex2g4s.c1();
      t.o6a_1 = prepareViewsBase$getRealXY($views, t.t6a(), t.u6a(), e.d6b_1);
    }
    $views.z66(ee);
    var tmp_0;
    if (ee.k6b() === 1) {
      var start = ee.u6b();
      var end = ee.v6b();
      var t_0 = first(ee.j6b());
      var p = t_0.o6a_1;
      var x = t_0.t6a();
      var y = t_0.u6a();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.a69_1 = 0;
      this_1.d69_1 = button;
      this_1.e69_1 = end ? 0 : 1 << button.s6e_1;
      this_1.b69_1 = numberToInt(x);
      this_1.c69_1 = numberToInt(y);
      this_1.m69_1 = false;
      this_1.n69_1 = true;
      this_1.z68_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.z66(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_39().j9g_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.z66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.z66(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.y9r($ag.a6g().t6f_1, $ag.a6g().u6f_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.z66(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.q67_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.p9k_1;
      var frameBuffer = this_0.a6g();
      this_0.k80_1.c2q();
      this_0.d80_1.e6g();
      var tmp_0;
      try {
        this_0.m8b(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.b1b(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.n8b();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.d80_1.n6b();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_39().k9g_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().g87_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().s84_1.j26_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().s84_1.k26_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.l26(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.j26_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.k26_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.l26(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_25().v2f_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_26().r24() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().t3y_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().s3y_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).g9j(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.l9g(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.b9j(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.l9g(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_simpleAnimator(_this__u8e3s4) {
  _init_properties_Animator_kt__gicf47();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = simpleAnimator$delegate;
    var property = simpleAnimator$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var simpleAnimator$delegate;
function _get_totalTime__xgts5c($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.k9s_1;
  totalTime$factory();
  return this_0.r1().v1u_1;
}
function Animator$TweenNode$computedVs$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.e9s_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(tmp0_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.TweenNode.computedVs$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item();
        destination.h(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    return toMutableList(tmp1_elvis_lhs == null ? toList(this$0.d9s_1) : tmp1_elvis_lhs);
  };
}
function Animator$TweenNode$totalTime$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.g9s_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = tmp0_safe_receiver();
      tmp = tmp_0 == null ? null : tmp_0.v1u_1;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp1_elvis_lhs;
    if ((tmp_2 == null ? null : new FastDuration(tmp_2)) == null) {
      tmp_1 = this$0.f9s_1;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return new FastDuration(tmp_1);
  };
}
var Companion_instance_16;
function Companion_getInstance_41() {
  if (Companion_instance_16 === VOID)
    new Companion_1();
  return Companion_instance_16;
}
function ensure($this) {
  if (!($this.w9s_1 == null))
    return ensure($this.w9s_1);
  if (!($this.h9t().d9t_1 == null))
    return Unit_instance;
  var tmp = $this.h9t();
  var tmp_0 = $this.h9t().z9s_1;
  tmp.d9t_1 = addFastUpdater($this.q9s_1, tmp_0, VOID, Animator$ensure$lambda($this));
}
function ensureInit($this) {
  var tmp0_elvis_lhs = $this.x9s_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var linit = tmp;
  $this.x9s_1 = null;
  linit($this);
}
function Animator$removeProps$lambda($props) {
  return function (it) {
    return !$props.w2(it.i8e_1);
  };
}
function Animator$ensure$lambda(this$0) {
  return function ($this$addFastUpdater, dt) {
    var tmp;
    if (this$0.e9t_1) {
      this$0.q9s_1.r9t();
      tmp = Unit_instance;
    }
    var tmp_0;
    if (FastDuration__compareTo_impl_4fhnj7(this$0.g9t_1.l9t(dt.v1u_1), Companion_instance_1.s1u()) >= 0) {
      if (this$0.v9s_1) {
        invoke(this$0.a9t_1);
      } else {
        this$0.s9t();
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function animator(_this__u8e3s4, defaultTime, defaultSpeed, defaultEasing, parallel, looped, startImmediately, block) {
  defaultTime = defaultTime === VOID ? Companion_getInstance_41().m9s_1 : defaultTime;
  defaultSpeed = defaultSpeed === VOID ? Companion_getInstance_41().n9s_1 : defaultSpeed;
  defaultEasing = defaultEasing === VOID ? Companion_getInstance_41().o9s_1 : defaultEasing;
  parallel = parallel === VOID ? false : parallel;
  looped = looped === VOID ? false : looped;
  startImmediately = startImmediately === VOID ? Companion_getInstance_41().p9s_1 : startImmediately;
  var tmp;
  if (block === VOID) {
    tmp = animator$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_Animator_kt__gicf47();
  // Inline function 'kotlin.apply' call
  var tmp0_fastDefaultTime = get_fast(defaultTime);
  var this_0 = new Animator(_this__u8e3s4, tmp0_fastDefaultTime, defaultSpeed, defaultEasing, parallel, looped, null, VOID, 0, startImmediately);
  // Inline function 'kotlin.contracts.contract' call
  block(this_0);
  return this_0;
}
function tween(_this__u8e3s4, vs, time, easing, name, replace) {
  time = time === VOID ? _this__u8e3s4.t9t() : time;
  easing = easing === VOID ? _this__u8e3s4.t9s_1 : easing;
  name = name === VOID ? null : name;
  replace = replace === VOID ? true : replace;
  _init_properties_Animator_kt__gicf47();
  return _this__u8e3s4.x9t(vs.slice(), VOID, get_fast(time), VOID, easing, name, replace);
}
function block(_this__u8e3s4, name, callback) {
  name = name === VOID ? null : name;
  _init_properties_Animator_kt__gicf47();
  _this__u8e3s4.v9t(new BlockNode(name, callback));
}
function simpleAnimator$delegate$lambda($this$PropertyThis) {
  _init_properties_Animator_kt__gicf47();
  // Inline function 'kotlin.also' call
  var this_0 = animator($this$PropertyThis, VOID, VOID, VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.animate.simpleAnimator$delegate.<anonymous>.<anonymous>' call
  this_0.e9t_1 = true;
  return this_0;
}
function animator$lambda(_this__u8e3s4) {
  _init_properties_Animator_kt__gicf47();
  return Unit_instance;
}
function simpleAnimator$factory() {
  return getPropertyCallableRef('simpleAnimator', 1, KProperty1, function (receiver) {
    return get_simpleAnimator(receiver);
  }, null);
}
function computedVs$factory() {
  return getPropertyCallableRef('computedVs', 1, KProperty1, function (receiver) {
    return receiver.m9t();
  }, null);
}
function totalTime$factory() {
  return getPropertyCallableRef('totalTime', 1, KProperty1, function (receiver) {
    return new FastDuration(_get_totalTime__xgts5c(receiver));
  }, null);
}
var properties_initialized_Animator_kt_opr5o7;
function _init_properties_Animator_kt__gicf47() {
  if (!properties_initialized_Animator_kt_opr5o7) {
    properties_initialized_Animator_kt_opr5o7 = true;
    simpleAnimator$delegate = new PropertyThis(VOID, simpleAnimator$delegate$lambda);
  }
}
function get_viewStageComponent(_this__u8e3s4) {
  _init_properties_StageComponent_kt__9w4k8v();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = viewStageComponent$delegate;
    var property = viewStageComponent$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var viewStageComponent$delegate;
function set_viewsToTrack(_this__u8e3s4, _set____db54di) {
  _init_properties_StageComponent_kt__9w4k8v();
  var this_0 = viewsToTrack$delegate;
  var property = viewsToTrack$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_viewsToTrack(_this__u8e3s4) {
  _init_properties_StageComponent_kt__9w4k8v();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = viewsToTrack$delegate;
    var property = viewsToTrack$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var viewsToTrack$delegate;
function onNewAttachDetach(_this__u8e3s4, onAttach, onDetach) {
  var tmp;
  if (onAttach === VOID) {
    tmp = onNewAttachDetach$lambda;
  } else {
    tmp = onAttach;
  }
  onAttach = tmp;
  var tmp_0;
  if (onDetach === VOID) {
    tmp_0 = onNewAttachDetach$lambda_0;
  } else {
    tmp_0 = onDetach;
  }
  onDetach = tmp_0;
  _init_properties_StageComponent_kt__9w4k8v();
  var view = _this__u8e3s4;
  var closeable = new CancellableGroup();
  var viewStageComponent = get_viewStageComponent(_this__u8e3s4);
  deferWithViews(view, VOID, VOID, onNewAttachDetach$lambda_1(view));
  closeable.yr(viewStageComponent.z9t_1.x1v(onNewAttachDetach$lambda_2(onAttach, view)));
  closeable.yr(viewStageComponent.a9u_1.x1v(onNewAttachDetach$lambda_3(onDetach, view)));
  return closeable;
}
function registerStageComponent(_this__u8e3s4, view) {
  _init_properties_StageComponent_kt__9w4k8v();
  var firstRun = get_viewsToTrack(_this__u8e3s4) == null;
  if (firstRun) {
    // Inline function 'kotlin.collections.linkedSetOf' call
    var tmp$ret$0 = LinkedHashSet.j1();
    set_viewsToTrack(_this__u8e3s4, tmp$ret$0);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  ensureNotNull(get_viewsToTrack(_this__u8e3s4)).h(view);
  if (!firstRun)
    return Unit_instance;
  var componentsInStagePrev = FastArrayList.ny();
  // Inline function 'kotlin.collections.linkedSetOf' call
  var componentsInStageCur = LinkedHashSet.j1();
  // Inline function 'kotlin.collections.linkedSetOf' call
  var componentsInStage = LinkedHashSet.j1();
  _this__u8e3s4.o9l_1.y1v(registerStageComponent$lambda(componentsInStagePrev, componentsInStageCur, _this__u8e3s4, componentsInStage));
}
function viewStageComponent$delegate$lambda($this$PropertyThis) {
  _init_properties_StageComponent_kt__9w4k8v();
  return new ViewStageComponent($this$PropertyThis);
}
function viewsToTrack$delegate$lambda() {
  _init_properties_StageComponent_kt__9w4k8v();
  return null;
}
function onNewAttachDetach$lambda(_this__u8e3s4, it) {
  _init_properties_StageComponent_kt__9w4k8v();
  return Unit_instance;
}
function onNewAttachDetach$lambda_0(_this__u8e3s4, it) {
  _init_properties_StageComponent_kt__9w4k8v();
  return Unit_instance;
}
function onNewAttachDetach$lambda_1($view) {
  return function (it) {
    registerStageComponent(it, $view);
    return Unit_instance;
  };
}
function onNewAttachDetach$lambda_2($onAttach, $view) {
  return function (it) {
    $onAttach(it, $view);
    return Unit_instance;
  };
}
function onNewAttachDetach$lambda_3($onDetach, $view) {
  return function (it) {
    $onDetach(it, $view);
    return Unit_instance;
  };
}
function registerStageComponent$lambda($componentsInStagePrev, $componentsInStageCur, $this_registerStageComponent, $componentsInStage) {
  return function (it) {
    $componentsInStagePrev.h3();
    var this_0 = $componentsInStagePrev;
    var elements = $componentsInStageCur;
    addAll(this_0, elements);
    $componentsInStageCur.h3();
    var tmp0_iterator = ensureNotNull(get_viewsToTrack($this_registerStageComponent)).a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.korge.component.registerStageComponent.<anonymous>.<anonymous>' call
      if (hasExtra(element, '__viewStageComponent') && !(element.b9u() == null)) {
        var it_0 = get_viewStageComponent(element);
        // Inline function 'kotlin.collections.plusAssign' call
        $componentsInStageCur.h(it_0);
        if (!$componentsInStage.w2(it_0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          $componentsInStage.h(it_0);
          it_0.z9t_1.z1v($this_registerStageComponent.d9k_1);
        }
      }
    }
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = $componentsInStagePrev.ly_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.component.registerStageComponent.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_1 = array[_unary__edvuaz];
      if (!$componentsInStageCur.w2(it_1)) {
        it_1.a9u_1.z1v($this_registerStageComponent.d9k_1);
        ensureNotNull(get_viewsToTrack($this_registerStageComponent)).j3(it_1.y9t_1);
      }
    }
    return Unit_instance;
  };
}
function viewStageComponent$factory() {
  return getPropertyCallableRef('viewStageComponent', 1, KProperty1, function (receiver) {
    return get_viewStageComponent(receiver);
  }, null);
}
function viewsToTrack$factory() {
  return getPropertyCallableRef('viewsToTrack', 1, KMutableProperty1, function (receiver) {
    return get_viewsToTrack(receiver);
  }, function (receiver, value) {
    return set_viewsToTrack(receiver, value);
  });
}
function viewsToTrack$factory_0() {
  return getPropertyCallableRef('viewsToTrack', 1, KMutableProperty1, function (receiver) {
    return get_viewsToTrack(receiver);
  }, function (receiver, value) {
    return set_viewsToTrack(receiver, value);
  });
}
var properties_initialized_StageComponent_kt_b9koe7;
function _init_properties_StageComponent_kt__9w4k8v() {
  if (!properties_initialized_StageComponent_kt_b9koe7) {
    properties_initialized_StageComponent_kt_b9koe7 = true;
    viewStageComponent$delegate = new PropertyThis('__viewStageComponent', viewStageComponent$delegate$lambda);
    viewsToTrack$delegate = new Property(VOID, viewsToTrack$delegate$lambda);
  }
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, it, $completion) {
  if ($this.c9u_1.w2(it.i68_1)) {
    var tmp = $this.d9u_1(it, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, it, $completion) {
  var tmp = $this.e9u_1(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, e, $completion) {
  if ($this.f9u_1.w2(e.i68_1)) {
    var tmp = $this.g9u_1(e, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, it, $completion) {
  var tmp = $this.h9u_1(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = $this.o9u_1.m9u_1.m1w($this.p9u_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = $this.q9u_1.k9u_1.m1w($this.r9u_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.s9u_1.l9u_1.m1w($this.t9u_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$down$slambda_1($keys, $callback) {
  var i = new KeysEvents$down$slambda($keys, $callback);
  var l = function (it, $completion) {
    return i.u9u(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$down$slambda_2($callback) {
  var i = new KeysEvents$down$slambda_0($callback);
  var l = function (it, $completion) {
    return i.u9u(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$up$slambda_0($keys, $callback) {
  var i = new KeysEvents$up$slambda($keys, $callback);
  var l = function (e, $completion) {
    return i.u9u(e, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$typed$slambda_0($callback) {
  var i = new KeysEvents$typed$slambda($callback);
  var l = function (it, $completion) {
    return i.u9u(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.g67_1;
    tmp.j9u_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.v9u().q9j_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.g67_1;
    tmp.j9u_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.v9u().q9j_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.g67_1;
    tmp.j9u_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.v9u().q9j_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitSearch$delegate;
  var property = mouseHitSearch$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitSearch$delegate;
    var property = mouseHitSearch$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResult$delegate;
  var property = mouseHitResult$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResult$delegate;
    var property = mouseHitResult$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResultUsed$delegate;
  var property = mouseHitResultUsed$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResultUsed$delegate;
    var property = mouseHitResultUsed$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugHandlerOnce$delegate;
  var property = mouseDebugHandlerOnce$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugHandlerOnce$delegate;
    var property = mouseDebugHandlerOnce$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugLastFrameClicked$delegate;
  var property = mouseDebugLastFrameClicked$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugLastFrameClicked$delegate;
    var property = mouseDebugLastFrameClicked$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = mouse$delegate;
    var property = mouse$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = cursor$delegate;
  var property = cursor$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = cursor$delegate;
    var property = cursor$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.t9j_1)) {
    set_mouseHitSearch(views.t9j_1, true);
    set_mouseHitResult(views.t9j_1, views.c9l_1.d9v(views.c9v()));
    var view = get_mouseHitResult(views.t9j_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.p23();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.w9j_1.a8j(), newCursor)) {
      views.w9j_1.z8i(newCursor);
    }
  }
  return get_mouseHitResult(views.t9j_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return function (_this__u8e3s4, ctx) {
    var scale = ctx.z8a();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.o89();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_17, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.e9v();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.f9v(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.p9k_1.b81_1;
      var this_1 = this_0.k81_1;
      if (!(this_1.f81_1 === this_0)) {
        this_1.f81_1 = this_0;
        this_1.p82();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$1 = get_Bitmaps_white();
      var tmp0_tex = ctx.q82(tmp$ret$1);
      var tmp1_x = bounds.o25_1;
      var tmp2_y = bounds.p25_1;
      var tmp3_width = bounds.q25_1;
      var tmp4_height = bounds.r25_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().u3y_1, 0.3);
      var tmp6_m = mouseHit.g9v();
      this_0.r82(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.p9k_1;
      var tmp8_font = _this__u8e3s4.h9v();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.c9v().e25_1 + ',' + $views.c9v().f25_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.a81_1;
      var tmp12_blendMode = Companion_getInstance_13().s7z_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.t9j_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.e9v();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.p9k_1.b81_1;
      var this_3 = this_2.k81_1;
      if (!(this_3.f81_1 === this_2)) {
        this_3.f81_1 = this_2;
        this_3.p82();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$4 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.q82(tmp$ret$4);
      var tmp1_x_0 = bounds_0.o25_1;
      var tmp2_y_0 = bounds_0.p25_1;
      var tmp3_width_0 = bounds_0.q25_1;
      var tmp4_height_0 = bounds_0.r25_1;
      var tmp5_colorMul_0 = Companion_getInstance_2().c4d(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.g9v();
      this_2.r82(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.p9k_1;
        var tmp8_font_0 = _this__u8e3s4.h9v();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.a81_1;
        var tmp12_blendMode_0 = Companion_getInstance_13().s7z_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.p23();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return function ($this$addUpdaterWithViews, views, dt) {
    this$0.x9w(views, dt.kj_1);
    return Unit_instance;
  };
}
var Companion_instance_17;
function Companion_getInstance_42() {
  return Companion_instance_17;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.s9w_1;
  var tmp = $this;
  tmp.s9w_1 = lastEventNew == null ? $this.s9w_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.s9w_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return function (event) {
    var tmp;
    if (!this$0.j9v_1.c9x()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.g67_1;
    tmp_0.k9v_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.r9w_1 = event;
    this$0.s9w_1.r69(event);
    this$0.t9w_1 = event.n69_1;
    this$0.q9w_1 = true;
    var tmp_2;
    switch (event.z68_1.n3_1) {
      case 2:
        this$0.u9w_1.r69(event);
        this$0.l9w_1 = this$0.d9x().t9j_1.i84();
        this$0.i9w_1 = PerformanceCounter_getInstance().o64();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.i9w_1, this$0.j9w_1);
        var tmp_3;
        if (this$0.l9w_1.v2g(this$0.k9w_1) < this$0.d9x().t9j_1.p83_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.d9x().t9j_1.o83_1) < 0) {
          var _unary__edvuaz = this$0.p9w_1;
          this$0.p9w_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.e9x()) {
            this$0.m9v_1.z1v(this$0);
            var tmp_5;
            if (this$0.m9v_1.e1w() > 0) {
              event.t69(this$0.j9v_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.k69_1) {
          set_mouseDebugLastFrameClicked(this$0.d9x(), true);
        }

        this$0.j9w_1 = PerformanceCounter_getInstance().o64();
        this$0.k9w_1 = this$0.d9x().t9j_1.i84();
        var tmp_6;
        if (this$0.l9v_1.f1w()) {
          var tmp_7;
          if (this$0.e9x()) {
            this$0.l9v_1.z1v(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.e9x()) {
          this$0.b9w_1.z1v(this$0);
        } else {
          this$0.d9w_1.z1v(this$0);
        }

        this$0.c9w_1.z1v(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return function () {
    var tmp;
    if ($over) {
      this$0.s9v_1.z1v(this$0);
      tmp = Unit_instance;
    } else {
      this$0.t9v_1.z1v(this$0);
      this$0.v9v_1.z1v(this$0);
      tmp = Unit_instance;
    }
    this$0.w9v_1.z1v(this$0);
    return Unit_instance;
  };
}
function doubleClick(_this__u8e3s4, callback) {
  _init_properties_MouseEvents_kt__io5soc();
  return multiClick(_this__u8e3s4, 2, callback);
}
function multiClick(_this__u8e3s4, count, callback) {
  _init_properties_MouseEvents_kt__io5soc();
  var clickCount = {_v: 0};
  var lastClickTime = {_v: new DateTime(Companion_getInstance_5().j1u_1)};
  return _this__u8e3s4.m9v_1.y1v(multiClick$lambda(lastClickTime, clickCount, count, callback));
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function multiClick$lambda($lastClickTime, $clickCount, $count, $callback) {
  return function (it) {
    var currentClickTime = Companion_getInstance_5().n1u();
    var tmp;
    var tmp_0 = DateTime__minus_impl_10njw8(currentClickTime, $lastClickTime._v.q1u_1);
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$0 = toDuration(0.3, DurationUnit_SECONDS_getInstance());
    if (Duration__compareTo_impl_pchp0f(tmp_0, tmp$ret$0) > 0) {
      $clickCount._v = 0;
      tmp = Unit_instance;
    }
    $lastClickTime._v = new DateTime(currentClickTime);
    var _unary__edvuaz = $clickCount._v;
    $clickCount._v = _unary__edvuaz + 1 | 0;
    it.p9w_1 = $clickCount._v;
    var tmp_1;
    if ($clickCount._v === $count) {
      tmp_1 = $callback(it);
    }
    return Unit_instance;
  };
}
function mouseHitSearch$factory() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitSearch$factory_0() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitResult$factory() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResult$factory_0() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResultUsed$factory() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseHitResultUsed$factory_0() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory_0() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory_0() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouse$factory() {
  return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
    return get_mouse(receiver);
  }, null);
}
function cursor$factory() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
function cursor$factory_0() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function get_touch(_this__u8e3s4) {
  _init_properties_TouchEvents_kt__159jsq();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = touch$delegate;
    var property = touch$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var touch$delegate;
function onTouchEvent($this, views, e) {
  $this.i9y_1.h3();
  var now = views.u9j_1.n1u();
  if (e.a6b_1.equals(Type_START_getInstance())) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = e.j6b();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      if (!it.q6a_1.equals(Status_KEEP_getInstance())) {
        var info = $this.k9y($this.j9y($this.g9y_1.m2p(), it));
        info.q9x_1 = now;
        info.u9x_1 = views;
        // Inline function 'korlibs.datastructure.set' call
        var this_1 = $this.h9y_1;
        var key = info.n9x_1;
        // Inline function 'kotlin.js.asDynamic' call
        this_1.set(key, info);
        $this.z9x_1.z1v(info);
      }
    }
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_2 = e.j6b();
  var n_0 = 0;
  while (n_0 < this_2.e1()) {
    // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
    var _unary__edvuaz_0 = n_0;
    n_0 = _unary__edvuaz_0 + 1 | 0;
    var it_0 = this_2.d1(_unary__edvuaz_0);
    // Inline function 'korlibs.datastructure.get' call
    var this_3 = $this.h9y_1;
    var key_0 = it_0.n6a_1;
    // Inline function 'kotlin.js.asDynamic' call
    var info_0 = this_3.get(key_0);
    if (!(info_0 == null)) {
      info_0.t9x_1 = now;
      $this.i9y_1.h($this.j9y(info_0, it_0));
    }
  }
  if (e.a6b_1.equals(Type_START_getInstance())) {
    $this.b9y_1.z1v($this);
  }
  if (e.a6b_1.equals(Type_MOVE_getInstance())) {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = $this.i9y_1.ly_1;
    var n_1 = 0;
    while (n_1 < array.length) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_1 = array[_unary__edvuaz_1];
      $this.a9y_1.z1v(it_1);
    }
    $this.c9y_1.z1v($this);
  }
  if (e.a6b_1.equals(Type_END_getInstance())) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = e.j6b();
    var n_2 = 0;
    while (n_2 < this_4.e1()) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      var _unary__edvuaz_2 = n_2;
      n_2 = _unary__edvuaz_2 + 1 | 0;
      var it_2 = this_4.d1(_unary__edvuaz_2);
      if (!it_2.q6a_1.equals(Status_KEEP_getInstance())) {
        // Inline function 'korlibs.datastructure.get' call
        var this_5 = $this.h9y_1;
        var key_1 = it_2.n6a_1;
        // Inline function 'kotlin.js.asDynamic' call
        var info_1 = this_5.get(key_1);
        if (!(info_1 == null)) {
          $this.f9y_1.z1v($this.j9y(info_1, it_2));
          $this.d9y_1.z1v($this);
          // Inline function 'korlibs.datastructure.remove' call
          var this_6 = $this.h9y_1;
          var key_2 = info_1.n9x_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_6.delete(key_2);
          $this.g9y_1.n2p(info_1);
        }
      }
    }
  }
  $this.e9y_1.z1v($this);
}
function TouchEvents$infoPool$lambda(it) {
  return new Info(it);
}
function TouchEvents$lambda(this$0) {
  return function (e) {
    var tmp = e.g67_1;
    onTouchEvent(this$0, tmp instanceof Views ? tmp : THROW_CCE(), e);
    return Unit_instance;
  };
}
function singleTouch(_this__u8e3s4, removeTouch, supportStartAnywhere, block) {
  removeTouch = removeTouch === VOID ? false : removeTouch;
  supportStartAnywhere = supportStartAnywhere === VOID ? false : supportStartAnywhere;
  _init_properties_TouchEvents_kt__159jsq();
  var ids = FastIntMap();
  touch(_this__u8e3s4, singleTouch$lambda(_this__u8e3s4, supportStartAnywhere, ids, block, removeTouch));
}
function touch(_this__u8e3s4, block) {
  _init_properties_TouchEvents_kt__159jsq();
  return block(get_touch(_this__u8e3s4));
}
function singleTouch$getById(ids, $block, id) {
  var tmp$ret$2;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var res = ids.get(id);
    if (!(res == null)) {
      tmp$ret$2 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.input.singleTouch.getById.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = new singleTouch$SingleTouchInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.singleTouch.getById.<anonymous>.<anonymous>' call
    $block(this_0.u9y_1, id);
    var out = this_0;
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'kotlin.js.asDynamic' call
    ids.set(id, out);
    tmp$ret$2 = out;
  }
  return tmp$ret$2;
}
function touch$delegate$lambda($this$PropertyThis) {
  _init_properties_TouchEvents_kt__159jsq();
  return new TouchEvents($this$PropertyThis);
}
function singleTouch$lambda$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.n9x_1);
    var handler = info.u9y_1;
    info.v9y_1 = !($this_singleTouch.w9y(it.r9x_1) == null);
    var tmp;
    if (handler.m9y_1.f1w() && info.v9y_1) {
      handler.m9y_1.z1v(it);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($supportStartAnywhere) {
      handler.n9y_1.z1v(it);
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function singleTouch$lambda$lambda_0($supportStartAnywhere, $this_singleTouch, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.n9x_1);
    var tmp;
    if (!$supportStartAnywhere && !info.v9y_1) {
      return Unit_instance;
    }
    var handler = info.u9y_1;
    var tmp_0;
    if (handler.o9y_1.f1w() && !($this_singleTouch.w9y(it.r9x_1) == null)) {
      handler.o9y_1.z1v(it);
      tmp_0 = Unit_instance;
    }
    handler.p9y_1.z1v(it);
    return Unit_instance;
  };
}
function singleTouch$lambda$lambda_1($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.n9x_1);
    var tmp;
    if (!$supportStartAnywhere && !info.v9y_1) {
      return Unit_instance;
    }
    var handler = info.u9y_1;
    var hitTest = handler.q9y_1.f1w() || handler.s9y_1.f1w() ? !($this_singleTouch.w9y(it.r9x_1) == null) : false;
    var tmp_0;
    if (hitTest) {
      handler.q9y_1.z1v(it);
      tmp_0 = Unit_instance;
    }
    handler.r9y_1.z1v(it);
    var tmp_1;
    if (Companion_getInstance_28().q2g(it.s9x_1, it.r9x_1) <= it.d9x().t9j_1.p83_1 && Duration__compareTo_impl_pchp0f(it.v9x(), it.d9x().t9j_1.o83_1) <= 0) {
      if (info.v9y_1 && hitTest) {
        handler.s9y_1.z1v(it);
      }
      handler.t9y_1.z1v(it);
      tmp_1 = Unit_instance;
    }
    var tmp_2;
    if ($removeTouch) {
      var this_0 = $ids;
      var key = it.n9x_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_0.delete(key);
      tmp_2 = Unit_instance;
    }
    return Unit_instance;
  };
}
function singleTouch$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block, $removeTouch) {
  return function ($this$touch) {
    $this$touch.z9x_1.y1v(singleTouch$lambda$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block));
    $this$touch.a9y_1.y1v(singleTouch$lambda$lambda_0($supportStartAnywhere, $this_singleTouch, $ids, $block));
    $this$touch.f9y_1.y1v(singleTouch$lambda$lambda_1($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block));
    return Unit_instance;
  };
}
function touch$factory() {
  return getPropertyCallableRef('touch', 1, KProperty1, function (receiver) {
    return get_touch(receiver);
  }, null);
}
var properties_initialized_TouchEvents_kt_a232zc;
function _init_properties_TouchEvents_kt__159jsq() {
  if (!properties_initialized_TouchEvents_kt_a232zc) {
    properties_initialized_TouchEvents_kt_a232zc = true;
    touch$delegate = new PropertyThis(VOID, touch$delegate$lambda);
  }
}
function materialRoundRect(_this__u8e3s4, x, y, width, height, color, radius, shadowOffset, shadowColor, shadowRadius, highlightPos, highlightRadius, highlightColor, borderSize, borderColor) {
  color = color === VOID ? Colors_getInstance().u3y_1 : color;
  radius = radius === VOID ? Companion_getInstance_29().k2d_1 : radius;
  shadowOffset = shadowOffset === VOID ? Companion_getInstance_28().g25_1 : shadowOffset;
  shadowColor = shadowColor === VOID ? Colors_getInstance().t3y_1 : shadowColor;
  shadowRadius = shadowRadius === VOID ? 0.0 : shadowRadius;
  highlightPos = highlightPos === VOID ? Companion_getInstance_28().g25_1 : highlightPos;
  highlightRadius = highlightRadius === VOID ? 0.0 : highlightRadius;
  highlightColor = highlightColor === VOID ? Colors_getInstance().s3y_1 : highlightColor;
  borderSize = borderSize === VOID ? 0.0 : borderSize;
  borderColor = borderColor === VOID ? Colors_getInstance().s3y_1 : borderColor;
  $l$block: {
    // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
    var this_0 = _this__u8e3s4.a62().e6n(MaterialBlockUB_getInstance());
    var _unary__edvuaz = this_0.t6o();
    this_0.u7b(_unary__edvuaz + 1 | 0);
    this_0.v7b(this_0.t6o() + 1 | 0);
    var blockSize = this_0.x6m_1;
    var index0 = imul(this_0.t6o() - 1 | 0, blockSize);
    var index1 = imul(this_0.t6o(), blockSize);
    var texBlockSize = this_0.u6m_1.t6u().e1();
    var texIndex0 = imul(this_0.t6o() - 1 | 0, texBlockSize);
    var texIndex1 = imul(this_0.t6o(), texBlockSize);
    if (this_0.t6o() > 0) {
      arraycopy(this_0.z6m_1, index0, this_0.z6m_1, index1, blockSize);
    } else {
      arrayfill(this_0.z6m_1, 0, 0, blockSize);
    }
    // Inline function 'korlibs.korge.render.materialRoundRect.<anonymous>' call
    var $this$push = this_0.u6m_1;
    var it = this_0.a6n_1;
    it.i7c($this$push.m9z(), radius);
    it.b7c($this$push.n9z(), Vector2F.f2i(width, height));
    it.g7c($this$push.o9z(), _RGBA___get_premultipliedFast__impl__qiau4g(color));
    it.d7c($this$push.p9z(), times(highlightPos, Size2D.b2e(width, height)));
    var tmp = $this$push.q9z();
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    it.a7c(tmp, highlightRadius * tmp$ret$0 * 1.25);
    it.g7c($this$push.r9z(), _RGBA___get_premultipliedFast__impl__qiau4g(highlightColor));
    it.z7b($this$push.s9z(), borderSize * 0.5);
    it.g7c($this$push.t9z(), _RGBA___get_premultipliedFast__impl__qiau4g(borderColor));
    it.g7c($this$push.u9z(), _RGBA___get_premultipliedFast__impl__qiau4g(shadowColor));
    it.d7c($this$push.v9z(), shadowOffset);
    it.a7c($this$push.w9z(), shadowRadius);
    if (true && this_0.t6o() >= 1) {
      var equals = arrayequal(this_0.z6m_1, index0, this_0.z6m_1, index1, blockSize);
      if (equals) {
        var _unary__edvuaz_0 = this_0.t6o();
        this_0.u7b(_unary__edvuaz_0 - 1 | 0);
        break $l$block;
      }
    }
  }
  _this__u8e3s4.e8c(x, y, width, height, MaterialRender_getInstance().ia0_1, Margin.l28(shadowRadius + shadowOffset.a()));
}
function drawText_0(_this__u8e3s4, placements, textRangeStart, textRangeEnd, filtering) {
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  filtering = filtering === VOID ? _this__u8e3s4.a8c_1 : filtering;
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n_0 = 0;
  while (n_0 < placements.e1()) {
    // Inline function 'korlibs.korge.render.drawText.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    var it = placements.d1(_unary__edvuaz);
    var tmp = get_lazyBitmap(it.q5s_1);
    var tmp_0 = it.r5s_1;
    var tmp_1;
    if (tmp_0 == null ? true : tmp_0 instanceof RGBA) {
      var tmp_2 = tmp_0;
      tmp_1 = tmp_2 == null ? null : tmp_2.m4e_1;
    } else {
      tmp_1 = null;
    }
    var tmp0_elvis_lhs = tmp_1;
    var tmp_3;
    var tmp_4 = tmp0_elvis_lhs;
    if ((tmp_4 == null ? null : new RGBA(tmp_4)) == null) {
      tmp_3 = Colors_getInstance().s3y_1;
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    drawText_1(_this__u8e3s4, it.n5s_1, tmp, it.p5s_1, it.o5s_1, tmp_3, true, textRangeStart - n | 0, textRangeEnd - n | 0, filtering);
    n = n + it.n5s_1.length | 0;
  }
}
var MaterialBlockUB_instance;
function MaterialBlockUB_getInstance() {
  if (MaterialBlockUB_instance === VOID)
    new MaterialBlockUB();
  return MaterialBlockUB_instance;
}
var MaterialRender_instance;
function MaterialRender_getInstance() {
  if (MaterialRender_instance === VOID)
    new MaterialRender();
  return MaterialRender_instance;
}
function drawText_1(_this__u8e3s4, text, font, textSize, pos, color, baseline, textRangeStart, textRangeEnd, filtering) {
  textSize = textSize === VOID ? 16.0 : textSize;
  pos = pos === VOID ? Companion_getInstance_28().g25_1 : pos;
  color = color === VOID ? Colors_getInstance().s3y_1 : color;
  baseline = baseline === VOID ? false : baseline;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  filtering = filtering === VOID ? _this__u8e3s4.a8c_1 : filtering;
  var scale = font.j4q(textSize);
  var sx = pos.e25_1;
  var sy = pos.f25_1 + (baseline ? -font.b3h() * scale : 0.0);
  var n = 0;
  var inductionVariable = 0;
  var last = text.length;
  while (inductionVariable < last) {
    var char = charSequenceGet(text, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var glyph = font.l4q(char);
    if (textRangeStart <= n ? n < textRangeEnd : false) {
      _this__u8e3s4.c8c(new Rectangle(sx + glyph.u4o_1 * scale, sy + glyph.v4o_1 * scale, glyph.c4p() * scale, glyph.d4p() * scale), RGBA__times_impl_wehs9n(color, _this__u8e3s4.z8b_1), filtering, glyph.t4o_1, get_agProgram(font));
    }
    sx = sx + glyph.w4o_1 * scale;
    n = n + 1 | 0;
  }
}
function u_ShadowColor$factory() {
  return getPropertyCallableRef('u_ShadowColor', 1, KProperty1, function (receiver) {
    return receiver.u9z();
  }, null);
}
function u_ShadowRadius$factory() {
  return getPropertyCallableRef('u_ShadowRadius', 1, KProperty1, function (receiver) {
    return receiver.w9z();
  }, null);
}
function u_ShadowOffset$factory() {
  return getPropertyCallableRef('u_ShadowOffset', 1, KProperty1, function (receiver) {
    return receiver.v9z();
  }, null);
}
function u_HighlightPos$factory() {
  return getPropertyCallableRef('u_HighlightPos', 1, KProperty1, function (receiver) {
    return receiver.p9z();
  }, null);
}
function u_HighlightRadius$factory() {
  return getPropertyCallableRef('u_HighlightRadius', 1, KProperty1, function (receiver) {
    return receiver.q9z();
  }, null);
}
function u_HighlightColor$factory() {
  return getPropertyCallableRef('u_HighlightColor', 1, KProperty1, function (receiver) {
    return receiver.r9z();
  }, null);
}
function u_Size$factory() {
  return getPropertyCallableRef('u_Size', 1, KProperty1, function (receiver) {
    return receiver.n9z();
  }, null);
}
function u_Radius$factory() {
  return getPropertyCallableRef('u_Radius', 1, KProperty1, function (receiver) {
    return receiver.m9z();
  }, null);
}
function u_BorderSizeHalf$factory() {
  return getPropertyCallableRef('u_BorderSizeHalf', 1, KProperty1, function (receiver) {
    return receiver.s9z();
  }, null);
}
function u_BorderColor$factory() {
  return getPropertyCallableRef('u_BorderColor', 1, KProperty1, function (receiver) {
    return receiver.t9z();
  }, null);
}
function u_BackgroundColor$factory() {
  return getPropertyCallableRef('u_BackgroundColor', 1, KProperty1, function (receiver) {
    return receiver.o9z();
  }, null);
}
function u_ShadowColor$factory_0() {
  return getPropertyCallableRef('u_ShadowColor', 1, KProperty1, function (receiver) {
    return receiver.u9z();
  }, null);
}
function u_ShadowRadius$factory_0() {
  return getPropertyCallableRef('u_ShadowRadius', 1, KProperty1, function (receiver) {
    return receiver.w9z();
  }, null);
}
function u_ShadowOffset$factory_0() {
  return getPropertyCallableRef('u_ShadowOffset', 1, KProperty1, function (receiver) {
    return receiver.v9z();
  }, null);
}
function u_HighlightPos$factory_0() {
  return getPropertyCallableRef('u_HighlightPos', 1, KProperty1, function (receiver) {
    return receiver.p9z();
  }, null);
}
function u_HighlightRadius$factory_0() {
  return getPropertyCallableRef('u_HighlightRadius', 1, KProperty1, function (receiver) {
    return receiver.q9z();
  }, null);
}
function u_HighlightColor$factory_0() {
  return getPropertyCallableRef('u_HighlightColor', 1, KProperty1, function (receiver) {
    return receiver.r9z();
  }, null);
}
function u_Size$factory_0() {
  return getPropertyCallableRef('u_Size', 1, KProperty1, function (receiver) {
    return receiver.n9z();
  }, null);
}
function u_Radius$factory_0() {
  return getPropertyCallableRef('u_Radius', 1, KProperty1, function (receiver) {
    return receiver.m9z();
  }, null);
}
function u_BorderSizeHalf$factory_0() {
  return getPropertyCallableRef('u_BorderSizeHalf', 1, KProperty1, function (receiver) {
    return receiver.s9z();
  }, null);
}
function u_BorderColor$factory_0() {
  return getPropertyCallableRef('u_BorderColor', 1, KProperty1, function (receiver) {
    return receiver.t9z();
  }, null);
}
function u_BackgroundColor$factory_0() {
  return getPropertyCallableRef('u_BackgroundColor', 1, KProperty1, function (receiver) {
    return receiver.o9z();
  }, null);
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.e80_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.aa1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.t14(), SceneCancellationException.pa0($this));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.d9x().q9j_1.an(new InjectorContext(this$0.ba1())).an(SupervisorJob(this$0.d9x().q9j_1.zc(Key_instance))).an(CoroutineName.n1b('Scene:' + toString(this$0)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.da1(this$0.ca1().e1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.va0_1.ma3(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.ba1().c64(getKClass(Resources));
  };
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.t14();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.pa3();
  }, null);
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var scene = $this.ua6_1.a9r_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.ua6_1.a9r_1) + ' . doFullReload=' + $this.va6_1.ca7());
    var tmp;
    if ($this.va6_1.ca7()) {
      tmp = $this.va6_1.da7(getKClassFromExpression(scene), scene.ba1());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.ua6_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.y9q_1;
    var sceneInjector = this_0.x9q_1.s9j_1.v63().t63(getKClass(SceneContainer), this_0).t63(getKClass(Resources), new Resources(this_0.t14(), this_0.x9q_1.z9r().q33_1, this_0.x9q_1.z9r()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.t63(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.c64(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.va6_1.a7z(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_43().ea7_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.j2t(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.k2t(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.e64(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.x9q_1.s9j_1.x63(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.va6_1, scene));
    }
    var tmp_5 = this_0.ga7(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.d9x().f9v(scene_0.pa3());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.c64($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.a7z($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.ha7_1.pa3();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.ha7_1.ca6(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.ia7_1.pa3();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.ia7_1.da6(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  var tmp = $this.ja7_1.fa6($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.ka7_1.ga6($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.ka7_1.ha6();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.la7_1.ia6($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = $this.ma7_1.ea6($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.x9q_1.s9j_1.v63().t63(getKClass(SceneContainer), $this).t63(getKClass(Resources), new Resources($this.t14(), $this.x9q_1.z9r().q33_1, $this.x9q_1.z9r()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.t63(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.c64(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_43().ea7_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.j2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.k2t(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.e64(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.x9q_1.s9j_1.x63(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.ga7(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq.bind(VOID, $this, clazz, injects, time, transition), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.a9r_1;
  $this.a9r_1 = newScene;
  $this.z9q_1.ya9(newScene.va0_1, transition);
  try {
    var tmp = newScene.t14();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.t14();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.z9q_1);
    var initial = Companion_getInstance_37().kx_1;
    var end = Companion_getInstance_37().nx_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween_0($this.z9q_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.z9q_1.va9_1 = Companion_getInstance_37().nx_1;
  }
  $this.z9q_1.za9();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.t14();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.t14();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_18;
function Companion_getInstance_43() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).g1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.a9r_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.c64($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.jx_1, p1.jx_1, p2.jx_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.va9_1);
  }, function (value) {
    $b0.va9_1 = value.jx_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.xa9_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.aai();
  var nextAlpha = next.aai();
  try {
    prev.zah(1.0 - Ratio__toFloat_impl_1ftup5(ratio.jx_1));
    next.zah(Ratio__toFloat_impl_1ftup5(ratio.jx_1));
    prev.dad(ctx);
    next.dad(ctx);
  }finally {
    prev.zah(prevAlpha);
    next.zah(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function get_styles(_this__u8e3s4) {
  _init_properties_ViewStyles_kt__hdc4op();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = styles$delegate;
    var property = styles$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var styles$delegate;
var textFont$delegate;
var textSize$delegate;
var textColor$delegate;
var buttonBackColor$delegate;
var textAlignment$delegate;
function styles$delegate$lambda($this$PropertyThis) {
  _init_properties_ViewStyles_kt__hdc4op();
  return new ViewStyles($this$PropertyThis);
}
function styles$factory() {
  return getPropertyCallableRef('styles', 1, KProperty1, function (receiver) {
    return get_styles(receiver);
  }, null);
}
var properties_initialized_ViewStyles_kt_405jyh;
function _init_properties_ViewStyles_kt__hdc4op() {
  if (!properties_initialized_ViewStyles_kt_405jyh) {
    properties_initialized_ViewStyles_kt_405jyh = true;
    styles$delegate = new PropertyThis(VOID, styles$delegate$lambda);
    textFont$delegate = new ViewStyle(get_DefaultTtfFontAsBitmap());
    textSize$delegate = new ViewStyle(16.0);
    textColor$delegate = new ViewStyle(new RGBA(Colors_getInstance().s3y_1));
    buttonBackColor$delegate = new ViewStyle(new RGBA(Colors_getInstance().v3z_1));
    textAlignment$delegate = new ViewStyle(Companion_getInstance_3().l4w_1);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.ko(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.p6y($this$FUNC.n7j($this$FUNC.m7j(a, b), $this$FUNC.m7j($this$FUNC.n7j(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.e6x($this$IF_ELSE_BINARY_LOOKUP.h6x(), $this$IF_ELSE_BINARY_LOOKUP.p6x(Companion_getInstance_6().e87_1[n], $this$IF_ELSE_BINARY_LOOKUP.n6x($$this$buildShader.a6x(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function *_generator_invoke__zhh2q8_18($this, it, $completion) {
  if (!get_focused($this.jak_1))
    return Unit_instance;
  switch (it.i68_1.n3_1) {
    case 25:
    case 44:
    case 48:
    case 23:
    case 46:
      if ($this.jak_1.pal(it)) {
        switch (it.i68_1.n3_1) {
          case 48:
            if (it.l68_1) {
              $this.jak_1.ial();
            } else {
              $this.jak_1.hal();
            }

            break;
          case 25:
          case 46:
            var tmp;
            // Inline function 'kotlin.text.isNotEmpty' call

            var this_0 = $this.jak_1.jal();
            if (charSequenceLength(this_0) > 0) {
              tmp = new TextClipboardData($this.jak_1.jal());
            } else {
              tmp = null;
            }

            var oldText = tmp;
            if (it.i68_1.equals(Key_X_getInstance())) {
              var selection = $this.jak_1.kal();
              $this.jak_1.lal(withoutRange($this.jak_1.w5q(), $this.jak_1.kal()));
              $this.jak_1.mal(false, selection.a2_1);
            }

            if (oldText == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp_0 = _get_gameWindow__b33wdz($this.jak_1).k8k(oldText, $completion);
              if (tmp_0 === get_COROUTINE_SUSPENDED())
                tmp_0 = yield tmp_0;
            }

            break;
          case 44:
            var tmp_1 = _get_gameWindow__b33wdz($this.jak_1).l8k($completion);
            if (tmp_1 === get_COROUTINE_SUSPENDED())
              tmp_1 = yield tmp_1;
            var tmp_2 = tmp_1;
            var tmp3_safe_receiver = (tmp_2 == null ? true : tmp_2 instanceof TextClipboardData) ? tmp_2 : null;
            var rtext = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.a8l_1;
            if (!(rtext == null)) {
              $this.jak_1.nal(rtext);
            }

            break;
          case 23:
            $this.jak_1.oal();
            break;
          default:
            break;
        }
      }

      break;
    case 59:
    case 61:
      var range = $this.jak_1.kal();
      if (get_length(range) > 0) {
        $this.jak_1.lal(withoutRange($this.jak_1.w5q(), range));
        $this.jak_1.ral(range.a2_1);
      } else {
        if (it.i68_1.equals(Key_BACKSPACE_getInstance())) {
          if ($this.jak_1.qal() > 0) {
            var oldCursorIndex = $this.jak_1.qal();
            $this.jak_1.lal(withoutIndex($this.jak_1.w5q(), $this.jak_1.qal() - 1 | 0));
            $this.jak_1.ral(oldCursorIndex - 1 | 0);
          }
        } else {
          if ($this.jak_1.qal() < $this.jak_1.w5q().length) {
            $this.jak_1.lal(withoutIndex($this.jak_1.w5q(), $this.jak_1.qal()));
          }
        }
      }

      break;
    case 63:
      if ($this.jak_1.val(it)) {
        $this.jak_1.mal(it.l68_1, 0);
      } else {
        $this.jak_1.mal(it.l68_1, $this.jak_1.ual($this.jak_1.sal(), $this.jak_1.tal(it)));
      }

      break;
    case 62:
      if ($this.jak_1.val(it)) {
        $this.jak_1.mal(it.l68_1, $this.jak_1.w5q().length);
      } else {
        $this.jak_1.mal(it.l68_1, $this.jak_1.wal($this.jak_1.sal(), $this.jak_1.tal(it)));
      }

      break;
    case 74:
      $this.jak_1.mal(it.l68_1, 0);
      break;
    case 75:
      $this.jak_1.mal(it.l68_1, $this.jak_1.w5q().length);
      break;
    default:
      break;
  }
  return Unit_instance;
}
function setTextNoSnapshot($this, text, out) {
  if (!$this.gal_1($this.lak_1.w5q(), text))
    return null;
  out.xal_1 = $this.lak_1.w5q();
  out.yal_1 = $this.kal();
  $this.lak_1.lal(text);
  reclampSelection($this);
  $this.tak_1.z1v($this);
  return out;
}
function setTextNoSnapshot$default($this, text, out, $super) {
  out = out === VOID ? new TextSnapshot('', numberRangeToNumber(0, 0)) : out;
  return setTextNoSnapshot($this, text, out);
}
function clampIndex($this, index) {
  return clamp(index, 0, $this.w5q().length);
}
function reclampSelection($this) {
  $this.xap($this.sal(), $this.wap());
  $this.yap($this.sal());
}
function _get_gameWindow__b33wdz($this) {
  return ensureNotNull($this.lak_1.b9u()).d9x().w9j_1;
}
function TextEditController$lambda($this$onNewAttachDetach, it) {
  get_uiFocusManager($this$onNewAttachDetach.c9l_1);
  return Unit_instance;
}
function TextEditController$acceptTextChange$lambda(old, new_0) {
  return true;
}
function TextEditController$lambda_0(this$0) {
  return function () {
    var tmp;
    if (!get_focused(this$0)) {
      this$0.zak_1.l8j(false);
      tmp = Unit_instance;
    } else {
      var tmp_0;
      if (this$0.zap() === 0) {
        this$0.zak_1.l8j(!this$0.zak_1.dai());
        tmp_0 = Unit_instance;
      } else {
        this$0.zak_1.l8j(true);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
function TextEditController$slambda_1(this$0) {
  var i = new TextEditController$slambda(this$0);
  var l = function (it, $completion) {
    return i.u9u(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function TextEditController$slambda_2(this$0) {
  var i = new TextEditController$slambda_0(this$0);
  var l = function (it, $completion) {
    return i.u9u(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function TextEditController$lambda_1(this$0) {
  return function (it) {
    this$0.wak_1.z1v(this$0);
    var tmp0_safe_receiver = this$0.oak_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mas_1 = true;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_2(this$0) {
  return function (it) {
    this$0.xak_1.z1v(this$0);
    var tmp0_safe_receiver = this$0.oak_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mas_1 = false;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_3(this$0, $dragging) {
  return function (it) {
    this$0.ral(this$0.oas(it.h9x()));
    $dragging._v = false;
    set_focused(this$0, true);
    return Unit_instance;
  };
}
function TextEditController$lambda_4(this$0, $dragging) {
  return function (it) {
    this$0.ral(this$0.oas(it.h9x()));
    $dragging._v = false;
    return Unit_instance;
  };
}
function TextEditController$lambda_5($dragging, this$0) {
  return function (it) {
    $dragging._v = false;
    var tmp;
    if (get_focused(this$0)) {
      set_focused(this$0, false);
      blur(this$0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_6(this$0, $dragging) {
  return function (it) {
    var tmp;
    if (get_focused(this$0) && it.k9x()) {
      $dragging._v = true;
      this$0.pas(this$0.oas(it.h9x()));
      it.j9x();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_7($dragging, this$0) {
  return function (it) {
    var tmp;
    if (!$dragging._v && get_focused(this$0)) {
      blur(this$0);
      tmp = Unit_instance;
    }
    $dragging._v = false;
    return Unit_instance;
  };
}
function TextEditController$lambda_8(this$0) {
  return function (it) {
    var index = this$0.oas(it.h9x());
    this$0.xap(this$0.ual(index, true), this$0.wal(index, true));
    return Unit_instance;
  };
}
function color$factory($b0) {
  return getPropertyCallableRef('color', 0, KMutableProperty0, function () {
    return new RGBA($b0.h5e());
  }, function (value) {
    return $b0.wav(value.m4e_1);
  });
}
function get_timers(_this__u8e3s4) {
  _init_properties_TimerComponents_kt__j84oeh();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = timers$delegate;
    var property = timers$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var timers$delegate;
function ensureUpdater($this) {
  if (!($this.cav_1 == null))
    return Unit_instance;
  var tmp = $this;
  tmp.cav_1 = addFastUpdater_0($this.yau_1, TimerComponents$ensureUpdater$lambda($this));
}
function addTimer($this, autoRemove, callback) {
  if ($this.bav_1.o27()) {
    var index = $this.bav_1.l3($this.bav_1.e1() - 1 | 0);
    $this.zau_1.k3(index, callback);
    // Inline function 'korlibs.math.toInt' call
    var tmp$ret$0 = autoRemove ? 1 : 0;
    $this.aav_1.a2k(index, tmp$ret$0);
    ensureUpdater($this);
    return _TimerRef___init__impl__cysrar(index);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  $this.zau_1.h(callback);
  // Inline function 'korlibs.math.toInt' call
  var tmp$ret$1 = autoRemove ? 1 : 0;
  $this.aav_1.t2j(tmp$ret$1);
  ensureUpdater($this);
  return _TimerRef___init__impl__cysrar($this.zau_1.e1() - 1 | 0);
}
function removeTimer($this, ref) {
  $this.zau_1.k3(_TimerRef___get_index__impl__pnrx4q(ref), null);
  $this.aav_1.a2k(_TimerRef___get_index__impl__pnrx4q(ref), 0);
  $this.bav_1.t2j(_TimerRef___get_index__impl__pnrx4q(ref));
}
function _interval($this, time, repeat, callback) {
  var elapsed = {_v: new FastDuration(get_fastMilliseconds_0(0))};
  var ref = {_v: new TimerRef(_TimerRef___init__impl__cysrar(-1))};
  ref._v = new TimerRef(addTimer($this, false, TimerComponents$_interval$lambda(elapsed, time, repeat, $this, ref, callback)));
  return Closeable(TimerComponents$_interval$lambda_0($this, ref));
}
function TimerComponents$ensureUpdater$lambda(this$0) {
  return function ($this$addFastUpdater, dt) {
    var this_0 = this$0.zau_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.time.TimerComponents.ensureUpdater.<anonymous>.<anonymous>' call
      var index = n;
      var tmp0_safe_receiver = this_0.d1(n);
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(dt);
      if (!(this$0.aav_1.d1(index) === 0)) {
        removeTimer(this$0, _TimerRef___init__impl__cysrar(index));
      }
      n = n + 1 | 0;
    }
    var tmp;
    if (this$0.zau_1.g1()) {
      var tmp0_safe_receiver_0 = this$0.cav_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.c6();
      }
      this$0.cav_1 = null;
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda($elapsed, $time, $repeat, this$0, $ref, $callback) {
  return function (dt) {
    $elapsed._v = new FastDuration(FastDuration__plus_impl_q1enab($elapsed._v.v1u_1, dt.v1u_1));
    $l$loop: while (FastDuration__compareTo_impl_4fhnj7($elapsed._v.v1u_1, $time) >= 0) {
      if (!$repeat) {
        removeTimer(this$0, $ref._v.xav_1);
      }
      $elapsed._v = new FastDuration(FastDuration__minus_impl_evs237($elapsed._v.v1u_1, $time));
      $callback();
      if (!$repeat)
        break $l$loop;
    }
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda_0(this$0, $ref) {
  return function () {
    removeTimer(this$0, $ref._v.xav_1);
    return Unit_instance;
  };
}
function _TimerRef___init__impl__cysrar(index) {
  return index;
}
function _TimerRef___get_index__impl__pnrx4q($this) {
  return $this;
}
function TimerRef__toString_impl_8hh2j7($this) {
  return 'TimerRef(index=' + $this + ')';
}
function TimerRef__hashCode_impl_d9ou9o($this) {
  return $this;
}
function TimerRef__equals_impl_2fvpr4($this, other) {
  if (!(other instanceof TimerRef))
    return false;
  if (!($this === (other instanceof TimerRef ? other.xav_1 : THROW_CCE())))
    return false;
  return true;
}
function timers$delegate$lambda($this$PropertyThis) {
  _init_properties_TimerComponents_kt__j84oeh();
  return new TimerComponents($this$PropertyThis);
}
function timers$factory() {
  return getPropertyCallableRef('timers', 1, KProperty1, function (receiver) {
    return get_timers(receiver);
  }, null);
}
var properties_initialized_TimerComponents_kt_v7ywzv;
function _init_properties_TimerComponents_kt__j84oeh() {
  if (!properties_initialized_TimerComponents_kt_v7ywzv) {
    properties_initialized_TimerComponents_kt_v7ywzv = true;
    timers$delegate = new PropertyThis('__ViewTimerComponents', timers$delegate$lambda);
  }
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_1(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.t1u() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds_0(300));
      } else {
        tmp_0 = Companion_instance_1.t1u();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.naw(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_1(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.t1u() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21.bind(VOID, _this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback), $completion);
}
function _update($this, dt) {
  if ($this.gaw_1) {
    $this.zav_1.r9t();
  }
  if ($this.jaw_1) {
    return $this.saw();
  }
  $this.haw_1 = FastDuration__plus_impl_q1enab($this.haw_1, dt);
  var ratio = clamp_0(FastDuration__div_impl_rlslck($this.haw_1, $this.iaw_1), 0.0, 1.0);
  $this.naw($this.haw_1);
  $this.daw_1($this.caw_1.dx(ratio));
  var tmp;
  var tmp_0 = $this.taw();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7_0($this.haw_1, $this.taw()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.uaw();
  }
  if (ratio >= 1.0) {
    return $this.saw();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.q8l_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.jaw_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.t1u()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.mc();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0.bind(VOID, time, block), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_19($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.j19();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.vaw_1;
  $this.waw_1._v = new TweenComponent(view, toList($this.xaw_1), $this.yaw_1, $this.zaw_1, $this.aax_1, cancellable, $this.bax_1, $this.cax_1);
  var tmp$ret$0 = cancellable.v16();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.w1n($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_36());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function *_generator_invoke__zhh2q8_20($this, $completion) {
  var tmp = $this.dax_1($this.eax_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_21($this, $completion) {
  var tmp = $this.fax_1($this.gax_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_19;
function Companion_getInstance_44() {
  if (Companion_instance_19 === VOID)
    new Companion_4();
  return Companion_instance_19;
}
function _get_halfSide__37ya73($this) {
  // Inline function 'kotlin.math.min' call
  var a = $this.m2i();
  var b = $this.n2i();
  var tmp$ret$0 = Math.min(a, b);
  return numberToInt(tmp$ret$0) / 2 | 0;
}
function setInitialState($this) {
  var width = $this.m2i();
  var height = $this.n2i();
  size($this.mb0_1, width, height);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_29();
  var corner = $this.zb0();
  var tmp$ret$0 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  $this.mb0_1.fb4(tmp$ret$0);
  $this.mb0_1.gb4($this.lb0_1 ? 10.0 : 0.0);
  size($this.nb0_1, width, height);
  var tmp = Companion_getInstance_45();
  var tmp0_elvis_lhs = $this.vb0_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    tmp_0 = get_Bitmaps_transparent();
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  tmp.kb4($this.pb0_1, tmp_0, width, height, Companion_getInstance_26().j24_1);
  $this.pb0_1.zah(!$this.lb4() ? 0.5 : $this.qb0_1 ? 1.0 : 1.0);
  $this.r9t();
}
function UIButton$lambda$lambda(this$0) {
  return function (it) {
    this$0.mb4(it.w9x() / this$0.m2i(), it.x9x() / this$0.n2i());
    var tmp;
    if (this$0.qav()) {
      set_focused(this$0, true);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function UIButton$lambda$lambda_0(this$0) {
  return function (it) {
    this$0.jb7();
    return Unit_instance;
  };
}
function UIButton$lambda$lambda_1(this$0) {
  return function (it) {
    this$0.wb0_1.z1v(it);
    return Unit_instance;
  };
}
function UIButton$lambda(this$0) {
  return function ($this$singleTouch, it) {
    $this$singleTouch.m9y_1.y1v(UIButton$lambda$lambda(this$0));
    $this$singleTouch.r9y_1.y1v(UIButton$lambda$lambda_0(this$0));
    $this$singleTouch.s9y_1.y1v(UIButton$lambda$lambda_1(this$0));
    return Unit_instance;
  };
}
function UIButton$slambda_3($$this$mouse, this$0) {
  var i = new UIButton$slambda($$this$mouse, this$0);
  var l = function (it, $completion) {
    return i.mb7(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$lambda$slambda_1($handler, $it) {
  var i = new UIButton$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function UIButton$lambda_0($this, $handler) {
  return function (it) {
    var tmp = $this.g9x();
    launchImmediately_0(tmp, UIButton$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function UIButton$slambda_4($$this$mouse, this$0) {
  var i = new UIButton$slambda_0($$this$mouse, this$0);
  var l = function (it, $completion) {
    return i.mb7(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$lambda$slambda_2($handler, $it) {
  var i = new UIButton$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function UIButton$lambda_1($this, $handler) {
  return function (it) {
    var tmp = $this.g9x();
    launchImmediately_0(tmp, UIButton$lambda$slambda_2($handler, it));
    return Unit_instance;
  };
}
function _interpolateColor$ref() {
  var l = function (p0, p1, p2) {
    return new RGBA(_interpolateColor(p0.jx_1, p1.m4e_1, p2.m4e_1));
  };
  l.callableName = '_interpolateColor';
  return l;
}
function UIButton$slambda_5(this$0) {
  var i = new UIButton$slambda_1(this$0);
  var l = function (it, $completion) {
    return i.u9u(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$slambda_6(this$0, $$this$keys) {
  var i = new UIButton$slambda_2(this$0, $$this$keys);
  var l = function (it, $completion) {
    return i.u9u(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function align$factory($b0) {
  return getPropertyCallableRef('align', 0, KMutableProperty0, function () {
    return $b0.uba_1;
  }, function (value) {
    return $b0.dbe(value);
  });
}
function text$factory($b0) {
  return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
    return $b0.tba_1;
  }, function (value) {
    return $b0.ebe(value);
  });
}
function over$factory() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.n9v_1;
  }, null);
}
function out$factory() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.o9v_1;
  }, null);
}
function bgColor$factory($b0) {
  return getPropertyCallableRef('bgColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.ub3_1);
  }, function (value) {
    return $b0.abe(value.m4e_1);
  });
}
function get_UI_DEFAULT_SIZE() {
  _init_properties_UIDefaults_kt__ebmksm();
  return UI_DEFAULT_SIZE;
}
var UI_DEFAULT_SIZE;
var properties_initialized_UIDefaults_kt_arkqjc;
function _init_properties_UIDefaults_kt__ebmksm() {
  if (!properties_initialized_UIDefaults_kt_arkqjc) {
    properties_initialized_UIDefaults_kt_arkqjc = true;
    UI_DEFAULT_SIZE = Size2D.l26(100, 32);
  }
}
function set__focusable(_this__u8e3s4, _set____db54di) {
  _init_properties_UIFocusManager_kt__odyms7();
  var this_0 = _focusable$delegate;
  var property = _focusable$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__focusable(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _focusable$delegate;
    var property = _focusable$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _focusable$delegate;
function get_uiFocusManager(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = uiFocusManager$delegate;
    var property = uiFocusManager$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var uiFocusManager$delegate;
function set_focused(_this__u8e3s4, value) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_safe_receiver = _this__u8e3s4.fav(Scope_instance).b9u();
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_uiFocusManager(tmp0_safe_receiver);
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.fbe(value ? _this__u8e3s4 : null);
  }
}
function get_focused(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_safe_receiver = _this__u8e3s4.fav(Scope_instance).b9u();
  return equals(tmp0_safe_receiver == null ? null : get_uiFocusedView(tmp0_safe_receiver), _this__u8e3s4);
}
function focus(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  set_focused(_this__u8e3s4, true);
}
function blur(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  set_focused(_this__u8e3s4, false);
}
var Scope_instance;
function Scope_getInstance() {
  return Scope_instance;
}
function _get_rfocusView__qys03k(_this__u8e3s4, $this) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIFocusManager.<get-rfocusView>.<anonymous>' call
  return _this__u8e3s4.fav(Scope_instance);
}
function UIFocusManager$changeFocusIndex$lambda(it) {
  return !(get_focusable(it) == null);
}
function UIFocusManager$changeFocusIndex$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
  var tmp = a.pav();
  // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
  var tmp$ret$1 = b.pav();
  return compareValues(tmp, tmp$ret$1);
}
function UIFocusManager$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it.i68_1.equals(Key_TAB_getInstance())) {
      this$0.hbe(it.l68_1 ? -1 : 1);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function get_uiFocusedView(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  return get_uiFocusManager(_this__u8e3s4).uav_1;
}
function set_focusable(_this__u8e3s4, value) {
  _init_properties_UIFocusManager_kt__odyms7();
  set__focusable(_this__u8e3s4, value);
}
function get_focusable(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, UIFocusable) ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? get__focusable(_this__u8e3s4) : tmp0_elvis_lhs;
}
function _focusable$delegate$lambda() {
  _init_properties_UIFocusManager_kt__odyms7();
  return null;
}
function uiFocusManager$delegate$lambda($this$PropertyThis) {
  _init_properties_UIFocusManager_kt__odyms7();
  return new UIFocusManager($this$PropertyThis);
}
function _focusable$factory() {
  return getPropertyCallableRef('_focusable', 1, KMutableProperty1, function (receiver) {
    return get__focusable(receiver);
  }, function (receiver, value) {
    return set__focusable(receiver, value);
  });
}
function _focusable$factory_0() {
  return getPropertyCallableRef('_focusable', 1, KMutableProperty1, function (receiver) {
    return get__focusable(receiver);
  }, function (receiver, value) {
    return set__focusable(receiver, value);
  });
}
function uiFocusManager$factory() {
  return getPropertyCallableRef('uiFocusManager', 1, KProperty1, function (receiver) {
    return get_uiFocusManager(receiver);
  }, null);
}
var properties_initialized_UIFocusManager_kt_a5rjit;
function _init_properties_UIFocusManager_kt__odyms7() {
  if (!properties_initialized_UIFocusManager_kt_a5rjit) {
    properties_initialized_UIFocusManager_kt_a5rjit = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _focusable$delegate$lambda;
    _focusable$delegate = new Property(null, default_0);
    uiFocusManager$delegate = new PropertyThis(VOID, uiFocusManager$delegate$lambda);
  }
}
function _interpolate$ref() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.jx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function UIMaterialLayer$Highlights$addHighlight$lambda(this$0) {
  return function (it) {
    this$0.kbe_1.r9t();
    return Unit_instance;
  };
}
function _interpolate$ref_0() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.jx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function _interpolate$ref_1() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.jx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function UIMaterialLayer$Highlights$removeHighlight$lambda(this$0) {
  return function (it) {
    this$0.kbe_1.r9t();
    return Unit_instance;
  };
}
function UIMaterialLayer$Highlights$removeHighlight$lambda_0(this$0, $highlight) {
  return function () {
    this$0.lbe_1.j3($highlight);
    return Unit_instance;
  };
}
function _get_computedRadius__cigsus($this) {
  var tmp0_safe_receiver = $this.wb3_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = $this.m2i();
    var b = $this.n2i();
    var tmp$ret$0 = Math.min(a, b);
    tmp = tmp0_safe_receiver.t2d(tmp$ret$0 / 2.0);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? $this.vb3_1 : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? Companion_getInstance_29().k2d_1 : tmp2_elvis_lhs;
}
function radiusRatio$factory($b0) {
  return getPropertyCallableRef('radiusRatio', 0, KMutableProperty0, function () {
    return $b0.obe_1;
  }, function (value) {
    $b0.obe_1 = value;
    return Unit_instance;
  });
}
function radiusRatio$factory_0($b0) {
  return getPropertyCallableRef('radiusRatio', 0, KMutableProperty0, function () {
    return $b0.obe_1;
  }, function (value) {
    $b0.obe_1 = value;
    return Unit_instance;
  });
}
function alpha$factory($b0) {
  return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
    return $b0.pbe_1;
  }, function (value) {
    $b0.pbe_1 = value;
    return Unit_instance;
  });
}
function containerPos$factory() {
  return getPropertyCallableRef('containerPos', 1, KMutableProperty1, function (receiver) {
    return receiver.qbi();
  }, function (receiver, value) {
    return receiver.rbi(value);
  });
}
function containerPos$factory_0() {
  return getPropertyCallableRef('containerPos', 1, KMutableProperty1, function (receiver) {
    return receiver.qbi();
  }, function (receiver, value) {
    return receiver.rbi(value);
  });
}
function set_uiTextInputBackgroundRender(_this__u8e3s4, _set____db54di) {
  _init_properties_UITextInput_kt__kefnmf();
  uiTextInputBackgroundRender$delegate;
  var property = uiTextInputBackgroundRender$factory();
  if (_this__u8e3s4.waj_1 == null)
    _this__u8e3s4.waj_1 = linkedHashMapOf([]);
  // Inline function 'kotlin.collections.set' call
  var this_0 = ensureNotNull(_this__u8e3s4.waj_1);
  var key = property.callableName;
  this_0.e3(key, _set____db54di);
  _this__u8e3s4.bak();
  return Unit_instance;
}
function get_uiTextInputBackgroundRender(_this__u8e3s4) {
  _init_properties_UITextInput_kt__kefnmf();
  // Inline function 'korlibs.korge.style.ViewStyle.getValue' call
  var this_0 = uiTextInputBackgroundRender$delegate;
  var property = uiTextInputBackgroundRender$factory_0();
  var tmp = _this__u8e3s4.yaj(property, this_0.cak_1);
  var tmp0_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : null;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var message = "Can't cast " + toString(property) + ' to T';
    throw IllegalStateException.w4(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
var uiTextInputBackgroundRender$delegate;
function UITextInput$bg$lambda($this$renderableView) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UITextInput.bg.<anonymous>.<anonymous>' call
  get_uiTextInputBackgroundRender(get_styles($this$renderableView)).tbi($this$renderableView);
  return Unit_instance;
}
function uiTextInputBackgroundRender$delegate$lambda($this$ViewRenderer) {
  _init_properties_UITextInput_kt__kefnmf();
  $this$ViewRenderer.gbr().d8c(new Rectangle(0.0, 0.0, $this$ViewRenderer.m2i(), $this$ViewRenderer.n2i()), Colors_getInstance().s3y_1);
  return Unit_instance;
}
function uiTextInputBackgroundRender$factory() {
  return getPropertyCallableRef('uiTextInputBackgroundRender', 1, KMutableProperty1, function (receiver) {
    return get_uiTextInputBackgroundRender(receiver);
  }, function (receiver, value) {
    return set_uiTextInputBackgroundRender(receiver, value);
  });
}
function uiTextInputBackgroundRender$factory_0() {
  return getPropertyCallableRef('uiTextInputBackgroundRender', 1, KMutableProperty1, function (receiver) {
    return get_uiTextInputBackgroundRender(receiver);
  }, function (receiver, value) {
    return set_uiTextInputBackgroundRender(receiver, value);
  });
}
function viewRenderer$factory($b0) {
  return getPropertyCallableRef('viewRenderer', 0, KMutableProperty0, function () {
    return $b0.kas_1;
  }, function (value) {
    $b0.kas_1 = value;
    return Unit_instance;
  });
}
function text$factory_0($b0) {
  return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
    return $b0.w5q();
  }, function (value) {
    return $b0.lal(value);
  });
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.jav();
  }, function (value) {
    return $b0.iav(value);
  });
}
function font$factory($b0) {
  return getPropertyCallableRef('font', 0, KMutableProperty0, function () {
    return $b0.t50();
  }, function (value) {
    return $b0.gav(value);
  });
}
function onReturnPressed$factory($b0) {
  return getPropertyCallableRef('onReturnPressed', 0, KProperty0, function () {
    return $b0.sak_1;
  }, null);
}
function onEscPressed$factory($b0) {
  return getPropertyCallableRef('onEscPressed', 0, KProperty0, function () {
    return $b0.rak_1;
  }, null);
}
function onFocusLost$factory($b0) {
  return getPropertyCallableRef('onFocusLost', 0, KProperty0, function () {
    return $b0.vak_1;
  }, null);
}
function selectionRange$factory($b0) {
  return getPropertyCallableRef('selectionRange', 0, KMutableProperty0, function () {
    return $b0.kal();
  }, function (value) {
    return $b0.kav(value);
  });
}
function selectionStart$factory($b0) {
  return getPropertyCallableRef('selectionStart', 0, KMutableProperty0, function () {
    return $b0.sal();
  }, function (value) {
    return $b0.yap(value);
  });
}
function selectionEnd$factory($b0) {
  return getPropertyCallableRef('selectionEnd', 0, KMutableProperty0, function () {
    return $b0.wap();
  }, function (value) {
    return $b0.pas(value);
  });
}
function selectionLength$factory($b0) {
  return getPropertyCallableRef('selectionLength', 0, KProperty0, function () {
    return $b0.zap();
  }, null);
}
function text$factory_1() {
  return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
    return receiver.w5q();
  }, function (receiver, value) {
    return receiver.lal(value);
  });
}
function text$factory_2() {
  return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
    return receiver.w5q();
  }, function (receiver, value) {
    return receiver.lal(value);
  });
}
var properties_initialized_UITextInput_kt_7ksi6x;
function _init_properties_UITextInput_kt__kefnmf() {
  if (!properties_initialized_UITextInput_kt_7ksi6x) {
    properties_initialized_UITextInput_kt_7ksi6x = true;
    var tmp = uiTextInputBackgroundRender$delegate$lambda;
    uiTextInputBackgroundRender$delegate = new ViewStyle(new sam$korlibs_korge_view_ViewRenderer$0_0(tmp));
  }
}
function registerUISupportOnce($this) {
  if ($this.vac_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.b9u();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.vac_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_20;
function Companion_getInstance_45() {
  if (Companion_instance_20 === VOID)
    new Companion_5();
  return Companion_instance_20;
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.vbe(anchor);
  return _this__u8e3s4;
}
function clearBitmaps($this, onParentChanged) {
  if ($this.vby_1.g1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.vby_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.d1(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$0))) {
      var tmp0_safe_receiver = $this.abz_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w80_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.s86(it, 'BaseGraphics');
      }
    }
  }
  $this.vby_1.h3();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.x5i().m2i();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.x5i().n2i();
}
function _getLocalBoundsInternal($this, strokes) {
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.o25_1 - $this.tag(), bounds.p25_1 - $this.uag(), bounds.q25_1, bounds.r25_1);
}
function _getLocalBoundsInternal$default($this, strokes, $super) {
  strokes = strokes === VOID ? $this.ebz_1 : strokes;
  return _getLocalBoundsInternal($this, strokes);
}
function boundsUnsafe($this, strokes) {
  if ($this.zby_1) {
    $this.zby_1 = false;
    $this.gbz_1 = $this.hbz(false);
    $this.fbz_1 = $this.hbz(true);
  }
  return strokes ? $this.fbz_1 : $this.gbz_1;
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.o5z();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.ma3(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.ecb();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.jag(this_0);
  return this_0;
}
var Companion_instance_21;
function Companion_getInstance_46() {
  return Companion_instance_21;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().p64())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.d9x().o9l_1;
  tmp.y1v(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.d9x().p9k_1).e8a_1;
  tmp_0.y1v(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.d9x().p9k_1.b81_1.j82_1;
  tmp_1.y1v(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.d9x().p9k_1.b81_1.k82_1;
  tmp_2.y1v(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.d9x();
  tmp_3.gcb(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.m8a_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.z87() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.h9v();
  var tmp1_colMul = $ctx.a81_1;
  var tmp2_blendMode = Companion_getInstance_13().s7z_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.z8a();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().p64();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.v1u_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, get_fastMilliseconds_0(4)) > 0) {
        $longWindow.ncb(elapsedTime);
        $shortWindow.ncb(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.d9k_1.o89();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.lcb(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_38().gu() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.p9k_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.d8a_1;
    if (!(this_2.f81_1 === this_1)) {
      this_2.f81_1 = this_1;
      this_2.p82();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.p8a_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().s7z_1;
          var doUpdate = !(this_1.o8a_1 === blending);
          var old = this_1.o8a_1;
          try {
            if (doUpdate) {
              this_1.d8a_1.p82();
              this_1.o8a_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().i44_1;
            var oldColor = this_1.g8a_1;
            this_1.g8a_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.u8a(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.u8a(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.g8a_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().s3y_1 : Colors_getInstance().t3y_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.g8a_1;
                this_1.g8a_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.e1() / $longWindow.hcb_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.e1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange_0(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var p1 = convertRange_0(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds_0(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.e1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.mcb(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.mcb(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.u8a(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.g8a_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.d8a_1.p82();
            }
            this_1.o8a_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.p8a_1;
  }, function (value) {
    $b0.p8a_1 = value;
    return Unit_instance;
  });
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.wcd_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.xcd_1 : tmp0_elvis_lhs);
}
function ensure_0($this) {
  if ($this.dce_1.n3_1 === 2) {
    if (!($this.wcd_1 == null)) {
      var tmp1_safe_receiver = $this.wcd_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.wai();
      }
      $this.wcd_1 = null;
    }
    if ($this.xcd_1 == null) {
      var tmp = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.dch(EmptyShape_instance, true);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
      var tmp$ret$2 = (new ShapeBuilder(null, null)).i4v();
      this_0.ech(tmp$ret$2);
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_1.fch($this.ycd_1);
      this_1.ecg_1 = $this.bce_1;
      this_1.gcg_1 = $this.ace_1;
      this_1.ech($this.cce_1);
      tmp.xcd_1 = this_1;
    }
  } else {
    if (!($this.xcd_1 == null)) {
      var tmp2_safe_receiver = $this.xcd_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.wai();
      }
      $this.xcd_1 = null;
    }
    if ($this.wcd_1 == null) {
      var tmp_0 = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.zc8(false), $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      var tmp$ret$9 = (new ShapeBuilder(null, null)).i4v();
      this_2.ac9(tmp$ret$9);
      if (false) {
        this_2.tbz();
      }
      this_2.zby_1 = true;
      this_2.kai();
      this_2.tbz();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_2.tc8_1 = $this.ycd_1;
      this_2.rby_1 = $this.bce_1;
      this_2.xc1_1 = $this.ace_1;
      this_2.ac9($this.cce_1);
      tmp_0.wcd_1 = this_2;
    }
    var tmp3_safe_receiver = $this.wcd_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.rbz($this.dce_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.lch($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.bi('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.pbt(tmp_0);
    $this.iah(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.pbt(tmp$ret$0);
      $this.iah(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.sbd_1.lch(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.obt_1.zy();
  if (!(source == null)) {
    $this.nbt_1 = true;
    $this.jc2(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.vch();
  }, function (value) {
    return $b0.uch(value);
  });
}
var Companion_instance_22;
function Companion_getInstance_47() {
  return Companion_instance_22;
}
var Companion_instance_23;
function Companion_getInstance_48() {
  return Companion_instance_23;
}
function _set_animationNumberOfFramesRequested__tjl77x($this, value) {
  if (value === 0) {
    $this.ccn();
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    if ($this.qcm_1 === _AnimationType___init__impl__l3ftd1(0)) {
      triggerEvent($this, $this.ecn());
    } else {
      triggerEvent($this, $this.dcn());
    }
  }
  $this.pcm_1 = value;
}
function _set_animationRemainingDuration__f6834h($this, value) {
  var tmp;
  // Inline function 'korlibs.time.milliseconds' call
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
  if (FastDuration__compareTo_impl_4fhnj7_0(value, tmp$ret$1) <= 0) {
    var tmp_0 = $this.qcm_1;
    // Inline function 'korlibs.korge.view.Companion.DURATION' call
    tmp = tmp_0 === _AnimationType___init__impl__l3ftd1(2);
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.ccn();
    triggerEvent($this, $this.rcm_1);
  }
  $this.ycm_1 = value;
}
function _set_currentSpriteIndex__7b2y7x($this, value) {
  $this.acn_1 = umod(value, $this.fcn());
  var tmp0_safe_receiver = $this.zcm_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.icn(value);
  $this.pbt(tmp1_elvis_lhs == null ? $this.x5i() : tmp1_elvis_lhs);
}
function getDefaultTime($this, spriteAnimation) {
  return !(spriteAnimation == null) && !equals(spriteAnimation.hcn_1, Companion_instance_1.t1u()) ? spriteAnimation.hcn_1 : $this.vcm_1;
}
function nextSprite($this, frameTime) {
  $this.xcm_1 = FastDuration__plus_impl_q1enab($this.xcm_1, frameTime);
  if (FastDuration__compareTo_impl_4fhnj7(FastDuration__plus_impl_q1enab($this.xcm_1, frameTime), $this.vcm_1) >= 0) {
    var tmp0_subject = $this.qcm_1;
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    if (tmp0_subject === _AnimationType___init__impl__l3ftd1(0)) {
      if ($this.pcm_1 > 0) {
        var _unary__edvuaz = $this.pcm_1;
        _set_animationNumberOfFramesRequested__tjl77x($this, _unary__edvuaz - 1 | 0);
      }
    } else {
      // Inline function 'korlibs.korge.view.Companion.DURATION' call
      if (tmp0_subject === _AnimationType___init__impl__l3ftd1(2)) {
        _set_animationRemainingDuration__f6834h($this, FastDuration__minus_impl_evs237($this.ycm_1, $this.xcm_1));
      } else {
        // Inline function 'korlibs.korge.view.Companion.LOOPED' call
        _AnimationType___init__impl__l3ftd1(1);
      }
    }
    if ($this.bcn_1) {
      _set_currentSpriteIndex__7b2y7x($this, $this.acn_1 - 1 | 0);
    } else {
      _set_currentSpriteIndex__7b2y7x($this, $this.acn_1 + 1 | 0);
    }
    $this.ocm_1 = $this.ocm_1 + 1 | 0;
    triggerEvent($this, $this.ucm_1);
    $this.xcm_1 = get_fastSeconds(0);
  }
}
function updateCurrentAnimation($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed, type) {
  triggerEvent($this, $this.tcm_1);
  $this.vcm_1 = spriteDisplayTime;
  $this.zcm_1 = spriteAnimation;
  $this.wcm_1 = looped;
  _set_animationRemainingDuration__f6834h($this, duration);
  _set_currentSpriteIndex__7b2y7x($this, startFrame);
  $this.bcn_1 = reversed;
  $this.qcm_1 = type;
  $this.ncm_1 = true;
  var endFrame_0 = umod(endFrame, $this.fcn());
  var tmp0_safe_receiver = $this.zcm_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var count = startFrame > endFrame_0 ? reversed ? startFrame - endFrame_0 | 0 : tmp0_safe_receiver.jcn() - (startFrame - endFrame_0 | 0) | 0 : endFrame_0 > startFrame ? reversed ? umod(startFrame - endFrame_0 | 0, tmp0_safe_receiver.jcn()) : endFrame_0 - startFrame | 0 : 0;
    var requestedFrames = count + imul(animationCyclesRequested, tmp0_safe_receiver.jcn()) | 0;
    _set_animationNumberOfFramesRequested__tjl77x($this, requestedFrames);
  }
}
function updateCurrentAnimation$default($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed, type, $super) {
  spriteDisplayTime = spriteDisplayTime === VOID ? getDefaultTime($this, spriteAnimation) : spriteDisplayTime;
  animationCyclesRequested = animationCyclesRequested === VOID ? 1 : animationCyclesRequested;
  duration = duration === VOID ? get_fastSeconds(0) : duration;
  startFrame = startFrame === VOID ? 0 : startFrame;
  endFrame = endFrame === VOID ? 0 : endFrame;
  looped = looped === VOID ? false : looped;
  reversed = reversed === VOID ? false : reversed;
  var tmp;
  if (type === VOID) {
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    tmp = _AnimationType___init__impl__l3ftd1(0);
  } else {
    tmp = type;
  }
  type = tmp;
  return updateCurrentAnimation($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed, type);
}
function triggerEvent($this, signal) {
  if (!(signal == null)) {
    var tmp0_safe_receiver = $this.zcm_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      signal.z1v(tmp0_safe_receiver);
    }
  }
}
function Sprite$lambda($this$addFastUpdater, frameTime) {
  if ($this$addFastUpdater.ncm_1) {
    nextSprite($this$addFastUpdater, frameTime.v1u_1);
  }
  return Unit_instance;
}
function _AnimationType___init__impl__l3ftd1(id) {
  return id;
}
var Companion_instance_24;
function Companion_getInstance_49() {
  return Companion_instance_24;
}
var Companion_instance_25;
function Companion_getInstance_50() {
  return Companion_instance_25;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.b9l_1;
  }, function (value) {
    $b0.b9l_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.vcn();
  }, function (value) {
    return $b0.wcn(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.o5z();
  }, function (receiver, value) {
    return receiver.ucn(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.o5z();
  }, function (receiver, value) {
    return receiver.ucn(value);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.cad();
  }, function (receiver, value) {
    return receiver.bad(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.cad();
  }, function (receiver, value) {
    return receiver.bad(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.h4p()) {
    case 'msdf':
      return MsdfRender_getInstance().dak_1;
    case 'psdf':
      return MsdfRender_getInstance().gak_1;
    case 'sdf':
      return MsdfRender_getInstance().gak_1;
    default:
      return null;
  }
}
function *_generator_invoke__zhh2q8_22($this, $completion) {
  var tmp = $this.xcn_1.aco(ensureNotNull(get_views($this.ycn_1)).n9k_1, $this.zcn_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_26;
function Companion_getInstance_51() {
  return Companion_instance_26;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.w5q();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.nao_1 = count + 1 | 0;
}
function *_generator_forceLoadFontSource__wlrz09($this, currentVfs, sourceFile, $completion) {
  $this.bco(sourceFile);
  $this.aap_1 = true;
  if (!(sourceFile == null)) {
    var tmp = readFont(currentVfs.bi('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.hav(tmp);
  }
  return Unit_instance;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.fl();
  var y = pos.gl();
  if ($this.fap_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.xao_1.d4y_1, $this.eap_1.q25_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.xao_1.e4y_1, $this.eap_1.r25_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.yao_1, x, y);
}
function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource) {
  var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function textSize$factory_0($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.sao_1;
  }, function (value) {
    return $b0.iav(value);
  });
}
function fontSource$factory($b0) {
  return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
    return $b0.dap_1;
  }, function (value) {
    return $b0.bco(value);
  });
}
function fontSize$factory() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.f4p();
  }, function (receiver, value) {
    return receiver.dco(value);
  });
}
function fontSize$factory_0() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.f4p();
  }, function (receiver, value) {
    return receiver.dco(value);
  });
}
function _get_allBitmap__bdn8f($this) {
  if ($this.hbb_1 == null) {
    var tmp = $this;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = $this.tba_1.k5r();
      var tmp_0;
      if (isInterface(this_0, Collection)) {
        tmp_0 = this_0.g1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.TextBlock.<get-allBitmap>.<anonymous>' call
        if (!isInterface(element, BitmapFont)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp.hbb_1 = tmp$ret$0;
  }
  return ensureNotNull($this.hbb_1);
}
function invalidateText($this) {
  invalidProps($this);
  if ($this.cbb_1) {
    // Inline function 'korlibs.korge.view.size' call
    var width = $this.tba_1.m2i();
    var height = $this.tba_1.n2i();
    size($this, numberToDouble(width), numberToDouble(height));
  }
  $this.hbb_1 = null;
}
function invalidProps($this) {
  $this.sba_1 = true;
  $this.r9t();
}
function ensureTexture($this) {
  if (!$this.sba_1)
    return Unit_instance;
  $this.sba_1 = false;
  var bmp = NativeImage(toIntCeil($this.m2i()), toIntCeil($this.n2i()));
  if ($this.gbb_1 == null) {
    var tmp = $this;
    // Inline function 'korlibs.korge.view.image' call
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var texture = get_Bitmaps_transparent();
    var anchor = Companion_getInstance_26().f24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Image.ubd(texture, anchor);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp.gbb_1 = addTo(this_0, $this);
  }
  var tmp0_safe_receiver = $this.gbb_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.pbt(slice(bmp));
  }
  var tmp1_safe_receiver = $this.gbb_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    var tmp_0 = tmp1_safe_receiver;
    var tmp_1 = $this.tba_1.v5r_1.y5q_1;
    var tmp2_safe_receiver = isInterface(tmp_1, BitmapFont) ? tmp_1 : null;
    tmp_0.bc2_1 = tmp2_safe_receiver == null ? null : get_agProgram(tmp2_safe_receiver);
  }
  var tmp3_safe_receiver = $this.gbb_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    tmp3_safe_receiver.xc1_1 = $this.fbb_1;
  }
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = bmp.p3x_1;
  if (true) {
    bmp.y3x();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = bmp.h45(true);
    try {
      // Inline function 'korlibs.korge.view.TextBlock.ensureTexture.<anonymous>' call
      var tmp0_text = $this.tba_1;
      var tmp1_bounds = Companion_getInstance_31().x2d($this.bbb_1.j28_1, $this.bbb_1.g28_1, ctx.m2i() - $this.bbb_1.h28_1, ctx.n2i() - $this.bbb_1.i28_1);
      var tmp2_includePartialLines = $this.vba_1;
      var tmp3_wordWrap = $this.zba_1;
      var tmp4_ellipsis = $this.abb_1;
      var tmp5_align = $this.uba_1;
      var tmp6_fill = $this.xba_1;
      var tmp7_stroke = $this.yba_1;
      var tmp8_textRangeStart = $this.dbb_1;
      var tmp9_textRangeEnd = $this.ebb_1;
      drawRichText(ctx, tmp0_text, tmp1_bounds, tmp3_wordWrap, tmp2_includePartialLines, tmp4_ellipsis, tmp6_fill, tmp7_stroke, tmp5_align, true, tmp8_textRangeStart, tmp9_textRangeEnd);
    }finally {
      ctx.d18();
    }
  }finally {
    result = true ? bmp.a3y(rect) : 0;
  }
}
var Companion_instance_27;
function Companion_getInstance_52() {
  if (Companion_instance_27 === VOID)
    new Companion_12();
  return Companion_instance_27;
}
var Companion_instance_28;
function Companion_getInstance_53() {
  return Companion_instance_28;
}
function updateRenderColorTransform($this) {
  $this.p9n_1 = $this.u9n_1;
  $this.w9n_1 = true;
  var parent = $this.p23();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.o9n_1.h4e($this.n9n_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.o9n_1.i4e($this.n9n_1, parent.gai());
    } else {
      $this.o9n_1.h4e($this.n9n_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.p9n_1 === $this.u9n_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.r9n_1 = $this.t9n_1;
  $this.v9n_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.t9m_1.equals(Companion_getInstance_13().j7z_1)) {
    var tmp1_safe_receiver = $this.p23();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hai();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_13().i7z_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.t9m_1;
  }
  tmp.q9n_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.r9n_1 === $this.t9n_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.s1u() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.o66(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addFastUpdater_0(_this__u8e3s4, updatable) {
  return addFastUpdater(_this__u8e3s4, true, VOID, updatable);
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_29;
  return _this__u8e3s4.o66(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.p23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.oah(Scale.g2d(sx, sy));
  return _this__u8e3s4;
}
function position(_this__u8e3s4, x, y) {
  return xy(_this__u8e3s4, Vector2D.n27(x, y));
}
function size(_this__u8e3s4, width, height) {
  return size_0(_this__u8e3s4, Size2D.b2e(width, height));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.h1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.h(_this__u8e3s4);
    }
    if (_this__u8e3s4.h9m_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.zaf();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.d1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function scrollParentsToMakeVisible(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.firstAncestorOfType' call
  var tmp = firstAncestor(_this__u8e3s4, false, scrollParentsToMakeVisible$lambda);
  var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof UIScrollable) ? tmp : THROW_CCE();
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.pbi(_this__u8e3s4);
  }
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.p23();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.p23();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.p23();
  }
  return count;
}
function addUpdater(_this__u8e3s4, updatable) {
  return addUpdater_0(_this__u8e3s4, true, VOID, updatable);
}
function xy(_this__u8e3s4, p) {
  _this__u8e3s4.w50(p);
  return _this__u8e3s4;
}
function size_0(_this__u8e3s4, size) {
  _this__u8e3s4.uah(size);
  return _this__u8e3s4;
}
function addFixedUpdater(_this__u8e3s4, time, first, limitCallsPerFrame, updatable) {
  first = first === VOID ? true : first;
  limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
  var accum = {_v: new FastDuration(Companion_instance_1.s1u())};
  return addFastUpdater(_this__u8e3s4, first, time, addFixedUpdater$lambda(accum, time, updatable, _this__u8e3s4, limitCallsPerFrame));
}
function addUpdater_0(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_getInstance().lj_1 : firstTime;
  if (first)
    updatable(_this__u8e3s4, new Duration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.o66(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
}
function firstAncestor(_this__u8e3s4, includeThis, condition) {
  includeThis = includeThis === VOID ? true : includeThis;
  if (_this__u8e3s4 == null)
    return null;
  if (includeThis && condition(_this__u8e3s4))
    return _this__u8e3s4;
  var tmp0_safe_receiver = _this__u8e3s4.p23();
  return tmp0_safe_receiver == null ? null : firstAncestor(tmp0_safe_receiver, true, condition);
}
function addFixedUpdater_0(_this__u8e3s4, timesPerSecond, initial, limitCallsPerFrame, updatable) {
  initial = initial === VOID ? true : initial;
  limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
  return addFixedUpdater(_this__u8e3s4, _Frequency___get_fastDuration__impl__87web0(timesPerSecond), initial, limitCallsPerFrame, updatable);
}
function xy_0(_this__u8e3s4, x, y) {
  _this__u8e3s4.eah(x, y);
  return _this__u8e3s4;
}
function bounds(_this__u8e3s4, rect) {
  return bounds_0(_this__u8e3s4, rect.v25(), rect.x25(), rect.w25(), rect.y25());
}
function bounds_0(_this__u8e3s4, left, top, right, bottom) {
  return size(xy_0(_this__u8e3s4, left, top), right - left, bottom - top);
}
function deferWithViews(_this__u8e3s4, views, tryImmediate, block) {
  views = views === VOID ? null : views;
  tryImmediate = tryImmediate === VOID ? true : tryImmediate;
  if (tryImmediate) {
    var tmp;
    if (views == null) {
      var tmp1_safe_receiver = _this__u8e3s4.b9u();
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.d9x();
    } else {
      tmp = views;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      block(tmp2_safe_receiver);
      return _this__u8e3s4;
    }
  }
  onNextFrame(_this__u8e3s4, deferWithViews$lambda(block));
  return _this__u8e3s4;
}
function onNextFrame(_this__u8e3s4, block) {
  var closeable = {_v: null};
  closeable._v = addUpdaterWithViews(_this__u8e3s4, onNextFrame$lambda(block, closeable));
  return closeable._v;
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return function (it) {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.q8l_1, $this_addFastUpdater.dah())));
    return Unit_instance;
  };
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return function (it) {
    $updatable($this_addUpdaterWithViews, it.nco_1, new Duration(Duration__times_impl_sfuzvp(it.pco(), $this_addUpdaterWithViews.dah())));
    return Unit_instance;
  };
}
function scrollParentsToMakeVisible$lambda(it) {
  return it instanceof UIScrollable;
}
function addFixedUpdater$lambda($accum, $time, $updatable, $this_addFixedUpdater, $limitCallsPerFrame) {
  return function ($this$addFastUpdater, dt) {
    $accum._v = new FastDuration(FastDuration__plus_impl_q1enab($accum._v.v1u_1, dt.v1u_1));
    var calls = 0;
    $l$loop: while (FastDuration__compareTo_impl_4fhnj7($accum._v.v1u_1, FastDuration__times_impl_h6amcp($time, 0.75)) >= 0) {
      $accum._v = new FastDuration(FastDuration__minus_impl_evs237($accum._v.v1u_1, $time));
      $updatable($this_addFixedUpdater);
      calls = calls + 1 | 0;
      if (calls >= $limitCallsPerFrame) {
        $accum._v = new FastDuration(Companion_instance_1.s1u());
        break $l$loop;
      }
    }
    return Unit_instance;
  };
}
function addUpdater$lambda($updatable, $this_addUpdater) {
  return function (it) {
    $updatable($this_addUpdater, new Duration(Duration__times_impl_sfuzvp(it.r8l(), $this_addUpdater.dah())));
    return Unit_instance;
  };
}
function deferWithViews$lambda($block) {
  return function ($this$onNextFrame, it) {
    $block(it);
    return Unit_instance;
  };
}
function onNextFrame$lambda($block, $closeable) {
  return function ($this$addUpdaterWithViews, views, _unused_var__etf5q3) {
    $block($this$addUpdaterWithViews, views);
    var tmp0_safe_receiver = $closeable._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c6();
    }
    return Unit_instance;
  };
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.jah();
  }, function (value) {
    return $b0.iah(value);
  });
}
function bviewAll$factory() {
  return getPropertyCallableRef('bviewAll', 1, KProperty1, function (receiver) {
    return receiver.sag();
  }, null);
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.p8a_1;
  }, function (value) {
    $b0.p8a_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_23($this, $completion) {
  var tmp = $this.qco_1.sch(ensureNotNull(get_views($this.rco_1)), VOID, $this.sco_1.nch_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_24($this, $completion) {
  var tmp = $this.uco_1.vco($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.l9k_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().h7z();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.y9k_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.d1(_unary__edvuaz).i1p($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.y9k_1.h3();
  cancel($this.q9j_1);
  $this.w9j_1.u8j();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.b9j(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.y9j_1 == null) ? ensureNotNull(this$0.y9j_1) : StandardPaths_instance.g2y(this$0.wco());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.ny();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.p9k_1.r86();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.p9k_1.i8b();
    return Unit_instance;
  };
}
var Companion_instance_29;
function Companion_getInstance_54() {
  return Companion_instance_29;
}
var Companion_instance_30;
function Companion_getInstance_55() {
  return Companion_instance_30;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.h9k_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.q8l_1 = delta;
  _this__u8e3s4.z66(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.i9k_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.oco_1 = delta;
  _this__u8e3s4.z66(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_25().y2f() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_26().r24() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.s2q(reqVirtualSize_0);
  targetSize.s2q(scaleMode.b2g(virtualSize.r1(), actualSize_0));
  var ratioX = targetSize.r1().i2g_1 / reqVirtualSize_0.i2g_1;
  var ratioY = targetSize.r1().j2g_1 / reqVirtualSize_0.j2g_1;
  var actualVirtualWidth = toIntRound(actualSize_0.i2g_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.j2g_1 / ratioY);
  _this__u8e3s4.r89(Companion_getInstance_33().x28_1.z29(ratioX, ratioY).h2a(toIntRound((actualVirtualWidth - reqVirtualSize_0.i2g_1 | 0) * anchor.o24_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.j2g_1 | 0) * anchor.p24_1)));
  _this__u8e3s4.n89(_this__u8e3s4.s89().j2a());
  _this__u8e3s4.t89(_this__u8e3s4.s89().k2a());
  _this__u8e3s4.p89(_this__u8e3s4.o89().k2a());
  var tl = _this__u8e3s4.y89(Vector2D.a28(0, 0));
  var br = _this__u8e3s4.y89(Vector2D.n27(actualSize_0.i2g_1, actualSize_0.j2g_1));
  _this__u8e3s4.v89(Companion_getInstance_31().x2d(tl.e25_1, tl.f25_1, br.e25_1, br.f25_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.c64(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006.bind(VOID), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.x8a();
  }, function (value) {
    return $b0.o8j(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.y8j();
  }, function (value) {
    return $b0.x8j(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.z80_1;
  }, function (value) {
    $b0.z80_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.a81_1);
  }, function (value) {
    $b0.a81_1 = value.m4e_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.i8h_1;
  }, function (value) {
    $b0.i8h_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.u9r();
  }, function (receiver, value) {
    return receiver.a9s(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.u9r();
  }, function (receiver, value) {
    return receiver.a9s(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.bcp();
  }, function (receiver, value) {
    return receiver.q9r(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.bcp();
  }, function (receiver, value) {
    return receiver.q9r(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.ccp());
  }, function (receiver, value) {
    return receiver.r9r(value.m4e_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.ccp());
  }, function (receiver, value) {
    return receiver.r9r(value.m4e_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.l9l_1;
  }, function (value) {
    $b0.l9l_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.n9l_1;
  }, function (value) {
    $b0.n9l_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.icp();
  }, function (receiver, value) {
    return receiver.ocp(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.icp();
  }, function (receiver, value) {
    return receiver.ocp(value);
  });
}
var UB_instance;
function UB_getInstance() {
  if (UB_instance === VOID)
    new UB();
  return UB_instance;
}
var Companion_instance_31;
function Companion_getInstance_56() {
  if (Companion_instance_31 === VOID)
    new Companion_16();
  return Companion_instance_31;
}
function updatedPoints($this) {
  var tmp = $this;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var tmp0_iterator = $this.rau_1.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    var tmp_0 = sum;
    // Inline function 'korlibs.korge.view.debug.DebugVertexView.updatedPoints.<anonymous>' call
    sum = tmp_0 + element.e1() | 0;
  }
  var tmp$ret$1 = sum;
  tmp.tau_1 = new Float32Array(imul(tmp$ret$1, 2));
  var buffer = $this.tau_1;
  var n = 0;
  $this.uau_1.h3();
  $this.vau_1 = Companion_getInstance_32().e26();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.rau_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.korge.view.debug.DebugVertexView.updatedPoints.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    var points = this_0.d1(_unary__edvuaz);
    $this.uau_1.h(new Batch(n / 2 | 0, points.e1()));
    if (points.r27() >= 5) {
      // Inline function 'korlibs.math.geom.fastForEachGeneric' call
      var inductionVariable = 0;
      var last = points.e1();
      if (inductionVariable < last)
        do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.korge.view.debug.DebugVertexView.updatedPoints.<anonymous>.<anonymous>' call
          var x = points.p27(n_1, 0);
          var y = points.p27(n_1, 1);
          var dx = points.p27(n_1, 2);
          var dy = points.p27(n_1, 3);
          var scale = points.p27(n_1, 4);
          var px = x + dx * scale;
          var py = y + dy * scale;
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          buffer[_unary__edvuaz_0] = px;
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          buffer[_unary__edvuaz_1] = py;
          $this.vau_1 = BoundsBuilder__plus_impl_cz7f7x_0($this.vau_1, Vector2D.n27(px, py));
        }
         while (inductionVariable < last);
    } else {
      // Inline function 'korlibs.math.geom.fastForEachGeneric' call
      var inductionVariable_0 = 0;
      var last_0 = points.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n_2 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.korge.view.debug.DebugVertexView.updatedPoints.<anonymous>.<anonymous>' call
          var x_0 = points.p27(n_2, 0);
          var y_0 = points.p27(n_2, 1);
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          buffer[_unary__edvuaz_2] = x_0;
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          buffer[_unary__edvuaz_3] = y_0;
          $this.vau_1 = BoundsBuilder__plus_impl_cz7f7x_0($this.vau_1, Vector2D.n27(x_0, y_0));
        }
         while (inductionVariable_0 < last_0);
    }
  }
}
function colorMul$factory($b0) {
  return getPropertyCallableRef('colorMul', 0, KMutableProperty0, function () {
    return new RGBA($b0.g4e());
  }, function (value) {
    return $b0.e4e(value.m4e_1);
  });
}
function u_Col$factory() {
  return getPropertyCallableRef('u_Col', 1, KProperty1, function (receiver) {
    return receiver.vcp();
  }, null);
}
function u_Matrix$factory() {
  return getPropertyCallableRef('u_Matrix', 1, KProperty1, function (receiver) {
    return receiver.wcp();
  }, null);
}
function u_Col$factory_0() {
  return getPropertyCallableRef('u_Col', 1, KProperty1, function (receiver) {
    return receiver.vcp();
  }, null);
}
function u_Matrix$factory_0() {
  return getPropertyCallableRef('u_Matrix', 1, KProperty1, function (receiver) {
    return receiver.wcp();
  }, null);
}
var renderToTextureResultPool$delegate;
var Companion_instance_32;
function Companion_getInstance_57() {
  if (Companion_instance_32 === VOID)
    new Companion_17();
  return Companion_instance_32;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.v2e(getBorder(_this__u8e3s4, toIntCeil(inp.q25_1), toIntCeil(inp.r25_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.dcq(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.j2p(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.d18();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_33;
function Companion_getInstance_58() {
  if (Companion_instance_33 === VOID)
    new Companion_18();
  return Companion_instance_33;
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.z9n_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.rcq_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.by_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.zx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.e9v(VOID, false);
  if (bounds.q25_1 <= 0.0 || bounds.r25_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_57();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.ccq();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.bcq(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.q25_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.r25_1 * tryFilterScale), 1);
  var realFilterScale = clamp_1(texWidthNoBorder / bounds.q25_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.o25_1 + edgeSize;
  var addy = -bounds.p25_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.p82();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.k8b(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.m8b(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.b81_1;
      var this_1 = this_0.k81_1;
      if (!(this_1.f81_1 === this_0)) {
        this_1.f81_1 = this_0;
        this_1.p82();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.s6q(0, 0, rb.t6f_1, rb.u6f_1);
        var temp = this_0.i82_1;
        this_0.r88();
        this_0.i82_1 = scissor;
        try {
          if (true) {
            ctx.f8b(Colors_getInstance().x3y_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.fai().d2a(addx, addy).y29(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.b81_1.k81_1;
          this_2.p82();
          var temp4 = this_2.q80_1;
          var temp2d = this_2.r80_1;
          this_2.r80_1 = mat;
          this_2.q80_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.e6n(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.t6o();
            this_3.u7b(_unary__edvuaz + 1 | 0);
            this_3.v7b(this_3.t6o() + 1 | 0);
            var blockSize = this_3.x6m_1;
            var index0 = imul(this_3.t6o() - 1 | 0, blockSize);
            var index1 = imul(this_3.t6o(), blockSize);
            var texBlockSize = this_3.u6m_1.t6u().e1();
            var texIndex0 = imul(this_3.t6o() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.t6o(), texBlockSize);
            if (this_3.t6o() > 0) {
              arraycopy(this_3.z6m_1, index0, this_3.z6m_1, index1, blockSize);
            } else {
              arrayfill(this_3.z6m_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.u6m_1;
            this_3.a6n_1.j7c($this$push.s6u(), this_2.q80_1);
            if (true && this_3.t6o() >= 1) {
              var equals = arrayequal(this_3.z6m_1, index0, this_3.z6m_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.t6o();
                this_3.u7b(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.nai(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.oai(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.p82();
            this_2.q80_1 = temp4;
            this_2.r80_1 = temp2d;
            this_2.e6n(ProjViewUB_getInstance()).w7b();
          }
          break $l$block_0;
        }finally {
          this_0.r88();
          this_0.i82_1 = temp;
        }
      }
    }finally {
      ctx.n8b();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).j3h(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.g9v().h2a(-addx, -addy).a2a(1.0 / realFilterScale);
    filter.ecq(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.iai(), _this__u8e3s4.t9m_1, realFilterScale);
    ctx.p82();
  }finally {
    ctx.l8b(rb);
  }
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.z9n_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.scq_1;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_57().bcq(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.by_1 = transform;
    filterScale$delegate = this_0;
  }
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.hcg_1 ? $this.scg_1 : $this.rcg_1;
  if (!valid) {
    if ($this.hcg_1)
      $this.scg_1 = true;
    else
      $this.rcg_1 = true;
    var result = $this.pcg_1.g5z($this.hcg_1);
    if ($this.hcg_1)
      $this.vcg_1 = result;
    else
      $this.ucg_1 = result;
    return result;
  }
  return $this.hcg_1 ? $this.vcg_1 : $this.ucg_1;
}
function invalidateShape($this) {
  $this.tcg_1 = 0;
  $this.qcg_1 = false;
  $this.rcg_1 = false;
  $this.scg_1 = false;
  $this.r9t();
}
function requireShape($this) {
  if ($this.qcg_1)
    return Unit_instance;
  $this.qcg_1 = true;
  $this.icg_1.h3();
  $this.icg_1.dcr();
  $this.icg_1.ecr(Companion_getInstance_16().m6h_1);
  $this.wcg_1 = true;
  renderShape($this, $this.pcg_1);
  $this.icg_1.c6g();
  $this.ycg_1 = $this.xcg_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.g9v().l29(get_immutable(ctx.e80_1.s89())) : $this.g9v();
  $this.zcg_1 = mat.f2a(-$this.tag(), -$this.uag());
  requireShape($this);
  $this.icg_1.fcr(ctx, $this.zcg_1, $this.eai(), $this.mcg_1, $this.iai(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.t5z_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var v = _iterator__ex2g4s.c1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.m60());
      } else {
        if (shape instanceof FillShape) {
          $this.tcg_1 = $this.tcg_1 + 1 | 0;
          if ($this.tcg_1 > $this.ach_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.tcg_1 = $this.tcg_1 + 1 | 0;
            if ($this.tcg_1 > $this.ach_1)
              return Unit_instance;
            renderStroke$default($this, shape.y5z_1, shape.v5z_1, shape.x5z_1, shape.a60_1, shape.z5z_1);
          } else {
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.od('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  var gpuShapeViewCommands = $this.icg_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.ecr(Companion_getInstance_16().m6h_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.d1(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.gcr();
    var vector = points.u38();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.e1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
        var x = vector.p27(n_0, 0);
        var y = vector.p27(n_0, 1);
        var dx = vector.p27(n_0, 2);
        var dy = vector.p27(n_0, 3);
        var len = vector.p27(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.p27(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.hcr(px, py, $this.ocg_1 ? len : 0.0, $this.ocg_1 ? maxLen : $this.cch_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.icr();
    var info = GpuShapeViewPrograms_getInstance().bcs(stateTransform, paint, globalAlpha, strokeInfo.d38_1);
    var tmp0_drawType = Companion_getInstance_14().q6p_1;
    var tmp1_blendMode = Companion_getInstance_13().i7z_1;
    gpuShapeViewCommands.ccs(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
  }
}
function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().a6h_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_19().y6g_1 : stencilRef;
  return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
}
function getPointsForPath($this, points, type) {
  if (points.e1() < 3)
    return null;
  var vertexStart = $this.icg_1.gcr();
  var bb = BoundsBuilder__plus_impl_cz7f7x_1(Companion_getInstance_32().e26(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.n27(xMid, yMid);
  var isStrip = type === Companion_getInstance_14().q6p_1;
  var antialiased = $this.ocg_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.icg_1.hcr(xMid, yMid, 0.0, $this.cch_1);
  }
  var inductionVariable = 0;
  var last = points.e1() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.d1(n % points.e1() | 0);
      var x = p.fl();
      var y = p.gl();
      var len = isStripAndAntialiased ? Companion_getInstance_28().q2g(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.cch_1;
      if (isStrip) {
        $this.icg_1.hcr(xMid, yMid, 0.0, maxLen);
      }
      $this.icg_1.hcr(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.icg_1.icr();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.e1() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = getPoints2List(path);
  var destination = ArrayList.h1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().bcs(shape.k5z_1, shape.j5z_1, shape.l5z_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.bch_1;
  var drawAntialiasingBorder = $this.bch_1 ? true : $this.ocg_1;
  var shapeIsConvex = shape.r5z();
  var isSimpleDraw = shapeIsConvex && shape.i5z_1 == null && !$this.bch_1;
  var pathDataList = getPointsForPathList($this, shape.h5z_1, isSimpleDraw ? Companion_getInstance_14().q6p_1 : Companion_getInstance_14().r6p_1);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
  var bb = Companion_getInstance_32().e26();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.d1(_unary__edvuaz);
    bb = plus(bb, it.dcs_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.v2e(MarginInt.v28(2)));
  var clipDataStart = $this.icg_1.gcr();
  var tmp1_safe_receiver = shape.i5z_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_14().r6p_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.icg_1.icr();
  var tmp3_elvis_lhs = clipData == null ? null : clipData.dcs_1;
  var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_16().m6h_1 : tmp3_elvis_lhs;
  if (!isSimpleDraw || $this.wcg_1) {
    $this.wcg_1 = true;
    $this.icg_1.ecr(isSimpleDraw ? Companion_getInstance_16().m6h_1 : !clipBounds.equals(Companion_getInstance_16().m6h_1) ? Companion_getInstance_16().x6q(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.wcg_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.e1()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.d1(_unary__edvuaz_0);
      var tmp0_$this = $this.icg_1;
      var tmp1_drawType = Companion_getInstance_14().q6p_1;
      var tmp2_startIndex = pathData.fcs_1;
      var tmp3_endIndex = pathData.gcs_1;
      var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp5_blendMode = $this.hai();
      tmp0_$this.ccs(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.h5z_1.z3d_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_20().r6r_1;
  if (drawFill) {
    switch (winding.n3_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_20().r6r_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().a6h_1, true), Companion_getInstance_20().q6r_1), Companion_getInstance_21().c6s_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().y6g_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.d1(_unary__edvuaz_1);
          writeStencil($this, pathData_0.fcs_1, pathData_0.gcs_1, stencilOpFunc, stencilRef, Companion_getInstance_22().o6h_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_20().x6r_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().a6h_1, true), Companion_getInstance_20().q6r_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().y6g_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.d1(_unary__edvuaz_2);
          writeStencil($this, pathData_1.fcs_1, pathData_1.gcs_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_21().b6s_1, Companion_getInstance_21().z6r_1), stencilRef_0, Companion_getInstance_22().o6h_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().a6h_1, true), Companion_getInstance_20().x6r_1), Companion_getInstance_21().c6s_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_19().y6g_1, 0), 255), Companion_getInstance_22().p6h_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().a6h_1, true), Companion_getInstance_20().q6r_1), Companion_getInstance_21().c6s_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().y6g_1, 2), Companion_getInstance_22().r6h_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.i5z_1 == null) {
    renderStroke($this, shape.k5z_1, shape.h5z_1, shape.j5z_1, shape.l5z_1, new StrokeInfo(1.6 / $this.xcg_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_18().a6h_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().a6h_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_19().y6g_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.icg_1.i76(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp0_$this = $this.icg_1;
  var tmp1_drawType = Companion_getInstance_14().r6p_1;
  var tmp2_paintShader = GpuShapeViewPrograms_getInstance().acs_1;
  var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp4_blendMode = Companion_getInstance_13().k7z_1;
  tmp0_$this.hcs(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.icg_1.gcr();
  var x0 = pathBounds.v25();
  var y0 = pathBounds.x25();
  var x1 = pathBounds.w25();
  var y1 = pathBounds.y25();
  $this.icg_1.hcr(x0, y0, 0.0, $this.cch_1);
  $this.icg_1.hcr(x1, y0, 0.0, $this.cch_1);
  $this.icg_1.hcr(x1, y1, 0.0, $this.cch_1);
  $this.icg_1.hcr(x0, y1, 0.0, $this.cch_1);
  var vend = $this.icg_1.icr();
  var tmp0_$this = $this.icg_1;
  var tmp1_drawType = Companion_getInstance_14().r6p_1;
  var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().a6h_1, true), stencilCompare);
  var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_19().y6g_1, stencilReferenceValue), 0);
  var tmp5_blendMode = $this.hai();
  tmp0_$this.ccs(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return function ($this$IF_ELSE_LIST, it) {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.e6x($this$IF_ELSE_LIST.h6x(), GpuShapeViewPrograms_getInstance().nct());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.e6x($this$IF_ELSE_LIST.h6x(), $this$IF_ELSE_LIST.p6x($$this$FragmentShaderDefault.o6x(), $this$IF_ELSE_LIST.x6y($this$IF_ELSE_LIST.z6y([$this$IF_ELSE_LIST.n6x($this$IF_ELSE_LIST.i6x(GpuShapeViewPrograms_getInstance().pct(), $this$IF_ELSE_LIST.l6x([$$this$FragmentShaderDefault.a6x(), $this$IF_ELSE_LIST.k6x(0.0), $this$IF_ELSE_LIST.k6x(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.e6x($this$IF_ELSE_LIST.h6x(), $this$IF_ELSE_LIST.p6x($$this$FragmentShaderDefault.o6x(), $this$IF_ELSE_LIST.n6x($this$IF_ELSE_LIST.i6x(GpuShapeViewPrograms_getInstance().pct(), $this$IF_ELSE_LIST.l6x([$this$IF_ELSE_LIST.a6z($$this$FragmentShaderDefault.a6x()), $this$IF_ELSE_LIST.b6z($$this$FragmentShaderDefault.a6x()), $this$IF_ELSE_LIST.k6x(0.0), $this$IF_ELSE_LIST.k6x(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.r6y(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.e6x($this$IF_ELSE_LIST.n6x(rpoint, 'xy'), $this$IF_ELSE_LIST.n6x($this$IF_ELSE_LIST.i6x(GpuShapeViewPrograms_getInstance().pct(), $this$IF_ELSE_LIST.l6x([$this$IF_ELSE_LIST.a6z($$this$FragmentShaderDefault.a6x()), $this$IF_ELSE_LIST.b6z($$this$FragmentShaderDefault.a6x()), $this$IF_ELSE_LIST.k6x(0.0), $this$IF_ELSE_LIST.k6x(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.a6z(rpoint);
        var y = $this$IF_ELSE_LIST.b6z(rpoint);
        var x0 = $this$IF_ELSE_LIST.a6z(GpuShapeViewPrograms_getInstance().qct());
        var y0 = $this$IF_ELSE_LIST.b6z(GpuShapeViewPrograms_getInstance().qct());
        var r0 = $this$IF_ELSE_LIST.c6z(GpuShapeViewPrograms_getInstance().qct());
        var x1 = $this$IF_ELSE_LIST.a6z(GpuShapeViewPrograms_getInstance().rct());
        var y1 = $this$IF_ELSE_LIST.b6z(GpuShapeViewPrograms_getInstance().rct());
        var r1 = $this$IF_ELSE_LIST.c6z(GpuShapeViewPrograms_getInstance().rct());
        var ratio = $this$IF_ELSE_LIST.a6z($$this$FragmentShaderDefault.s6x());
        var r0r1_2 = $this$IF_ELSE_LIST.b6z($$this$FragmentShaderDefault.s6x());
        var r0pow2 = $this$IF_ELSE_LIST.c6z($$this$FragmentShaderDefault.s6x());
        var r1pow2 = $this$IF_ELSE_LIST.d6z($$this$FragmentShaderDefault.s6x());
        var y0_y1 = $this$IF_ELSE_LIST.a6z($$this$FragmentShaderDefault.r6z());
        var x0_x1 = $this$IF_ELSE_LIST.b6z($$this$FragmentShaderDefault.r6z());
        var r0_r1 = $this$IF_ELSE_LIST.c6z($$this$FragmentShaderDefault.r6z());
        var radial_scale = $this$IF_ELSE_LIST.d6z($$this$FragmentShaderDefault.r6z());
        $this$IF_ELSE_LIST.e6x(r0r1_2, $this$IF_ELSE_LIST.i6x($this$IF_ELSE_LIST.i6x($this$IF_ELSE_LIST.k6x(2.0), r0), r1));
        $this$IF_ELSE_LIST.e6x(r0pow2, GpuShapeViewPrograms_getInstance().sct(r0));
        $this$IF_ELSE_LIST.e6x(r1pow2, GpuShapeViewPrograms_getInstance().sct(r1));
        $this$IF_ELSE_LIST.e6x(x0_x1, $this$IF_ELSE_LIST.f6z(x0, x1));
        $this$IF_ELSE_LIST.e6x(y0_y1, $this$IF_ELSE_LIST.f6z(y0, y1));
        $this$IF_ELSE_LIST.e6x(r0_r1, $this$IF_ELSE_LIST.f6z(r0, r1));
        $this$IF_ELSE_LIST.e6x(radial_scale, $this$IF_ELSE_LIST.t6x($this$IF_ELSE_LIST.k6x(1.0), $this$IF_ELSE_LIST.f6z($this$IF_ELSE_LIST.f6z(GpuShapeViewPrograms_getInstance().sct($this$IF_ELSE_LIST.f6z(r0, r1)), GpuShapeViewPrograms_getInstance().sct($this$IF_ELSE_LIST.f6z(x0, x1))), GpuShapeViewPrograms_getInstance().sct($this$IF_ELSE_LIST.f6z(y0, y1)))));
        $this$IF_ELSE_LIST.e6x(ratio, $this$IF_ELSE_LIST.f6z($this$IF_ELSE_LIST.k6x(1.0), $this$IF_ELSE_LIST.i6x($this$IF_ELSE_LIST.f6z($this$IF_ELSE_LIST.h6z($this$IF_ELSE_LIST.h6z($this$IF_ELSE_LIST.i6x($this$IF_ELSE_LIST.e6z(r1), r0_r1), $this$IF_ELSE_LIST.i6x(x0_x1, $this$IF_ELSE_LIST.f6z(x1, x))), $this$IF_ELSE_LIST.i6x(y0_y1, $this$IF_ELSE_LIST.f6z(y1, y))), $this$IF_ELSE_LIST.v6y($this$IF_ELSE_LIST.f6z($this$IF_ELSE_LIST.h6z($this$IF_ELSE_LIST.f6z($this$IF_ELSE_LIST.i6x(r1pow2, $this$IF_ELSE_LIST.h6z(GpuShapeViewPrograms_getInstance().sct($this$IF_ELSE_LIST.f6z(x0, x)), GpuShapeViewPrograms_getInstance().sct($this$IF_ELSE_LIST.f6z(y0, y)))), $this$IF_ELSE_LIST.i6x(r0r1_2, $this$IF_ELSE_LIST.h6z($this$IF_ELSE_LIST.i6x($this$IF_ELSE_LIST.f6z(x0, x), $this$IF_ELSE_LIST.f6z(x1, x)), $this$IF_ELSE_LIST.i6x($this$IF_ELSE_LIST.f6z(y0, y), $this$IF_ELSE_LIST.f6z(y1, y))))), $this$IF_ELSE_LIST.i6x(r0pow2, $this$IF_ELSE_LIST.h6z(GpuShapeViewPrograms_getInstance().sct($this$IF_ELSE_LIST.f6z(x1, x)), GpuShapeViewPrograms_getInstance().sct($this$IF_ELSE_LIST.f6z(y1, y))))), GpuShapeViewPrograms_getInstance().sct($this$IF_ELSE_LIST.f6z($this$IF_ELSE_LIST.h6z($this$IF_ELSE_LIST.h6z($this$IF_ELSE_LIST.f6z($this$IF_ELSE_LIST.f6z($this$IF_ELSE_LIST.i6x(x1, y0), $this$IF_ELSE_LIST.i6x(x, y0)), $this$IF_ELSE_LIST.i6x(x0, y1)), $this$IF_ELSE_LIST.i6x(x, y1)), $this$IF_ELSE_LIST.i6x(x0, y)), $this$IF_ELSE_LIST.i6x(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.e6x($this$IF_ELSE_LIST.h6x(), $this$IF_ELSE_LIST.p6x($$this$FragmentShaderDefault.o6x(), $this$IF_ELSE_LIST.z6y([ratio, $this$IF_ELSE_LIST.k6x(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.r6y(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.e6x($this$IF_ELSE_LIST.n6x(rpoint_0, 'xy'), $this$IF_ELSE_LIST.n6x($this$IF_ELSE_LIST.i6x(GpuShapeViewPrograms_getInstance().pct(), $this$IF_ELSE_LIST.l6x([$this$IF_ELSE_LIST.a6z($$this$FragmentShaderDefault.a6x()), $this$IF_ELSE_LIST.b6z($$this$FragmentShaderDefault.a6x()), $this$IF_ELSE_LIST.k6x(0.0), $this$IF_ELSE_LIST.k6x(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.a6z(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.b6z(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.a6z($$this$FragmentShaderDefault.s6x());
        var angle = $this$IF_ELSE_LIST.b6z($$this$FragmentShaderDefault.s6x());
        var x0_0 = $this$IF_ELSE_LIST.a6z(GpuShapeViewPrograms_getInstance().qct());
        var y0_0 = $this$IF_ELSE_LIST.b6z(GpuShapeViewPrograms_getInstance().qct());
        var PI2 = $this$IF_ELSE_LIST.k6x(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.e6x(angle, $this$IF_ELSE_LIST.t6y($this$IF_ELSE_LIST.f6z(y_0, y0_0), $this$IF_ELSE_LIST.f6z(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.l6z(angle, $this$IF_ELSE_LIST.k6x(0.0));
        var body = $this$IF_ELSE_LIST.v6x();
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

        body.e6x(angle, body.h6z(angle, PI2));
        var stmIf = new If(cond, body.x6x());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.d6x_1.h(stmIf);
        $this$IF_ELSE_LIST.e6x(ratio_0, $this$IF_ELSE_LIST.t6x(angle, PI2));
        $this$IF_ELSE_LIST.e6x($this$IF_ELSE_LIST.h6x(), $this$IF_ELSE_LIST.p6x($$this$FragmentShaderDefault.o6x(), $this$IF_ELSE_LIST.x6y($this$IF_ELSE_LIST.z6y([ratio_0, $this$IF_ELSE_LIST.k6x(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function u_ProgramType$factory() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.mct();
  }, null);
}
function u_Color$factory() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.nct();
  }, null);
}
function u_ColorMul$factory() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.lct();
  }, null);
}
function u_GlobalAlpha$factory() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.oct();
  }, null);
}
function u_GlobalPixelScale$factory() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.kct();
  }, null);
}
function u_Transform$factory() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.pct();
  }, null);
}
function u_Gradientp0$factory() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.qct();
  }, null);
}
function u_Gradientp1$factory() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.rct();
  }, null);
}
function u_ProgramType$factory_0() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.mct();
  }, null);
}
function u_Color$factory_0() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.nct();
  }, null);
}
function u_ColorMul$factory_0() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.lct();
  }, null);
}
function u_GlobalAlpha$factory_0() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.oct();
  }, null);
}
function u_GlobalPixelScale$factory_0() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.kct();
  }, null);
}
function u_Transform$factory_0() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.pct();
  }, null);
}
function u_Gradientp0$factory_0() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.qct();
  }, null);
}
function u_Gradientp1$factory_0() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.rct();
  }, null);
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(RootAnimationNode, 'RootAnimationNode');
initMetadataForClass(TweenNode, 'TweenNode');
initMetadataForClass(BlockNode, 'BlockNode');
initMetadataForClass(Animator, 'Animator', VOID, VOID, [CloseableCancellable], [1]);
initMetadataForClass(ViewStageComponent, 'ViewStageComponent');
initMetadataForLambda(KeysEvents$down$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$down$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$up$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$typed$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Info, 'Info', Info);
initMetadataForClass(TouchEvents, 'TouchEvents');
initMetadataForClass(SingleTouchHandler, 'SingleTouchHandler', SingleTouchHandler);
initMetadataForClass(singleTouch$SingleTouchInfo, 'SingleTouchInfo');
initMetadataForObject(MaterialBlockUB, 'MaterialBlockUB');
initMetadataForObject(MaterialRender, 'MaterialRender');
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_3);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.nc2);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.na3);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.oc2);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.ibw);
initMetadataForClass(UIView, 'UIView', UIView.wac);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.xac);
protoOf(Transition$1).kaj = start;
protoOf(Transition$1).laj = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForClass(ViewStyles, 'ViewStyles');
initMetadataForClass(ViewStyle, 'ViewStyle');
initMetadataForInterface(StyleableView, 'StyleableView');
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TextSnapshot, 'TextSnapshot');
initMetadataForLambda(TextEditController$slambda, VOID, VOID, [1]);
initMetadataForLambda(TextEditController$slambda_0, VOID, VOID, [1]);
initMetadataForInterface(UIFocusable, 'UIFocusable');
initMetadataForClass(TextEditController, 'TextEditController', VOID, VOID, [AutoCloseable, UIFocusable, ISoftKeyboardConfig]);
initMetadataForClass(TimerComponents, 'TimerComponents', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(TimerRef, 'TimerRef');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_4);
initMetadataForLambda(UIButton$slambda, VOID, VOID, [1]);
initMetadataForLambda(UIButton$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(UIButton$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(UIButton$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(UIButton$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(UIButton$slambda_2, VOID, VOID, [1]);
initMetadataForClass(UIFocusableView, 'UIFocusableView', UIFocusableView.wb7, VOID, [UIView, UIFocusable]);
initMetadataForClass(UIButton, 'UIButton', UIButton.vb7);
initMetadataForObject(Scope, 'Scope');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(UIFocusManager, 'UIFocusManager');
initMetadataForClass(Highlight, 'Highlight');
initMetadataForClass(Highlights, 'Highlights');
initMetadataForClass(UIMaterialLayer, 'UIMaterialLayer', UIMaterialLayer.xb7);
initMetadataForClass(UIScrollable, 'UIScrollable');
initMetadataForInterface(ViewRenderer, 'ViewRenderer');
initMetadataForClass(sam$korlibs_korge_view_ViewRenderer$0, 'sam$korlibs_korge_view_ViewRenderer$0', VOID, VOID, [ViewRenderer, FunctionAdapter]);
initMetadataForClass(UITextInput, 'UITextInput', UITextInput.fbm, VOID, [UIView, ISoftKeyboardConfig]);
initMetadataForClass(sam$korlibs_korge_view_ViewRenderer$0_0, 'sam$korlibs_korge_view_ViewRenderer$0', VOID, VOID, [ViewRenderer, FunctionAdapter]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.cc9);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.gc5);
initMetadataForClass(ClipContainer, 'ClipContainer', ClipContainer.sbo);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [MutableIterable, Collection, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.zc8);
initMetadataForClass(CustomContextRenderizableView, 'CustomContextRenderizableView');
initMetadataForClass(DummyView, 'DummyView', DummyView.ecb);
initMetadataForCompanion(Companion_6);
initMetadataForClass(SContainer, 'SContainer', SContainer.ba6);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.gch);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).sch = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForClass(RenderableView, 'RenderableView');
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Sprite, 'Sprite', Sprite.kcn);
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(SpriteAnimation, 'SpriteAnimation', VOID, VOID, [Collection]);
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForCompanion(Companion_11);
initMetadataForLambda(Text$_renderInternal$slambda, VOID, VOID, [0]);
initMetadataForClass(Text, 'Text', VOID, VOID, VOID, [2]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(TextBlock, 'TextBlock', TextBlock.jbb);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_13);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).sch = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_15);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForObject(UB, 'UB');
initMetadataForCompanion(Companion_16);
initMetadataForClass(Batch, 'Batch');
initMetadataForClass(DebugVertexView, 'DebugVertexView');
initMetadataForCompanion(Companion_17);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).ccq = get_recommendedFilterScale;
protoOf(IdentityFilter).dcq = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.dch);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_17 = new Companion_2();
Scope_instance = new Scope();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_25 = new Companion_10();
Companion_instance_26 = new Companion_11();
Companion_instance_28 = new Companion_13();
Companion_instance_29 = new Companion_14();
Companion_instance_30 = new Companion_15();
//endregion
//region block: exports
export {
  views as views116j359zi8nvf,
  Korge_0 as Korge3fi4cwjkh8up9,
  Companion_getInstance_43 as Companion_getInstance2b4rje0hs8ulh,
  Companion_getInstance_44 as Companion_getInstancequ1o8fwft10r,
  Companion_instance_25 as Companion_instance2ffk2psxndlag,
  Companion_instance_26 as Companion_instance1qzytx5vkv693,
  get_mouse as get_mouse1jstwhfaumelj,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  UIButton as UIButton259u54yn72ttw,
  UITextInput as UITextInput3hf6kt3o0p9up,
  Container as Container7486fjmip554,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  Image as Image1b2d7ghyim7p5,
  SolidRect as SolidRect131p7hyzlx7j8,
  Sprite as Sprite19oods84ct31j,
  Stage as Stage1ggtrzujnnkl0,
  Text as Text3kimhvgfxflj3,
  addFixedUpdater_0 as addFixedUpdaterkdt88bj87xku,
  addTo as addTo25e29vq105prw,
  addUpdater as addUpdater1la23qj9g2d42,
  anchor as anchor3c5itxst996yy,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  scale as scalea9fc0mbrr7ub,
  xy_0 as xy1gb51vhy014mx,
};
//endregion
